
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2bb7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2bb7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5N2AT", function(module, exports) {
"use strict";
var $43738a75d355cce5$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $43738a75d355cce5$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $43738a75d355cce5$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseManifest = module.exports.loadManifest = void 0;

$43738a75d355cce5$var$__exportStar((parcelRequire("bpdXW")), module.exports);

var $fFio0 = parcelRequire("fFio0");
/**
Initiates downloading an IIIF manifest json file from URL. Returns a Promise<any>
to allow subsequent processing on a successful fetch.

@param url  string containing the URL to Fetch
@returns Promise<any> The object returned through the Promise is the javascript object obtained by deserializing the json text.
**/ var $43738a75d355cce5$var$loadManifest = function(url) {
    return $fFio0.Utils.loadManifest(url);
};
module.exports.loadManifest = $43738a75d355cce5$var$loadManifest;
/**
Parses  IIIF manifest file to return a manifesto Manifest instance

@param manifest Either a string containing text of a manifest file or an javascript object obtained by deserializing by the JSON.parse function a manifest file.
@param options? TODO Not yet documented
@returns  instance of Manifest class.
**/ var $43738a75d355cce5$var$parseManifest = function(manifest, options) {
    return $fFio0.Utils.parseManifest(manifest, options);
};
module.exports.parseManifest = $43738a75d355cce5$var$parseManifest;

});
parcelRegister("bpdXW", function(module, exports) {
"use strict";
var $84dcdccef03e6108$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $84dcdccef03e6108$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $84dcdccef03e6108$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$84dcdccef03e6108$var$__exportStar((parcelRequire("1k7gL")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("bKm1x")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("h2BUe")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("k1ud9")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("cmmif")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("1oig9")), module.exports);

//export * from "./SpecificResourceForTarget";
//export * from "./SpecificResourceForBody";
$84dcdccef03e6108$var$__exportStar((parcelRequire("aaS4h")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("3Kky0")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("irqmu")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("dyYIu")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("Fwkqk")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("8WsTK")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("8Jhhz")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("8p5ST")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("8wL7U")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("5hZtU")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("dKTPk")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("Gt4Z0")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("1tewS")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("br9Gf")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("gNUMp")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("eTMqj")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("aiIi8")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("8elFM")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("hIWZm")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("hngIS")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("4UQGi")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("1SB3n")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("aWk7d")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("lUdGQ")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("53zBL")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("lGjrj")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("2oYJZ")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("jeD8Q")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("2JO3k")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("ky1YU")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("gT2AM")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("7Su5A")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("hHQud")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("aml4N")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("bKm1x")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("coue3")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("dGbbu")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("lAFUM")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("g5jkY")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("fFio0")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("coue3")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("5RMk3")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("eGPMK")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("3ib2J")), module.exports);

$84dcdccef03e6108$var$__exportStar((parcelRequire("hzQBg")), module.exports);

});
parcelRegister("1k7gL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.JSONLDResource = void 0;
var $0f6d4c4497a93a28$var$JSONLDResource = /** @class */ function() {
    function JSONLDResource(jsonld) {
        this.__jsonld = jsonld;
        this.context = this.getProperty("context");
        this.id = this.getProperty("id");
    }
    JSONLDResource.prototype.getProperty = function(name) {
        var prop = null;
        if (this.__jsonld) {
            prop = this.__jsonld[name];
            if (!prop) // property may have a prepended '@'
            prop = this.__jsonld["@" + name];
        }
        return prop;
    };
    /**
    A function that wraps the getProperty function, which client
    code can use if it is needed to identify when the json value of
    a property is an IRI -- Internationalized Resource Identifier
    
    If the value of the json value is a bare string, then it will be
    wrapped in a json object with the string in the property 'id',
    additionally that property will have a property 'isIRI' which will
    be true for the literal string case, otherwise false meaning the
    returned getProperty should be parsed as before.
    
    **/ JSONLDResource.prototype.getPropertyAsObject = function(name) {
        var prop = this.getProperty(name);
        if (typeof prop === 'string') return {
            "id": prop,
            "isIRI": true
        };
        else if (prop === Object(prop)) return prop;
        else return null;
    };
    return JSONLDResource;
}();
module.exports.JSONLDResource = $0f6d4c4497a93a28$var$JSONLDResource;

});

parcelRegister("bKm1x", function(module, exports) {
"use strict";
var $88d51312abb897fe$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Transform = void 0;

var $bpdXW = parcelRequire("bpdXW");
var $88d51312abb897fe$var$Transform = /** @class */ function(_super) {
    $88d51312abb897fe$var$__extends(Transform, _super);
    function Transform(jsonld) {
        var _this = _super.call(this, jsonld) || this;
        _this.isTransform = true;
        _this.isTransform = true;
        return _this;
    }
    return Transform;
}($bpdXW.JSONLDResource);
module.exports.Transform = $88d51312abb897fe$var$Transform;

});

parcelRegister("h2BUe", function(module, exports) {
"use strict";
var $c68006ea323f4d45$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ManifestResource = void 0;

var $bpdXW = parcelRequire("bpdXW");

var $loafo = parcelRequire("loafo");
var $c68006ea323f4d45$var$ManifestResource = /** @class */ function(_super) {
    $c68006ea323f4d45$var$__extends(ManifestResource, _super);
    function ManifestResource(jsonld, options) {
        var _this = _super.call(this, jsonld) || this;
        _this.options = options;
        return _this;
    }
    ManifestResource.prototype.getIIIFResourceType = function() {
        return $bpdXW.Utils.normaliseType(this.getProperty("type"));
    };
    /**
    * returns the PropertyValue which in turn allows a language-specific string
    * encoded in the json as the "label" property
    * @example
    * var label = manifest.getLabel().getValue(); // returns the string for default locale
    *
    * @example
    * var label = manifest.getLabel().getValue(locale); // locale a string , examples
    *                                                   // would be "fr", "en-US",
    **/ ManifestResource.prototype.getLabel = function() {
        var label = this.getProperty("label");
        if (label) return $bpdXW.PropertyValue.parse(label, this.options.locale);
        return new $bpdXW.PropertyValue([], this.options.locale);
    };
    ManifestResource.prototype.getSummary = function() {
        var summary = this.getProperty("summary");
        if (summary) return $bpdXW.PropertyValue.parse(summary, this.options.locale);
        return new $bpdXW.PropertyValue([], this.options.locale);
    };
    ManifestResource.prototype.getDefaultLabel = function() {
        return this.getLabel().getValue(this.options.locale);
    };
    ManifestResource.prototype.getMetadata = function() {
        var _metadata = this.getProperty("metadata");
        var metadata = [];
        if (!_metadata) return metadata;
        for(var i = 0; i < _metadata.length; i++){
            var item = _metadata[i];
            var metadataItem = new $bpdXW.LabelValuePair(this.options.locale);
            metadataItem.parse(item);
            metadata.push(metadataItem);
        }
        return metadata;
    };
    ManifestResource.prototype.getRendering = function(format) {
        var renderings = this.getRenderings();
        for(var i = 0; i < renderings.length; i++){
            var rendering = renderings[i];
            if (rendering.getFormat() === format) return rendering;
        }
        return null;
    };
    ManifestResource.prototype.getRenderings = function() {
        var rendering;
        // if passing a manifesto-parsed object, use the __jsonld.rendering property,
        // otherwise look for a rendering property
        if (this.__jsonld) rendering = this.__jsonld.rendering;
        else rendering = this.rendering;
        var renderings = [];
        if (!rendering) return renderings;
        // coerce to array
        if (!Array.isArray(rendering)) rendering = [
            rendering
        ];
        for(var i = 0; i < rendering.length; i++){
            var r = rendering[i];
            renderings.push(new $bpdXW.Rendering(r, this.options));
        }
        return renderings;
    };
    ManifestResource.prototype.getRequiredStatement = function() {
        var requiredStatement = null;
        var _requiredStatement = this.getProperty("requiredStatement");
        if (_requiredStatement) {
            requiredStatement = new $bpdXW.LabelValuePair(this.options.locale);
            requiredStatement.parse(_requiredStatement);
        }
        return requiredStatement;
    };
    ManifestResource.prototype.getService = function(profile) {
        return $bpdXW.Utils.getService(this, profile);
    };
    ManifestResource.prototype.getServices = function() {
        return $bpdXW.Utils.getServices(this);
    };
    ManifestResource.prototype.getThumbnail = function() {
        var thumbnail = this.getProperty("thumbnail");
        if (Array.isArray(thumbnail)) thumbnail = thumbnail[0];
        if (thumbnail) return new $bpdXW.Thumbnail(thumbnail, this.options);
        return null;
    };
    ManifestResource.prototype.isAnnotation = function() {
        return this.getIIIFResourceType() === $loafo.IIIFResourceType.ANNOTATION;
    };
    ManifestResource.prototype.isCanvas = function() {
        return this.getIIIFResourceType() === $loafo.IIIFResourceType.CANVAS;
    };
    ManifestResource.prototype.isCollection = function() {
        return this.getIIIFResourceType() === $loafo.IIIFResourceType.COLLECTION;
    };
    ManifestResource.prototype.isManifest = function() {
        return this.getIIIFResourceType() === $loafo.IIIFResourceType.MANIFEST;
    };
    ManifestResource.prototype.isRange = function() {
        return this.getIIIFResourceType() === $loafo.IIIFResourceType.RANGE;
    };
    // this different implementation is necessary until such time as the 
    // SCENE is added to the @iiif/vocabulary package.
    ManifestResource.prototype.isScene = function() {
        return this.getIIIFResourceType() === $bpdXW.Utils.normaliseType('Scene');
    };
    ManifestResource.prototype.isSequence = function() {
        return this.getIIIFResourceType() === $loafo.IIIFResourceType.SEQUENCE;
    };
    return ManifestResource;
}($bpdXW.JSONLDResource);
module.exports.ManifestResource = $c68006ea323f4d45$var$ManifestResource;

});
parcelRegister("loafo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ViewingHint = module.exports.ViewingDirection = module.exports.ServiceType = module.exports.ServiceProfile = module.exports.RenderingFormat = module.exports.MediaType = module.exports.IIIFResourceType = module.exports.ExternalResourceType = module.exports.Behavior = module.exports.AnnotationMotivation = void 0;
var $f923c9beaafc37f0$var$AnnotationMotivation;
(function(AnnotationMotivation) {
    AnnotationMotivation["BOOKMARKING"] = "oa:bookmarking";
    AnnotationMotivation["CLASSIFYING"] = "oa:classifying";
    AnnotationMotivation["COMMENTING"] = "oa:commenting";
    AnnotationMotivation["DESCRIBING"] = "oa:describing";
    AnnotationMotivation["EDITING"] = "oa:editing";
    AnnotationMotivation["HIGHLIGHTING"] = "oa:highlighting";
    AnnotationMotivation["IDENTIFYING"] = "oa:identifying";
    AnnotationMotivation["LINKING"] = "oa:linking";
    AnnotationMotivation["MODERATING"] = "oa:moderating";
    AnnotationMotivation["PAINTING"] = "sc:painting";
    AnnotationMotivation["QUESTIONING"] = "oa:questioning";
    AnnotationMotivation["REPLYING"] = "oa:replying";
    AnnotationMotivation["TAGGING"] = "oa:tagging";
    AnnotationMotivation["TRANSCRIBING"] = "oad:transcribing";
})($f923c9beaafc37f0$var$AnnotationMotivation || (module.exports.AnnotationMotivation = $f923c9beaafc37f0$var$AnnotationMotivation = {}));
var $f923c9beaafc37f0$var$Behavior;
(function(Behavior) {
    Behavior["AUTO_ADVANCE"] = "auto-advance";
    Behavior["CONTINUOUS"] = "continuous";
    Behavior["FACING_PAGES"] = "facing-pages";
    Behavior["HIDDEN"] = "hidden";
    Behavior["INDIVIDUALS"] = "individuals";
    Behavior["MULTI_PART"] = "multi-part";
    Behavior["NO_NAV"] = "no-nav";
    Behavior["NON_PAGED"] = "non-paged";
    Behavior["PAGED"] = "paged";
    Behavior["REPEAT"] = "repeat";
    Behavior["SEQUENCE"] = "sequence";
    Behavior["THUMBNAIL_NAV"] = "thumbnail-nav";
    Behavior["TOGETHER"] = "together";
    Behavior["UNORDERED"] = "unordered";
})($f923c9beaafc37f0$var$Behavior || (module.exports.Behavior = $f923c9beaafc37f0$var$Behavior = {}));
var $f923c9beaafc37f0$var$ExternalResourceType;
(function(ExternalResourceType) {
    ExternalResourceType["CANVAS"] = "canvas";
    ExternalResourceType["CHOICE"] = "choice";
    ExternalResourceType["OA_CHOICE"] = "oa:choice";
    ExternalResourceType["CONTENT_AS_TEXT"] = "contentastext";
    ExternalResourceType["DATASET"] = "dataset";
    ExternalResourceType["DOCUMENT"] = "document";
    ExternalResourceType["IMAGE"] = "image";
    ExternalResourceType["MODEL"] = "model";
    ExternalResourceType["MOVING_IMAGE"] = "movingimage";
    ExternalResourceType["PDF"] = "pdf";
    ExternalResourceType["PHYSICAL_OBJECT"] = "physicalobject";
    ExternalResourceType["SOUND"] = "sound";
    ExternalResourceType["TEXT"] = "text";
    ExternalResourceType["TEXTUALBODY"] = "textualbody";
    ExternalResourceType["VIDEO"] = "video";
})($f923c9beaafc37f0$var$ExternalResourceType || (module.exports.ExternalResourceType = $f923c9beaafc37f0$var$ExternalResourceType = {}));
var $f923c9beaafc37f0$var$IIIFResourceType;
(function(IIIFResourceType) {
    IIIFResourceType["ANNOTATION"] = "annotation";
    IIIFResourceType["ANNOTATION_COLLECTION"] = "annotationcollection";
    IIIFResourceType["ANNOTATION_PAGE"] = "annotationpage";
    IIIFResourceType["CANVAS"] = "canvas";
    IIIFResourceType["COLLECTION"] = "collection";
    IIIFResourceType["MANIFEST"] = "manifest";
    IIIFResourceType["RANGE"] = "range";
    IIIFResourceType["SEQUENCE"] = "sequence";
})($f923c9beaafc37f0$var$IIIFResourceType || (module.exports.IIIFResourceType = $f923c9beaafc37f0$var$IIIFResourceType = {}));
var $f923c9beaafc37f0$var$MediaType;
(function(MediaType) {
    MediaType["APNG"] = "image/apng";
    MediaType["AUDIO_MP4"] = "audio/mp4";
    MediaType["AUDIO_OGG"] = "audio/ogg";
    MediaType["AVIF"] = "audio/avif";
    MediaType["CORTO"] = "application/corto";
    MediaType["DICOM"] = "application/dicom";
    MediaType["DRACO"] = "application/draco";
    MediaType["EPUB"] = "application/epub+zip";
    MediaType["GIF"] = "image/gif";
    MediaType["GIRDER"] = "image/vnd.kitware.girder";
    MediaType["GLB"] = "model/gltf-binary";
    MediaType["GLTF"] = "model/gltf+json";
    MediaType["IIIF_PRESENTATION_2"] = "application/ld+json;profile=\"http://iiif.io/api/presentation/2/context.json\"";
    MediaType["IIIF_PRESENTATION_3"] = "application/ld+json;profile=\"http://iiif.io/api/presentation/3/context.json\"";
    MediaType["JPG"] = "image/jpeg";
    MediaType["M3U8"] = "application/vnd.apple.mpegurl";
    MediaType["MP3"] = "audio/mp3";
    MediaType["MPEG"] = "audio/mpeg";
    MediaType["MPEG_DASH"] = "application/dash+xml";
    MediaType["OBJ"] = "model/obj";
    MediaType["OPF"] = "application/oebps-package+xml";
    MediaType["PDF"] = "application/pdf";
    MediaType["PLY"] = "application/ply";
    MediaType["PNG"] = "image/png";
    MediaType["SVG"] = "image/svg+xml";
    MediaType["THREEJS"] = "application/vnd.threejs+json";
    MediaType["USDZ"] = "model/vnd.usd+zip";
    MediaType["VIDEO_MP4"] = "video/mp4";
    MediaType["VIDEO_OGG"] = "video/ogg";
    MediaType["WAV"] = "audio/wav";
    MediaType["WEBM"] = "video/webm";
    MediaType["WEBP"] = "image/webp";
})($f923c9beaafc37f0$var$MediaType || (module.exports.MediaType = $f923c9beaafc37f0$var$MediaType = {}));
var $f923c9beaafc37f0$var$RenderingFormat;
(function(RenderingFormat) {
    RenderingFormat["DOC"] = "application/msword";
    RenderingFormat["DOCX"] = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    RenderingFormat["ODT"] = "application/vnd.oasis.opendocument.text";
    RenderingFormat["PDF"] = "application/pdf";
})($f923c9beaafc37f0$var$RenderingFormat || (module.exports.RenderingFormat = $f923c9beaafc37f0$var$RenderingFormat = {}));
var $f923c9beaafc37f0$var$ServiceProfile;
(function(ServiceProfile) {
    // image api
    ServiceProfile["IMAGE_0_COMPLIANCE_LEVEL_0"] = "http://library.stanford.edu/iiif/image-api/compliance.html#level0";
    ServiceProfile["IMAGE_0_COMPLIANCE_LEVEL_1"] = "http://library.stanford.edu/iiif/image-api/compliance.html#level1";
    ServiceProfile["IMAGE_0_COMPLIANCE_LEVEL_2"] = "http://library.stanford.edu/iiif/image-api/compliance.html#level2";
    ServiceProfile["IMAGE_0_CONFORMANCE_LEVEL_0"] = "http://library.stanford.edu/iiif/image-api/conformance.html#level0";
    ServiceProfile["IMAGE_0_CONFORMANCE_LEVEL_1"] = "http://library.stanford.edu/iiif/image-api/conformance.html#level1";
    ServiceProfile["IMAGE_0_CONFORMANCE_LEVEL_2"] = "http://library.stanford.edu/iiif/image-api/conformance.html#level2";
    ServiceProfile["IMAGE_1_COMPLIANCE_LEVEL_0"] = "http://library.stanford.edu/iiif/image-api/1.1/compliance.html#level0";
    ServiceProfile["IMAGE_1_COMPLIANCE_LEVEL_1"] = "http://library.stanford.edu/iiif/image-api/1.1/compliance.html#level1";
    ServiceProfile["IMAGE_1_COMPLIANCE_LEVEL_2"] = "http://library.stanford.edu/iiif/image-api/1.1/compliance.html#level2";
    ServiceProfile["IMAGE_1_CONFORMANCE_LEVEL_0"] = "http://library.stanford.edu/iiif/image-api/1.1/conformance.html#level0";
    ServiceProfile["IMAGE_1_CONFORMANCE_LEVEL_1"] = "http://library.stanford.edu/iiif/image-api/1.1/conformance.html#level1";
    ServiceProfile["IMAGE_1_CONFORMANCE_LEVEL_2"] = "http://library.stanford.edu/iiif/image-api/1.1/conformance.html#level2";
    ServiceProfile["IMAGE_1_LEVEL_0"] = "http://iiif.io/api/image/1/level0.json";
    ServiceProfile["IMAGE_1_PROFILE_LEVEL_0"] = "http://iiif.io/api/image/1/profiles/level0.json";
    ServiceProfile["IMAGE_1_LEVEL_1"] = "http://iiif.io/api/image/1/level1.json";
    ServiceProfile["IMAGE_1_PROFILE_LEVEL_1"] = "http://iiif.io/api/image/1/profiles/level1.json";
    ServiceProfile["IMAGE_1_LEVEL_2"] = "http://iiif.io/api/image/1/level2.json";
    ServiceProfile["IMAGE_1_PROFILE_LEVEL_2"] = "http://iiif.io/api/image/1/profiles/level2.json";
    ServiceProfile["IMAGE_2_LEVEL_0"] = "http://iiif.io/api/image/2/level0.json";
    ServiceProfile["IMAGE_2_PROFILE_LEVEL_0"] = "http://iiif.io/api/image/2/profiles/level0.json";
    ServiceProfile["IMAGE_2_LEVEL_1"] = "http://iiif.io/api/image/2/level1.json";
    ServiceProfile["IMAGE_2_PROFILE_LEVEL_1"] = "http://iiif.io/api/image/2/profiles/level1.json";
    ServiceProfile["IMAGE_2_LEVEL_2"] = "http://iiif.io/api/image/2/level2.json";
    ServiceProfile["IMAGE_2_PROFILE_LEVEL_2"] = "http://iiif.io/api/image/2/profiles/level2.json";
    // auth api
    ServiceProfile["AUTH_0_CLICK_THROUGH"] = "http://iiif.io/api/auth/0/login/clickthrough";
    ServiceProfile["AUTH_0_LOGIN"] = "http://iiif.io/api/auth/0/login";
    ServiceProfile["AUTH_0_LOGOUT"] = "http://iiif.io/api/auth/0/logout";
    ServiceProfile["AUTH_0_RESTRICTED"] = "http://iiif.io/api/auth/0/login/restricted";
    ServiceProfile["AUTH_0_TOKEN"] = "http://iiif.io/api/auth/0/token";
    ServiceProfile["AUTH_1_CLICK_THROUGH"] = "http://iiif.io/api/auth/1/clickthrough";
    ServiceProfile["AUTH_1_EXTERNAL"] = "http://iiif.io/api/auth/1/external";
    ServiceProfile["AUTH_1_KIOSK"] = "http://iiif.io/api/auth/1/kiosk";
    ServiceProfile["AUTH_1_LOGIN"] = "http://iiif.io/api/auth/1/login";
    ServiceProfile["AUTH_1_LOGOUT"] = "http://iiif.io/api/auth/1/logout";
    ServiceProfile["AUTH_1_PROBE"] = "http://iiif.io/api/auth/1/probe";
    ServiceProfile["AUTH_1_TOKEN"] = "http://iiif.io/api/auth/1/token";
    // search api
    ServiceProfile["SEARCH_0"] = "http://iiif.io/api/search/0/search";
    ServiceProfile["SEARCH_0_AUTO_COMPLETE"] = "http://iiif.io/api/search/0/autocomplete";
    ServiceProfile["SEARCH_1"] = "http://iiif.io/api/search/1/search";
    ServiceProfile["SEARCH_1_AUTO_COMPLETE"] = "http://iiif.io/api/search/1/autocomplete";
    ServiceProfile["SEARCH_2"] = "http://iiif.io/api/search/2/search";
    ServiceProfile["SEARCH_2_AUTO_COMPLETE"] = "http://iiif.io/api/search/2/autocomplete";
    // extensions
    ServiceProfile["TRACKING_EXTENSIONS"] = "http://universalviewer.io/tracking-extensions-profile";
    ServiceProfile["UI_EXTENSIONS"] = "http://universalviewer.io/ui-extensions-profile";
    ServiceProfile["PRINT_EXTENSIONS"] = "http://universalviewer.io/print-extensions-profile";
    ServiceProfile["SHARE_EXTENSIONS"] = "http://universalviewer.io/share-extensions-profile";
    ServiceProfile["DOWNLOAD_EXTENSIONS"] = "http://universalviewer.io/download-extensions-profile";
    // other
    ServiceProfile["OTHER_MANIFESTATIONS"] = "http://iiif.io/api/otherManifestations.json";
    ServiceProfile["IXIF"] = "http://wellcomelibrary.org/ld/ixif/0/alpha.json";
})($f923c9beaafc37f0$var$ServiceProfile || (module.exports.ServiceProfile = $f923c9beaafc37f0$var$ServiceProfile = {}));
var $f923c9beaafc37f0$var$ServiceType;
(function(ServiceType) {
    ServiceType["IMAGE_SERVICE_2"] = "ImageService2";
    ServiceType["IMAGE_SERVICE_3"] = "ImageService3";
    ServiceType["SEARCH_SERVICE_2"] = "SearchService2";
    ServiceType["AUTO_COMPLETE_SERVICE_2"] = "AutoCompleteService2";
})($f923c9beaafc37f0$var$ServiceType || (module.exports.ServiceType = $f923c9beaafc37f0$var$ServiceType = {}));
var $f923c9beaafc37f0$var$ViewingDirection;
(function(ViewingDirection) {
    ViewingDirection["BOTTOM_TO_TOP"] = "bottom-to-top";
    ViewingDirection["LEFT_TO_RIGHT"] = "left-to-right";
    ViewingDirection["RIGHT_TO_LEFT"] = "right-to-left";
    ViewingDirection["TOP_TO_BOTTOM"] = "top-to-bottom";
})($f923c9beaafc37f0$var$ViewingDirection || (module.exports.ViewingDirection = $f923c9beaafc37f0$var$ViewingDirection = {}));
var $f923c9beaafc37f0$var$ViewingHint;
(function(ViewingHint) {
    ViewingHint["CONTINUOUS"] = "continuous";
    ViewingHint["INDIVIDUALS"] = "individuals";
    ViewingHint["NON_PAGED"] = "non-paged";
    ViewingHint["PAGED"] = "paged";
    ViewingHint["TOP"] = "top";
})($f923c9beaafc37f0$var$ViewingHint || (module.exports.ViewingHint = $f923c9beaafc37f0$var$ViewingHint = {}));

});


parcelRegister("k1ud9", function(module, exports) {
"use strict";
var $e93b55f5c8838375$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Resource = void 0;

var $bpdXW = parcelRequire("bpdXW");
var $e93b55f5c8838375$var$Resource = /** @class */ function(_super) {
    $e93b55f5c8838375$var$__extends(Resource, _super);
    function Resource(jsonld, options) {
        return _super.call(this, jsonld, options) || this;
    }
    Resource.prototype.getFormat = function() {
        var format = this.getProperty("format");
        if (format) return format.toLowerCase();
        return null;
    };
    Resource.prototype.getResources = function() {
        var resources = [];
        if (!this.__jsonld.resources) return resources;
        for(var i = 0; i < this.__jsonld.resources.length; i++){
            var a = this.__jsonld.resources[i];
            var annotation = new $bpdXW.Annotation(a, this.options);
            resources.push(annotation);
        }
        return resources;
    };
    Resource.prototype.getType = function() {
        var type = this.getProperty("type");
        if (type) return $bpdXW.Utils.normaliseType(type);
        return null;
    };
    Resource.prototype.getWidth = function() {
        return this.getProperty("width");
    };
    Resource.prototype.getHeight = function() {
        return this.getProperty("height");
    };
    Resource.prototype.getMaxWidth = function() {
        return this.getProperty("maxWidth");
    };
    Resource.prototype.getMaxHeight = function() {
        var maxHeight = this.getProperty("maxHeight");
        // if a maxHeight hasn't been specified, default to maxWidth.
        // maxWidth in essence becomes maxEdge
        if (!maxHeight) return this.getMaxWidth();
        return null;
    };
    return Resource;
}($bpdXW.ManifestResource);
module.exports.Resource = $e93b55f5c8838375$var$Resource;

});

parcelRegister("cmmif", function(module, exports) {
"use strict";
var $0252770cce5cc701$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IIIFResource = void 0;

var $bpdXW = parcelRequire("bpdXW");

var $loafo = parcelRequire("loafo");
var $0252770cce5cc701$var$IIIFResource = /** @class */ function(_super) {
    $0252770cce5cc701$var$__extends(IIIFResource, _super);
    function IIIFResource(jsonld, options) {
        var _this = _super.call(this, jsonld, options) || this;
        _this.index = -1;
        _this.isLoaded = false;
        var defaultOptions = {
            defaultLabel: "-",
            locale: "en-GB",
            resource: _this,
            pessimisticAccessControl: false
        };
        _this.options = Object.assign(defaultOptions, options);
        return _this;
    }
    /**
     * @deprecated
     */ IIIFResource.prototype.getAttribution = function() {
        //console.warn('getAttribution will be deprecated, use getRequiredStatement instead.');
        var attribution = this.getProperty("attribution");
        if (attribution) return $bpdXW.PropertyValue.parse(attribution, this.options.locale);
        return new $bpdXW.PropertyValue([], this.options.locale);
    };
    IIIFResource.prototype.getDescription = function() {
        var description = this.getProperty("description");
        if (description) return $bpdXW.PropertyValue.parse(description, this.options.locale);
        return new $bpdXW.PropertyValue([], this.options.locale);
    };
    IIIFResource.prototype.getHomepage = function() {
        var homepage = this.getProperty("homepage");
        if (!homepage) return null;
        if (typeof homepage == "string") return homepage;
        if (Array.isArray(homepage) && homepage.length) homepage = homepage[0];
        return homepage["@id"] || homepage.id;
    };
    IIIFResource.prototype.getIIIFResourceType = function() {
        return $bpdXW.Utils.normaliseType(this.getProperty("type"));
    };
    IIIFResource.prototype.getLogo = function() {
        var logo = this.getProperty("logo");
        // Presentation 3.
        // The logo is exclusive to the "provider" property, which is of type "Agent".
        // In order to fulfil `manifest.getLogo()` we should check
        // When P3 is fully supported, the following should work.
        // return this.getProvider()?.getLogo();
        if (!logo) {
            var provider = this.getProperty("provider");
            if (!provider) return null;
            logo = provider.logo;
        }
        if (!logo) return null;
        if (typeof logo === "string") return logo;
        if (Array.isArray(logo) && logo.length) logo = logo[0];
        return logo["@id"] || logo.id;
    };
    IIIFResource.prototype.getLicense = function() {
        return $bpdXW.Utils.getLocalisedValue(this.getProperty("license"), this.options.locale);
    };
    IIIFResource.prototype.getRights = function() {
        var rights = this.getProperty("rights");
        if (!rights) return null;
        if (typeof rights === "string") return rights;
        if (Array.isArray(rights) && rights.length) rights = rights[0];
        return rights["@id"] || rights.id;
    };
    IIIFResource.prototype.getNavDate = function() {
        return new Date(this.getProperty("navDate"));
    };
    IIIFResource.prototype.getRelated = function() {
        return this.getProperty("related");
    };
    IIIFResource.prototype.getSeeAlso = function() {
        return this.getProperty("seeAlso");
    };
    IIIFResource.prototype.getTrackingLabel = function() {
        var service = this.getService($loafo.ServiceProfile.TRACKING_EXTENSIONS);
        if (service) return service.getProperty("trackingLabel");
        return "";
    };
    IIIFResource.prototype.getDefaultTree = function() {
        this.defaultTree = new $bpdXW.TreeNode("root");
        this.defaultTree.data = this;
        return this.defaultTree;
    };
    IIIFResource.prototype.getRequiredStatement = function() {
        var requiredStatement = null;
        var _requiredStatement = this.getProperty("requiredStatement");
        if (_requiredStatement) {
            requiredStatement = new $bpdXW.LabelValuePair(this.options.locale);
            requiredStatement.parse(_requiredStatement);
        } else {
            // fall back to attribution (if it exists)
            var attribution = this.getAttribution();
            if (attribution) {
                requiredStatement = new $bpdXW.LabelValuePair(this.options.locale);
                requiredStatement.value = attribution;
            }
        }
        return requiredStatement;
    };
    IIIFResource.prototype.isCollection = function() {
        if (this.getIIIFResourceType() === $loafo.IIIFResourceType.COLLECTION) return true;
        return false;
    };
    IIIFResource.prototype.isManifest = function() {
        if (this.getIIIFResourceType() === $loafo.IIIFResourceType.MANIFEST) return true;
        return false;
    };
    IIIFResource.prototype.load = function() {
        var that = this;
        return new Promise(function(resolve) {
            if (that.isLoaded) resolve(that);
            else {
                var options_1 = that.options;
                options_1.navDate = that.getNavDate();
                var id = that.__jsonld.id;
                if (!id) id = that.__jsonld["@id"];
                $bpdXW.Utils.loadManifest(id).then(function(data) {
                    that.parentLabel = that.getLabel().getValue(options_1.locale);
                    var parsed = $bpdXW.Deserialiser.parse(data, options_1);
                    that = Object.assign(that, parsed);
                    //that.parentCollection = options.resource.parentCollection;
                    that.index = options_1.index;
                    resolve(that);
                });
            }
        });
    };
    return IIIFResource;
}($bpdXW.ManifestResource);
module.exports.IIIFResource = $0252770cce5cc701$var$IIIFResource;

});

parcelRegister("1oig9", function(module, exports) {
"use strict";
var $1036324bd6dd2e00$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpecificResource = void 0;

var $bpdXW = parcelRequire("bpdXW");
/**
    Developer note: This implementation does not strictly adhere
    to the description of SpecificResource in the Web Annotation Model
    document https://www.w3.org/TR/annotation-model/
    section 4 : https://www.w3.org/TR/annotation-model/#specific-resources
    
    The getTransform() method returning an Array of 3D Transfom resources, is
    an extension of SpecificResource beyond the web annotation model.
*/ var $1036324bd6dd2e00$var$SpecificResource = /** @class */ function(_super) {
    $1036324bd6dd2e00$var$__extends(SpecificResource, _super);
    function SpecificResource(jsonld, options) {
        var _this = _super.call(this, jsonld, options) || this;
        /*
        property distinguishing instances of SpecificResource from instances of AnnotionBody.
        The return type of the Annotation.getBody() method is an array of instances of the
        union type ( AnnotationBody | SpecificResource )
        */ _this.isAnnotationBody = false;
        /*
        property distinguishing instances of SpecificResource from instances of AnnotionBody.
        The return type of the Annotation.getBody() method is an array of instances of the
        union type ( AnnotationBody | SpecificResource )
        */ _this.isSpecificResource = true;
        _this.isSpecificResource = true;
        return _this;
    }
    SpecificResource.prototype.getSource = function() {
        var raw = this.getPropertyAsObject("source");
        if (raw.isIRI) return raw;
        /*
            this logic gets a little convoluted, because we have to preserve
            the cases where the raw json is an array for the sources of a
            SpecificResource applied to an annotation body, while for a target
            of an Annotation we just want a single object
        */ // case of a source of a SpecificResource which is an Annotation target
        if (raw) {
            var containerTypes = [
                "Scene",
                "Canvas"
            ];
            var singleItem = [].concat(raw)[0];
            if (containerTypes.includes(singleItem["type"])) return singleItem;
        }
        if (raw) {
            var item = [].concat(raw)[0];
            if (item) return $bpdXW.AnnotationBodyParser.BuildFromJson(item, this.options);
        }
        throw new Error("cannot resolve Source " + JSON.stringify(raw));
    };
    Object.defineProperty(SpecificResource.prototype, "Source", {
        get: function() {
            return this.getSource();
        },
        enumerable: false,
        configurable: true
    });
    SpecificResource.prototype.getSelector = function() {
        var raw = this.getProperty("selector");
        if (raw) {
            var item = [].concat(raw)[0];
            if (item) {
                if (item["type"] === "PointSelector") return new $bpdXW.PointSelector(item);
            }
            throw new Error("unable to resolve SpecificResource selector " + JSON.stringify(this.__jsonld));
        }
        return null;
    };
    Object.defineProperty(SpecificResource.prototype, "Selector", {
        get: function() {
            return this.getSelector();
        },
        enumerable: false,
        configurable: true
    });
    SpecificResource.prototype.getTransform = function() {
        var retVal = [];
        var transformItems = this.getProperty("transform");
        for(var i = 0; i < transformItems.length; ++i){
            var transformItem = transformItems[i];
            retVal.push($bpdXW.TransformParser.BuildFromJson(transformItem));
        }
        return retVal;
    };
    Object.defineProperty(SpecificResource.prototype, "Transform", {
        get: function() {
            return this.getTransform();
        },
        enumerable: false,
        configurable: true
    });
    return SpecificResource;
}($bpdXW.ManifestResource);
module.exports.SpecificResource = $1036324bd6dd2e00$var$SpecificResource;

});

parcelRegister("aaS4h", function(module, exports) {
"use strict";
var $01e95e0dcd78dfef$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AnnotationBody = void 0;

var $loafo = parcelRequire("loafo");

var $bpdXW = parcelRequire("bpdXW");
/**
With the 3D extensions to the IIIF Presentation API the name of this
class is misleading, but for now is being retained for the sake backward
compatibility with earlier manifesto code and tests.

The 3D extensions allow that the body property of an annotation can be
a light, camera, or model, or a SpecificResource object wrapping a light, camera,
or model.
**/ var $01e95e0dcd78dfef$var$AnnotationBody = /** @class */ function(_super) {
    $01e95e0dcd78dfef$var$__extends(AnnotationBody, _super);
    function AnnotationBody(jsonld, options) {
        return _super.call(this, jsonld, options) || this;
    }
    // Get resource URI ID from either body (for content resource) or source (for specific resource)
    AnnotationBody.prototype.getResourceID = function() {
        if (this.isSpecificResource()) {
            var source = this.getSource();
            if (source instanceof AnnotationBody) return source.id;
            else return source || this.id;
        } else return this.id;
    };
    // Format, Type, Width, and Height are the body properties supported
    // in the code that supports Presentation 3
    AnnotationBody.prototype.getFormat = function() {
        var format = this.getPropertyFromSelfOrSource("format");
        if (format) return $bpdXW.Utils.getMediaType(format);
        return null;
    };
    AnnotationBody.prototype.getType = function() {
        var type = this.getPropertyFromSelfOrSource("type");
        if (type) return $bpdXW.Utils.normaliseType(type);
        return null;
    };
    AnnotationBody.prototype.getWidth = function() {
        return this.getProperty("width");
    };
    AnnotationBody.prototype.getHeight = function() {
        return this.getProperty("height");
    };
    AnnotationBody.prototype.getTransform = function() {
        return this.getProperty("transform").map(function(transform) {
            return $bpdXW.TransformParser.BuildFromJson(transform);
        });
    };
    // Some properties may be on this object or (for SpecificResource) in source object
    AnnotationBody.prototype.getPropertyFromSelfOrSource = function(prop) {
        if (this.isSpecificResource() && this.getSource() instanceof AnnotationBody) return this.getSource().getProperty(prop);
        else return this.getProperty(prop);
    };
    // Get the first source available on the annotation body, if any
    AnnotationBody.prototype.getSource = function() {
        var source = [].concat(this.getPropertyAsObject("source"))[0];
        if (source) {
            if (source["isIRI"] === true) return source["id"];
            else return $bpdXW.AnnotationBodyParser.BuildFromJson(source, this.options);
        }
        return null;
    };
    AnnotationBody.prototype.isModel = function() {
        return this.getType() === $loafo.ExternalResourceType.MODEL;
    };
    AnnotationBody.prototype.isSpecificResource = function() {
        return this.getProperty("type") === "SpecificResource";
    };
    return AnnotationBody;
}($bpdXW.ManifestResource);
module.exports.AnnotationBody = $01e95e0dcd78dfef$var$AnnotationBody;

});

parcelRegister("3Kky0", function(module, exports) {
"use strict";
var $2ba59b4d33d3da45$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Light = void 0;

var $bpdXW = parcelRequire("bpdXW");
var $2ba59b4d33d3da45$var$Light = /** @class */ function(_super) {
    $2ba59b4d33d3da45$var$__extends(Light, _super);
    function Light(jsonld, options) {
        return _super.call(this, jsonld, options) || this;
    }
    Light.prototype.getColor = function() {
        var hexColor = this.getProperty("color");
        if (hexColor) return $bpdXW.Color.fromCSS(hexColor);
        else return new $bpdXW.Color([
            255,
            255,
            255
        ]); // white light
    };
    Object.defineProperty(Light.prototype, "Color", {
        get: function() {
            return this.getColor();
        },
        enumerable: false,
        configurable: true
    });
    /**
    * The implementation of the intensity is based on
    * {@link https://github.com/IIIF/3d/blob/main/temp-draft-4.md | temp-draft-4.md }
    * and the example 3D manifests
    * {@link https://github.com/IIIF/3d/tree/main/manifests/3_lights | lights }
    * on 24 Mar 2024. The intensity property in the manifest is an object
    * with declared type 'Value', a numeric property named 'value' and a
    * property named unit . This implementation will only work with a unit == 'relative'
    * and it will be assumed that a relative unit value of 1.0 corresponds to the
    * brightest light source a rendering engine supports.
    *
    * This code will implement a default intensity of 1.0
    **/ Light.prototype.getIntensity = function() {
        var intObject = this.getProperty("intensity");
        if (intObject) try {
            if (!(intObject.type === "Value" && intObject.unit === "relative")) throw new Error();
            return intObject.value;
        } catch (err) {
            throw new Error("unable to interpret raw intensity object " + JSON.stringify(intObject));
        }
        else return 1.0;
    };
    Object.defineProperty(Light.prototype, "Intensity", {
        get: function() {
            return this.getIntensity();
        },
        enumerable: false,
        configurable: true
    });
    /**
    * As defined in the temp-draft-4.md (
    * https://github.com/IIIF/3d/blob/main/temp-draft-4.md#lights ; 12 May 2024)
    * this quantity is the half-angle of the cone of the spotlight.
    *
    * The inconsistency between this definition of the angle and the definition of
    * fieldOfView for PerspectiveCamera (where the property value defines the full angle) has
    * already been noted: https://github.com/IIIF/api/issues/2284
    *
    * provisional decision is to return undefined in case that this property
    * is accessed in a light that is not a spotlight
    *
    *
    * @returns number
    
    **/ Light.prototype.getAngle = function() {
        if (this.isSpotLight()) return Number(this.getProperty("angle"));
        else return undefined;
    };
    Object.defineProperty(Light.prototype, "Angle", {
        get: function() {
            return this.getAngle();
        },
        enumerable: false,
        configurable: true
    });
    /**
    * @return : if not null, is either a PointSelector, or an object
    * with an id matching the id of an Annotation instance.
    **/ Light.prototype.getLookAt = function() {
        var rawObj = this.getPropertyAsObject("lookAt");
        var rawType = rawObj["type"] || rawObj["@type"];
        if (rawType == "Annotation") return rawObj;
        if (rawType == "PointSelector") return new $bpdXW.PointSelector(rawObj);
        throw new Error('unidentified value of lookAt ${rawType}');
    };
    Object.defineProperty(Light.prototype, "LookAt", {
        get: function() {
            return this.getLookAt();
        },
        enumerable: false,
        configurable: true
    });
    Light.prototype.isAmbientLight = function() {
        return $bpdXW.Utils.normaliseType(this.getType() || "") === "ambientlight";
    };
    Light.prototype.isDirectionalLight = function() {
        return $bpdXW.Utils.normaliseType(this.getType() || "") === "directionallight";
    };
    Light.prototype.isPointLight = function() {
        return $bpdXW.Utils.normaliseType(this.getType() || "") === "pointlight";
    };
    Light.prototype.isSpotLight = function() {
        return $bpdXW.Utils.normaliseType(this.getType() || "") === "spotlight";
    };
    return Light;
}($bpdXW.AnnotationBody);
module.exports.Light = $2ba59b4d33d3da45$var$Light;

});

parcelRegister("irqmu", function(module, exports) {
"use strict";
var $d6cf327ade5ff59f$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Camera = void 0;

var $bpdXW = parcelRequire("bpdXW");
var $d6cf327ade5ff59f$var$Camera = /** @class */ function(_super) {
    $d6cf327ade5ff59f$var$__extends(Camera, _super);
    function Camera(jsonld, options) {
        return _super.call(this, jsonld, options) || this;
    }
    /**
    @returns full angular size of perspective viewport in vertical direction.
    Angular unit is degrees
    **/ Camera.prototype.getFieldOfView = function() {
        if (this.isPerspectiveCamera()) {
            var value = this.getProperty("fieldOfView");
            if (value) return value;
            else return 45.0;
        } else return undefined;
    };
    Object.defineProperty(Camera.prototype, "FieldOfView", {
        /**
        Full angular size of perspective viewport in vertical direction.
        Angular unit is degrees
        **/ get: function() {
            return this.getFieldOfView();
        },
        enumerable: false,
        configurable: true
    });
    /**
    @returns full linear size of orthographic viewport in vertical direction.
    linear unit is Scene global unit of measure
    
    Name of this property was originally Height, has been changed
    at this revision to ViewHeight:
    See issues at https://github.com/IIIF/api/issues/2289
    **/ Camera.prototype.getViewHeight = function() {
        if (this.isOrthographicCamera()) {
            // the term viewHeight for the resource Type was suggested
            // in https://github.com/IIIF/api/issues/2289#issuecomment-2161608587
            var value = this.getProperty("viewHeight");
            if (value) return value;
            else return undefined;
        } else return undefined;
    };
    Object.defineProperty(Camera.prototype, "ViewHeight", {
        get: function() {
            return this.getViewHeight();
        },
        enumerable: false,
        configurable: true
    });
    /**
    * @return : if not null, is either a PointSelector, or an object
    * with an id matching the id of an Annotation instance.
    **/ Camera.prototype.getLookAt = function() {
        var _a, _b;
        var rawObj = (_a = this.getPropertyAsObject("lookAt")) !== null && _a !== void 0 ? _a : null;
        if (rawObj == null) return null;
        var rawType = (_b = rawObj["type"] || rawObj["@type"]) !== null && _b !== void 0 ? _b : null;
        if (rawType == null) return null;
        if (rawType == "Annotation") return rawObj;
        else if (rawType == "PointSelector") return new $bpdXW.PointSelector(rawObj);
        else {
            console.error('unidentified value of lookAt ${rawType}');
            return null;
        }
    };
    Object.defineProperty(Camera.prototype, "LookAt", {
        get: function() {
            return this.getLookAt();
        },
        enumerable: false,
        configurable: true
    });
    // TODO implement near and far properties
    Camera.prototype.isPerspectiveCamera = function() {
        return $bpdXW.Utils.normaliseType(this.getType() || "") === "perspectivecamera";
    };
    Camera.prototype.isOrthographicCamera = function() {
        return $bpdXW.Utils.normaliseType(this.getType() || "") === "orthographiccamera";
    };
    return Camera;
}($bpdXW.AnnotationBody);
module.exports.Camera = $d6cf327ade5ff59f$var$Camera;

});

parcelRegister("dyYIu", function(module, exports) {
"use strict";
var $9dfd8c625f1d4bf2$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TextualBody = void 0;

var $bpdXW = parcelRequire("bpdXW");
/**
An implementation of the TextualBody class (class in JSON-LD sense)
as it is described in Web Annotation Data Model Section 3.2.4
https://www.w3.org/TR/annotation-model/#embedded-textual-body
**/ var $9dfd8c625f1d4bf2$var$TextualBody = /** @class */ function(_super) {
    $9dfd8c625f1d4bf2$var$__extends(TextualBody, _super);
    function TextualBody(jsonld, options) {
        return _super.call(this, jsonld, options) || this;
    }
    Object.defineProperty(TextualBody.prototype, "Value", {
        /**
        The simple string that is the data content of this resource
        will return empty string as a default value
        **/ get: function() {
            return this.getProperty("value") || "";
        },
        enumerable: false,
        configurable: true
    });
    return TextualBody;
}($bpdXW.AnnotationBody);
module.exports.TextualBody = $9dfd8c625f1d4bf2$var$TextualBody;

});

parcelRegister("Fwkqk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AnnotationBodyParser = void 0;

var $bpdXW = parcelRequire("bpdXW");
// Todo: Add these to @iiif/vocabulary
var $07cce8330220b3db$var$LightTypes = [
    "AmbientLight",
    "DirectionalLight",
    "PointLight",
    "SpotLight"
];
var $07cce8330220b3db$var$CameraTypes = [
    "PerspectiveCamera",
    "OrthographicCamera"
];
var $07cce8330220b3db$var$DisplayedTypes = [
    "Image",
    "Document",
    "Audio",
    "Model",
    "Video"
];
var $07cce8330220b3db$var$AnnotationBodyParser = /** @class */ function() {
    function AnnotationBodyParser() {}
    AnnotationBodyParser.BuildFromJson = function(jsonld, options) {
        var type = jsonld.type === "SpecificResource" && jsonld.source ? [].concat(jsonld.source)[0]["type"] : jsonld.type;
        if ($07cce8330220b3db$var$DisplayedTypes.includes(type)) return new $bpdXW.AnnotationBody(jsonld, options);
        else if ($07cce8330220b3db$var$LightTypes.includes(type)) return new $bpdXW.Light(jsonld, options);
        else if ($07cce8330220b3db$var$CameraTypes.includes(type)) return new $bpdXW.Camera(jsonld, options);
        else throw new Error("unimplemented type for AnnotationBody: " + type);
    };
    return AnnotationBodyParser;
}();
module.exports.AnnotationBodyParser = $07cce8330220b3db$var$AnnotationBodyParser;

});

parcelRegister("8WsTK", function(module, exports) {
"use strict";
var $682a281a2f671f49$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Annotation = void 0;

var $bpdXW = parcelRequire("bpdXW");

var $3uWBl = parcelRequire("3uWBl");
var $682a281a2f671f49$var$Annotation = /** @class */ function(_super) {
    $682a281a2f671f49$var$__extends(Annotation, _super);
    function Annotation(jsonld, options) {
        return _super.call(this, jsonld, options) || this;
    }
    /**
    In spite of its name, this method returns an array of objects, each of which
    represents a potential body annotations
    
    @see{ https://iiif.io/api/cookbook/recipe/0033-choice/ }
    **/ Annotation.prototype.getBody = function() {
        var bodies = [];
        /*
        A bodyValue property in the annotation json will short circuit
        the parsing process and be interpreted as a shorthand version of
        a TextualBody resource defining as the body
        
        This procedure is allowed, see Web Annotation Data Model section 3.2.5
        https://www.w3.org/TR/annotation-model/#string-body
        */ var stringBody = this.getProperty("bodyValue");
        //console.log("retrieved stringBody " + stringBody);
        if (stringBody) return [
            new $bpdXW.TextualBody({
                "id": "https://example.com/TextualBody/1",
                "value": stringBody,
                "type": "TextualBody"
            }, this.options)
        ];
        var body = this.getProperty("body");
        // the following is intended to handle the following cases for
        /// the raw json of the body property of __jsonld
        // -- body is an array, each element of which is parsed
        // == body is an object with property items, each item is parsed
        // -- body is parsed
        if (body) for(var _i = 0, _a = [].concat(body); _i < _a.length; _i++){
            var bd = _a[_i];
            var items = bd.items;
            if (items) bodies = bodies.concat(this.parseBodiesFromItemsList(items));
            else bodies.push(this.parseSingletonBody(bd));
        }
        return bodies;
    };
    Object.defineProperty(Annotation.prototype, "Body", {
        get: function() {
            return this.getBody();
        },
        enumerable: false,
        configurable: true
    });
    /**
    auxiliary function to getBody; intended to hande an object that has an element items
    which is a array of annotation- body-like objects. This : https://iiif.io/api/cookbook/recipe/0033-choice/
    seems to be the use case for this
    **/ Annotation.prototype.parseBodiesFromItemsList = function(rawbodies) {
        var retVal = [];
        for(var _i = 0, _a = [].concat(rawbodies); _i < _a.length; _i++){
            var bd = _a[_i];
            retVal.push(this.parseSingletonBody(bd));
        }
        return retVal;
    };
    /**
    auxiliary function to parseBodiesFromItemsList and getBody, this is the last
    step on recursively going through collections of bodies.
    **/ Annotation.prototype.parseSingletonBody = function(rawbody) {
        return $bpdXW.AnnotationBodyParser.BuildFromJson(rawbody, this.options);
    };
    /**
    Developer Note: 8 April 2024
    getBody3D function was developed in the early stages of the 3D API Feb-March 2024
    as alternative to the existing Annotation getBody function, but the signature for
    getBody3D was chosen to be a single object instance, not an array.
    
    At this stage, the merging of the 2D API anf the draft 3D API has been completed, so
    3D applications can use the getBody() function to retrieve the body of an Annotation intended
    to target a scene. For compatibily the return value of the function is still an
    array.
    
    3D clients using getBody are responsible for choosing the appropriate instance from the
    returned array. In most cases this will be the sole 0th element.
    **/ Annotation.prototype.getBody3D = function() {
        console.warn("Annotation.getBody3D is deprecated: replace with getBody3D() with getBody()[0]");
        return this.getBody()[0];
    };
    Annotation.prototype.getMotivation = function() {
        var motivation = this.getProperty("motivation");
        if (motivation) //const key: string | undefined = Object.keys(AnnotationMotivationEnum).find(k => AnnotationMotivationEnum[k] === motivation);
        return motivation;
        return null;
    };
    // open annotation
    Annotation.prototype.getOn = function() {
        return this.getProperty("on");
    };
    Annotation.prototype.getTarget = function() {
        var rawTarget = this.getPropertyAsObject("target");
        if (rawTarget.isIRI) return rawTarget;
        if (rawTarget.type && rawTarget.type == "SpecificResource") return new $bpdXW.SpecificResource(rawTarget, this.options);
        else if ([
            "Scene",
            "Canvas"
        ].includes(rawTarget.type)) return rawTarget;
        else throw new Error("unknown target specified");
    };
    Object.defineProperty(Annotation.prototype, "Target", {
        get: function() {
            return this.getTarget();
        },
        enumerable: false,
        configurable: true
    });
    Annotation.prototype.getResource = function() {
        return new $bpdXW.Resource(this.getProperty("resource"), this.options);
    };
    Object.defineProperty(Annotation.prototype, "LookAtLocation", {
        /**
        *    A 3D point coordinate object for the location of an Annotation
        *    to satisfy the requirements of the lookAt property of camera and
        *    spotlight resources, according to the draft v4 API as of April 1 2024
        *
        *    Is the position of the point for a target which is a SpecificResource with
        *    a PointSelector
        *    Otherwise, for example when the annotation target is an entire Scene, the
        *    location for lookAt is the origin (0,0,0)
        **/ get: function() {
            var _a;
            var target = this.getTarget();
            if (target.isSpecificResource && ((_a = target.getSelector()) === null || _a === void 0 ? void 0 : _a.isPointSelector)) return target.getSelector().getLocation();
            else return new $3uWBl.Vector3(0.0, 0.0, 0.0);
        },
        enumerable: false,
        configurable: true
    });
    return Annotation;
}($bpdXW.ManifestResource);
module.exports.Annotation = $682a281a2f671f49$var$Annotation;

});
parcelRegister("3uWBl", function(module, exports) {

$parcel$export(module.exports, "MathUtils", () => $28c1a1744a38aaaa$export$6a7ef315a0d1ef07);
$parcel$export(module.exports, "Quaternion", () => $28c1a1744a38aaaa$export$23d6a54f0bbc85a3);
$parcel$export(module.exports, "Vector3", () => $28c1a1744a38aaaa$export$64b5c384219d3699);
$parcel$export(module.exports, "Euler", () => $28c1a1744a38aaaa$export$d93cc409a0768c5f);
const $28c1a1744a38aaaa$export$3545e07a80636437 = '144dev';
const $28c1a1744a38aaaa$export$7177b3e430c2d7ca = {
    LEFT: 0,
    MIDDLE: 1,
    RIGHT: 2,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2
};
const $28c1a1744a38aaaa$export$d46bd3ead7cc759b = {
    ROTATE: 0,
    PAN: 1,
    DOLLY_PAN: 2,
    DOLLY_ROTATE: 3
};
const $28c1a1744a38aaaa$export$3237e1f2c1ea1f44 = 0;
const $28c1a1744a38aaaa$export$b9a7b4fc5cb15f9b = 1;
const $28c1a1744a38aaaa$export$b8058bcc7037d3f3 = 2;
const $28c1a1744a38aaaa$export$f24be24dcddeac0d = 3;
const $28c1a1744a38aaaa$export$346307dbae2b7447 = 0;
const $28c1a1744a38aaaa$export$5813f879eee7cd88 = 1;
const $28c1a1744a38aaaa$export$a47c4b43a1be34f0 = 2;
const $28c1a1744a38aaaa$export$896ae1ade6c829c4 = 3;
const $28c1a1744a38aaaa$export$2ede184fc2998901 = 0;
const $28c1a1744a38aaaa$export$d9f0486e75b5ace = 1;
const $28c1a1744a38aaaa$export$3b296b6f144d5b03 = 2;
const $28c1a1744a38aaaa$export$63b8d6b580fc65ba = 0;
const $28c1a1744a38aaaa$export$5b29a26d96ee6af0 = 1;
const $28c1a1744a38aaaa$export$777d8f9551c2216b = 2;
const $28c1a1744a38aaaa$export$cdfa06f868e2e467 = 3;
const $28c1a1744a38aaaa$export$4138e1c684b46a20 = 4;
const $28c1a1744a38aaaa$export$eda4864c68df1fa2 = 5;
const $28c1a1744a38aaaa$export$20183a0484ce21a0 = 100;
const $28c1a1744a38aaaa$export$73e0df5177988548 = 101;
const $28c1a1744a38aaaa$export$28e582859cbec660 = 102;
const $28c1a1744a38aaaa$export$c8c1508da8d0600c = 103;
const $28c1a1744a38aaaa$export$99948c02fb51055f = 104;
const $28c1a1744a38aaaa$export$2110f05edf778d3d = 200;
const $28c1a1744a38aaaa$export$8805bad65e24940e = 201;
const $28c1a1744a38aaaa$export$7fbe15b28d28cf52 = 202;
const $28c1a1744a38aaaa$export$947829af9f2c17f6 = 203;
const $28c1a1744a38aaaa$export$d5773124e86cf28c = 204;
const $28c1a1744a38aaaa$export$11d468cc7f19e971 = 205;
const $28c1a1744a38aaaa$export$a78aed1ca2a87192 = 206;
const $28c1a1744a38aaaa$export$5d0fe17fd8773bac = 207;
const $28c1a1744a38aaaa$export$ef5f2dd8ffac5574 = 208;
const $28c1a1744a38aaaa$export$56b85b2686ab16 = 209;
const $28c1a1744a38aaaa$export$c05e2a1fc8609506 = 210;
const $28c1a1744a38aaaa$export$69025ce147cee220 = 0;
const $28c1a1744a38aaaa$export$7182eb52ea3b3f04 = 1;
const $28c1a1744a38aaaa$export$eedccec66ab7ebe = 2;
const $28c1a1744a38aaaa$export$296f78a0b892f81a = 3;
const $28c1a1744a38aaaa$export$a60d398fc7b7590e = 4;
const $28c1a1744a38aaaa$export$7d7234c1240a1fc4 = 5;
const $28c1a1744a38aaaa$export$c5e2c52991f30937 = 6;
const $28c1a1744a38aaaa$export$2f843afa843d8916 = 7;
const $28c1a1744a38aaaa$export$e50ac29801f1774d = 0;
const $28c1a1744a38aaaa$export$9f9d94f963c85479 = 1;
const $28c1a1744a38aaaa$export$e641dc52bc3494aa = 2;
const $28c1a1744a38aaaa$export$9fcb6b4294603b2 = 0;
const $28c1a1744a38aaaa$export$98f52c2a46c598ca = 1;
const $28c1a1744a38aaaa$export$74b25e54b3bcd548 = 2;
const $28c1a1744a38aaaa$export$932b3dd283d4a366 = 3;
const $28c1a1744a38aaaa$export$a0d98fe6d7e4af64 = 4;
const $28c1a1744a38aaaa$export$2c7b09c1e9abfb5e = 5;
const $28c1a1744a38aaaa$export$1beec6768cbb3d2d = 300;
const $28c1a1744a38aaaa$export$8759762a6477f2c4 = 301;
const $28c1a1744a38aaaa$export$dc59f8aed047f61d = 302;
const $28c1a1744a38aaaa$export$d64030b316d3b087 = 303;
const $28c1a1744a38aaaa$export$ee99d97d46898098 = 304;
const $28c1a1744a38aaaa$export$dbf3e70ff37af79 = 306;
const $28c1a1744a38aaaa$export$533346c8e8dac0f5 = 1000;
const $28c1a1744a38aaaa$export$9d9334239a5a5e06 = 1001;
const $28c1a1744a38aaaa$export$c7e7c00b14f51a4f = 1002;
const $28c1a1744a38aaaa$export$727aa5ec3fe39bf0 = 1003;
const $28c1a1744a38aaaa$export$d129e38cf6feaa8c = 1004;
const $28c1a1744a38aaaa$export$14a4936464a36496 = 1004;
const $28c1a1744a38aaaa$export$d2327c1afe5bfdf2 = 1005;
const $28c1a1744a38aaaa$export$cbc5b7f5647595d8 = 1005;
const $28c1a1744a38aaaa$export$8a72f490b25c56c8 = 1006;
const $28c1a1744a38aaaa$export$19a719f377145a13 = 1007;
const $28c1a1744a38aaaa$export$dbe96bee3fe9dbf0 = 1007;
const $28c1a1744a38aaaa$export$5d8599b6a933fb1b = 1008;
const $28c1a1744a38aaaa$export$90d80f1e3506775f = 1008;
const $28c1a1744a38aaaa$export$2e8ce08d3f6f5e10 = 1009;
const $28c1a1744a38aaaa$export$545fce0311a9796a = 1010;
const $28c1a1744a38aaaa$export$88572337f312435f = 1011;
const $28c1a1744a38aaaa$export$c63dc51868b06a9d = 1012;
const $28c1a1744a38aaaa$export$5c612977753abe2 = 1013;
const $28c1a1744a38aaaa$export$c3c7fc4518ebba96 = 1014;
const $28c1a1744a38aaaa$export$f6d331659b644596 = 1015;
const $28c1a1744a38aaaa$export$2697304443f382bc = 1016;
const $28c1a1744a38aaaa$export$b3969b01faf587f2 = 1017;
const $28c1a1744a38aaaa$export$18886f8ae33e90de = 1018;
const $28c1a1744a38aaaa$export$6c8ea339bfab1301 = 1020;
const $28c1a1744a38aaaa$export$988473390501ed4b = 1021;
const $28c1a1744a38aaaa$export$7c67423a5ee6f5eb = 1022; // @deprecated since r137
const $28c1a1744a38aaaa$export$3f8bb04b555a363c = 1023;
const $28c1a1744a38aaaa$export$cc09ccbf6d1ed449 = 1024;
const $28c1a1744a38aaaa$export$9053a81c4a69c289 = 1025;
const $28c1a1744a38aaaa$export$c1b6b5136be58045 = 1026;
const $28c1a1744a38aaaa$export$1e113ac2d0905829 = 1027;
const $28c1a1744a38aaaa$export$4e041a7967d15c4b = 1028;
const $28c1a1744a38aaaa$export$aa92e870a709d190 = 1029;
const $28c1a1744a38aaaa$export$6cdf0b461c7ce8a0 = 1030;
const $28c1a1744a38aaaa$export$1ba1c45f9f77d4d7 = 1031;
const $28c1a1744a38aaaa$export$c200e7d26f592f21 = 1033;
const $28c1a1744a38aaaa$export$21d1799c6d552fc0 = 33776;
const $28c1a1744a38aaaa$export$afa304c3e981b668 = 33777;
const $28c1a1744a38aaaa$export$d2a1a68024a3e56c = 33778;
const $28c1a1744a38aaaa$export$9a79c424327dacf9 = 33779;
const $28c1a1744a38aaaa$export$19ada9bbb1af3573 = 35840;
const $28c1a1744a38aaaa$export$d0f0355bb3d948e4 = 35841;
const $28c1a1744a38aaaa$export$b82296714358084c = 35842;
const $28c1a1744a38aaaa$export$b71692456c47b6c3 = 35843;
const $28c1a1744a38aaaa$export$6ab91af2d757aee7 = 36196;
const $28c1a1744a38aaaa$export$7800993ef8106a6a = 37492;
const $28c1a1744a38aaaa$export$23ed8300a860e7d8 = 37496;
const $28c1a1744a38aaaa$export$dc5570b4a2b92d48 = 37808;
const $28c1a1744a38aaaa$export$68880cd325f8b2fb = 37809;
const $28c1a1744a38aaaa$export$7d2c0be323373d95 = 37810;
const $28c1a1744a38aaaa$export$22b52da301fc3a3e = 37811;
const $28c1a1744a38aaaa$export$c009e2cb4a66485e = 37812;
const $28c1a1744a38aaaa$export$118fff5afa255b63 = 37813;
const $28c1a1744a38aaaa$export$120713c829ae0667 = 37814;
const $28c1a1744a38aaaa$export$c79eeabbf53313e9 = 37815;
const $28c1a1744a38aaaa$export$443cf6567cdd6424 = 37816;
const $28c1a1744a38aaaa$export$6573984fc9840780 = 37817;
const $28c1a1744a38aaaa$export$e7aee563f30091de = 37818;
const $28c1a1744a38aaaa$export$2eb8634622ddeab7 = 37819;
const $28c1a1744a38aaaa$export$202b1ce7b5d25742 = 37820;
const $28c1a1744a38aaaa$export$18ab77abd087e467 = 37821;
const $28c1a1744a38aaaa$export$ce40b115e188bc81 = 36492;
const $28c1a1744a38aaaa$export$d62fdc9d1b1cccad = 2200;
const $28c1a1744a38aaaa$export$dfaf4422ce096e29 = 2201;
const $28c1a1744a38aaaa$export$f8f6f2041b78e210 = 2202;
const $28c1a1744a38aaaa$export$995b32462a65e855 = 2300;
const $28c1a1744a38aaaa$export$30fac1aace31cf4d = 2301;
const $28c1a1744a38aaaa$export$198b11ff4c72bb30 = 2302;
const $28c1a1744a38aaaa$export$7f795934b84ab523 = 2400;
const $28c1a1744a38aaaa$export$24a4ccb5099273b5 = 2401;
const $28c1a1744a38aaaa$export$8e8c3ecdcd8e1fee = 2402;
const $28c1a1744a38aaaa$export$bcfbbdcf8de7f8cd = 2500;
const $28c1a1744a38aaaa$export$d875e029ef558d3 = 2501;
const $28c1a1744a38aaaa$export$4c28c87c2dc84758 = 0;
const $28c1a1744a38aaaa$export$b23a071aa286eb29 = 1;
const $28c1a1744a38aaaa$export$f0d8293634f88842 = 2;
const $28c1a1744a38aaaa$export$7207336e4151a112 = 3000;
const $28c1a1744a38aaaa$export$f32388edbb32674 = 3001;
const $28c1a1744a38aaaa$export$deeb383078690b50 = 3200;
const $28c1a1744a38aaaa$export$8f910f4c4f73df11 = 3201;
const $28c1a1744a38aaaa$export$2852a58ebdac27b8 = 0;
const $28c1a1744a38aaaa$export$9990ad26f9db5b2c = 1;
// Color space string identifiers, matching CSS Color Module Level 4 and WebGPU names where available.
const $28c1a1744a38aaaa$export$bfcb490c2dd3db51 = '';
const $28c1a1744a38aaaa$export$561f394b24edfcaa = 'srgb';
const $28c1a1744a38aaaa$export$42429b3acfb233a4 = 'srgb-linear';
const $28c1a1744a38aaaa$export$69433f11f42d5527 = 0;
const $28c1a1744a38aaaa$export$9f542ae4b5baca34 = 7680;
const $28c1a1744a38aaaa$export$8a4f28336ef203d3 = 7681;
const $28c1a1744a38aaaa$export$2928c0231297c036 = 7682;
const $28c1a1744a38aaaa$export$c0e9611c8a15f9a8 = 7683;
const $28c1a1744a38aaaa$export$9c2c08927385dcc4 = 34055;
const $28c1a1744a38aaaa$export$7c74ea00fa1315e6 = 34056;
const $28c1a1744a38aaaa$export$22e2e5726612443 = 5386;
const $28c1a1744a38aaaa$export$1343870698229224 = 512;
const $28c1a1744a38aaaa$export$8e1d8ed281997fa6 = 513;
const $28c1a1744a38aaaa$export$55648a1cde8329a7 = 514;
const $28c1a1744a38aaaa$export$2dff107857e6aca2 = 515;
const $28c1a1744a38aaaa$export$6f93765ab2f451a2 = 516;
const $28c1a1744a38aaaa$export$6f3fb2d2440f2b76 = 517;
const $28c1a1744a38aaaa$export$4119cf7b4c98fd5a = 518;
const $28c1a1744a38aaaa$export$14cf96713ddd97a8 = 519;
const $28c1a1744a38aaaa$export$763e8360f4d7f77d = 35044;
const $28c1a1744a38aaaa$export$8505d14ac8546ca = 35048;
const $28c1a1744a38aaaa$export$721e63549e51d81e = 35040;
const $28c1a1744a38aaaa$export$415731dc4f48e299 = 35045;
const $28c1a1744a38aaaa$export$9e809946455f13bc = 35049;
const $28c1a1744a38aaaa$export$2ed9499a35b5f832 = 35041;
const $28c1a1744a38aaaa$export$32ab2503ea19469a = 35046;
const $28c1a1744a38aaaa$export$ab4022c2c3f86315 = 35050;
const $28c1a1744a38aaaa$export$ba7f1db36a76a970 = 35042;
const $28c1a1744a38aaaa$export$43600cc67fabd9f = '100';
const $28c1a1744a38aaaa$export$f63012db5506e7dd = '300 es';
const $28c1a1744a38aaaa$export$ca1dce8b5e1de74d = 1035; // fallback for WebGL 1
class $28c1a1744a38aaaa$export$c977b3e384af9ae1 {
    constructor(x = 0, y = 0){
        $28c1a1744a38aaaa$export$c977b3e384af9ae1.prototype.isVector2 = true;
        this.x = x;
        this.y = y;
    }
    get width() {
        return this.x;
    }
    set width(value) {
        this.x = value;
    }
    get height() {
        return this.y;
    }
    set height(value) {
        this.y = value;
    }
    set(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        return this;
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6];
        this.y = e[1] * x + e[4] * y + e[7];
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    }
    roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y;
    }
    cross(v) {
        return this.x * v.y - this.y * v.x;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    angle() {
        // computes the angle in radians with respect to the positive x-axis
        const angle = Math.atan2(-this.y, -this.x) + Math.PI;
        return angle;
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y;
        return dx * dx + dy * dy;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        return array;
    }
    // fromBufferAttribute( attribute, index ) {
    // 	this.x = attribute.getX( index );
    // 	this.y = attribute.getY( index );
    // 	return this;
    // }
    rotateAround(center, angle) {
        const c = Math.cos(angle), s = Math.sin(angle);
        const x = this.x - center.x;
        const y = this.y - center.y;
        this.x = x * c - y * s + center.x;
        this.y = x * s + y * c + center.y;
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
    }
}
const $28c1a1744a38aaaa$var$_lut = [
    '00',
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '0a',
    '0b',
    '0c',
    '0d',
    '0e',
    '0f',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '1a',
    '1b',
    '1c',
    '1d',
    '1e',
    '1f',
    '20',
    '21',
    '22',
    '23',
    '24',
    '25',
    '26',
    '27',
    '28',
    '29',
    '2a',
    '2b',
    '2c',
    '2d',
    '2e',
    '2f',
    '30',
    '31',
    '32',
    '33',
    '34',
    '35',
    '36',
    '37',
    '38',
    '39',
    '3a',
    '3b',
    '3c',
    '3d',
    '3e',
    '3f',
    '40',
    '41',
    '42',
    '43',
    '44',
    '45',
    '46',
    '47',
    '48',
    '49',
    '4a',
    '4b',
    '4c',
    '4d',
    '4e',
    '4f',
    '50',
    '51',
    '52',
    '53',
    '54',
    '55',
    '56',
    '57',
    '58',
    '59',
    '5a',
    '5b',
    '5c',
    '5d',
    '5e',
    '5f',
    '60',
    '61',
    '62',
    '63',
    '64',
    '65',
    '66',
    '67',
    '68',
    '69',
    '6a',
    '6b',
    '6c',
    '6d',
    '6e',
    '6f',
    '70',
    '71',
    '72',
    '73',
    '74',
    '75',
    '76',
    '77',
    '78',
    '79',
    '7a',
    '7b',
    '7c',
    '7d',
    '7e',
    '7f',
    '80',
    '81',
    '82',
    '83',
    '84',
    '85',
    '86',
    '87',
    '88',
    '89',
    '8a',
    '8b',
    '8c',
    '8d',
    '8e',
    '8f',
    '90',
    '91',
    '92',
    '93',
    '94',
    '95',
    '96',
    '97',
    '98',
    '99',
    '9a',
    '9b',
    '9c',
    '9d',
    '9e',
    '9f',
    'a0',
    'a1',
    'a2',
    'a3',
    'a4',
    'a5',
    'a6',
    'a7',
    'a8',
    'a9',
    'aa',
    'ab',
    'ac',
    'ad',
    'ae',
    'af',
    'b0',
    'b1',
    'b2',
    'b3',
    'b4',
    'b5',
    'b6',
    'b7',
    'b8',
    'b9',
    'ba',
    'bb',
    'bc',
    'bd',
    'be',
    'bf',
    'c0',
    'c1',
    'c2',
    'c3',
    'c4',
    'c5',
    'c6',
    'c7',
    'c8',
    'c9',
    'ca',
    'cb',
    'cc',
    'cd',
    'ce',
    'cf',
    'd0',
    'd1',
    'd2',
    'd3',
    'd4',
    'd5',
    'd6',
    'd7',
    'd8',
    'd9',
    'da',
    'db',
    'dc',
    'dd',
    'de',
    'df',
    'e0',
    'e1',
    'e2',
    'e3',
    'e4',
    'e5',
    'e6',
    'e7',
    'e8',
    'e9',
    'ea',
    'eb',
    'ec',
    'ed',
    'ee',
    'ef',
    'f0',
    'f1',
    'f2',
    'f3',
    'f4',
    'f5',
    'f6',
    'f7',
    'f8',
    'f9',
    'fa',
    'fb',
    'fc',
    'fd',
    'fe',
    'ff'
];
let $28c1a1744a38aaaa$var$_seed = 1234567;
const $28c1a1744a38aaaa$var$DEG2RAD = Math.PI / 180;
const $28c1a1744a38aaaa$var$RAD2DEG = 180 / Math.PI;
// http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
function $28c1a1744a38aaaa$var$generateUUID() {
    const d0 = Math.random() * 0xffffffff | 0;
    const d1 = Math.random() * 0xffffffff | 0;
    const d2 = Math.random() * 0xffffffff | 0;
    const d3 = Math.random() * 0xffffffff | 0;
    const uuid = $28c1a1744a38aaaa$var$_lut[d0 & 0xff] + $28c1a1744a38aaaa$var$_lut[d0 >> 8 & 0xff] + $28c1a1744a38aaaa$var$_lut[d0 >> 16 & 0xff] + $28c1a1744a38aaaa$var$_lut[d0 >> 24 & 0xff] + '-' + $28c1a1744a38aaaa$var$_lut[d1 & 0xff] + $28c1a1744a38aaaa$var$_lut[d1 >> 8 & 0xff] + '-' + $28c1a1744a38aaaa$var$_lut[d1 >> 16 & 0x0f | 0x40] + $28c1a1744a38aaaa$var$_lut[d1 >> 24 & 0xff] + '-' + $28c1a1744a38aaaa$var$_lut[d2 & 0x3f | 0x80] + $28c1a1744a38aaaa$var$_lut[d2 >> 8 & 0xff] + '-' + $28c1a1744a38aaaa$var$_lut[d2 >> 16 & 0xff] + $28c1a1744a38aaaa$var$_lut[d2 >> 24 & 0xff] + $28c1a1744a38aaaa$var$_lut[d3 & 0xff] + $28c1a1744a38aaaa$var$_lut[d3 >> 8 & 0xff] + $28c1a1744a38aaaa$var$_lut[d3 >> 16 & 0xff] + $28c1a1744a38aaaa$var$_lut[d3 >> 24 & 0xff];
    // .toLowerCase() here flattens concatenated strings to save heap memory space.
    return uuid.toLowerCase();
}
function $28c1a1744a38aaaa$var$clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
// compute euclidean modulo of m % n
// https://en.wikipedia.org/wiki/Modulo_operation
function $28c1a1744a38aaaa$var$euclideanModulo(n, m) {
    return (n % m + m) % m;
}
// Linear mapping from range <a1, a2> to range <b1, b2>
function $28c1a1744a38aaaa$var$mapLinear(x, a1, a2, b1, b2) {
    return b1 + (x - a1) * (b2 - b1) / (a2 - a1);
}
// https://www.gamedev.net/tutorials/programming/general-and-gameplay-programming/inverse-lerp-a-super-useful-yet-often-overlooked-function-r5230/
function $28c1a1744a38aaaa$var$inverseLerp(x, y, value) {
    if (x !== y) return (value - x) / (y - x);
    else return 0;
}
// https://en.wikipedia.org/wiki/Linear_interpolation
function $28c1a1744a38aaaa$var$lerp(x, y, t) {
    return (1 - t) * x + t * y;
}
// http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/
function $28c1a1744a38aaaa$var$damp(x, y, lambda, dt) {
    return $28c1a1744a38aaaa$var$lerp(x, y, 1 - Math.exp(-lambda * dt));
}
// https://www.desmos.com/calculator/vcsjnyz7x4
function $28c1a1744a38aaaa$var$pingpong(x, length = 1) {
    return length - Math.abs($28c1a1744a38aaaa$var$euclideanModulo(x, length * 2) - length);
}
// http://en.wikipedia.org/wiki/Smoothstep
function $28c1a1744a38aaaa$var$smoothstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * (3 - 2 * x);
}
function $28c1a1744a38aaaa$var$smootherstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * x * (x * (x * 6 - 15) + 10);
}
// Random integer from <low, high> interval
function $28c1a1744a38aaaa$var$randInt(low, high) {
    return low + Math.floor(Math.random() * (high - low + 1));
}
// Random float from <low, high> interval
function $28c1a1744a38aaaa$var$randFloat(low, high) {
    return low + Math.random() * (high - low);
}
// Random float from <-range/2, range/2> interval
function $28c1a1744a38aaaa$var$randFloatSpread(range) {
    return range * (0.5 - Math.random());
}
// Deterministic pseudo-random float in the interval [ 0, 1 ]
function $28c1a1744a38aaaa$var$seededRandom(s) {
    if (s !== undefined) $28c1a1744a38aaaa$var$_seed = s;
    // Mulberry32 generator
    let t = $28c1a1744a38aaaa$var$_seed += 0x6D2B79F5;
    t = Math.imul(t ^ t >>> 15, t | 1);
    t ^= t + Math.imul(t ^ t >>> 7, t | 61);
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
}
function $28c1a1744a38aaaa$var$degToRad(degrees) {
    return degrees * $28c1a1744a38aaaa$var$DEG2RAD;
}
function $28c1a1744a38aaaa$var$radToDeg(radians) {
    return radians * $28c1a1744a38aaaa$var$RAD2DEG;
}
function $28c1a1744a38aaaa$var$isPowerOfTwo(value) {
    return (value & value - 1) === 0 && value !== 0;
}
function $28c1a1744a38aaaa$var$ceilPowerOfTwo(value) {
    return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}
function $28c1a1744a38aaaa$var$floorPowerOfTwo(value) {
    return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
}
function $28c1a1744a38aaaa$var$setQuaternionFromProperEuler(q, a, b, c, order) {
    // Intrinsic Proper Euler Angles - see https://en.wikipedia.org/wiki/Euler_angles
    // rotations are applied to the axes in the order specified by 'order'
    // rotation by angle 'a' is applied first, then by angle 'b', then by angle 'c'
    // angles are in radians
    const cos = Math.cos;
    const sin = Math.sin;
    const c2 = cos(b / 2);
    const s2 = sin(b / 2);
    const c13 = cos((a + c) / 2);
    const s13 = sin((a + c) / 2);
    const c1_3 = cos((a - c) / 2);
    const s1_3 = sin((a - c) / 2);
    const c3_1 = cos((c - a) / 2);
    const s3_1 = sin((c - a) / 2);
    switch(order){
        case 'XYX':
            q.set(c2 * s13, s2 * c1_3, s2 * s1_3, c2 * c13);
            break;
        case 'YZY':
            q.set(s2 * s1_3, c2 * s13, s2 * c1_3, c2 * c13);
            break;
        case 'ZXZ':
            q.set(s2 * c1_3, s2 * s1_3, c2 * s13, c2 * c13);
            break;
        case 'XZX':
            q.set(c2 * s13, s2 * s3_1, s2 * c3_1, c2 * c13);
            break;
        case 'YXY':
            q.set(s2 * c3_1, c2 * s13, s2 * s3_1, c2 * c13);
            break;
        case 'ZYZ':
            q.set(s2 * s3_1, s2 * c3_1, c2 * s13, c2 * c13);
            break;
        default:
            console.warn('THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: ' + order);
    }
}
function $28c1a1744a38aaaa$var$denormalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint16Array:
            return value / 65535.0;
        case Uint8Array:
            return value / 255.0;
        case Int16Array:
            return Math.max(value / 32767.0, -1);
        case Int8Array:
            return Math.max(value / 127.0, -1);
        default:
            throw new Error('Invalid component type.');
    }
}
function $28c1a1744a38aaaa$var$normalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint16Array:
            return Math.round(value * 65535.0);
        case Uint8Array:
            return Math.round(value * 255.0);
        case Int16Array:
            return Math.round(value * 32767.0);
        case Int8Array:
            return Math.round(value * 127.0);
        default:
            throw new Error('Invalid component type.');
    }
}
var $28c1a1744a38aaaa$export$6a7ef315a0d1ef07 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    DEG2RAD: $28c1a1744a38aaaa$var$DEG2RAD,
    RAD2DEG: $28c1a1744a38aaaa$var$RAD2DEG,
    generateUUID: $28c1a1744a38aaaa$var$generateUUID,
    clamp: $28c1a1744a38aaaa$var$clamp,
    euclideanModulo: $28c1a1744a38aaaa$var$euclideanModulo,
    mapLinear: $28c1a1744a38aaaa$var$mapLinear,
    inverseLerp: $28c1a1744a38aaaa$var$inverseLerp,
    lerp: $28c1a1744a38aaaa$var$lerp,
    damp: $28c1a1744a38aaaa$var$damp,
    pingpong: $28c1a1744a38aaaa$var$pingpong,
    smoothstep: $28c1a1744a38aaaa$var$smoothstep,
    smootherstep: $28c1a1744a38aaaa$var$smootherstep,
    randInt: $28c1a1744a38aaaa$var$randInt,
    randFloat: $28c1a1744a38aaaa$var$randFloat,
    randFloatSpread: $28c1a1744a38aaaa$var$randFloatSpread,
    seededRandom: $28c1a1744a38aaaa$var$seededRandom,
    degToRad: $28c1a1744a38aaaa$var$degToRad,
    radToDeg: $28c1a1744a38aaaa$var$radToDeg,
    isPowerOfTwo: $28c1a1744a38aaaa$var$isPowerOfTwo,
    ceilPowerOfTwo: $28c1a1744a38aaaa$var$ceilPowerOfTwo,
    floorPowerOfTwo: $28c1a1744a38aaaa$var$floorPowerOfTwo,
    setQuaternionFromProperEuler: $28c1a1744a38aaaa$var$setQuaternionFromProperEuler,
    normalize: $28c1a1744a38aaaa$var$normalize,
    denormalize: $28c1a1744a38aaaa$var$denormalize
});
class $28c1a1744a38aaaa$export$23d6a54f0bbc85a3 {
    constructor(x = 0, y = 0, z = 0, w = 1){
        this.isQuaternion = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
    }
    static slerpFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t) {
        // fuzz-free, array-based Quaternion SLERP operation
        let x0 = src0[srcOffset0 + 0], y0 = src0[srcOffset0 + 1], z0 = src0[srcOffset0 + 2], w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1 + 0], y1 = src1[srcOffset1 + 1], z1 = src1[srcOffset1 + 2], w1 = src1[srcOffset1 + 3];
        if (t === 0) {
            dst[dstOffset + 0] = x0;
            dst[dstOffset + 1] = y0;
            dst[dstOffset + 2] = z0;
            dst[dstOffset + 3] = w0;
            return;
        }
        if (t === 1) {
            dst[dstOffset + 0] = x1;
            dst[dstOffset + 1] = y1;
            dst[dstOffset + 2] = z1;
            dst[dstOffset + 3] = w1;
            return;
        }
        if (w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1) {
            let s = 1 - t;
            const cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1, dir = cos >= 0 ? 1 : -1, sqrSin = 1 - cos * cos;
            // Skip the Slerp for tiny steps to avoid numeric problems:
            if (sqrSin > Number.EPSILON) {
                const sin = Math.sqrt(sqrSin), len = Math.atan2(sin, cos * dir);
                s = Math.sin(s * len) / sin;
                t = Math.sin(t * len) / sin;
            }
            const tDir = t * dir;
            x0 = x0 * s + x1 * tDir;
            y0 = y0 * s + y1 * tDir;
            z0 = z0 * s + z1 * tDir;
            w0 = w0 * s + w1 * tDir;
            // Normalize in case we just did a lerp:
            if (s === 1 - t) {
                const f = 1 / Math.sqrt(x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0);
                x0 *= f;
                y0 *= f;
                z0 *= f;
                w0 *= f;
            }
        }
        dst[dstOffset] = x0;
        dst[dstOffset + 1] = y0;
        dst[dstOffset + 2] = z0;
        dst[dstOffset + 3] = w0;
    }
    static multiplyQuaternionsFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1) {
        const x0 = src0[srcOffset0];
        const y0 = src0[srcOffset0 + 1];
        const z0 = src0[srcOffset0 + 2];
        const w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1];
        const y1 = src1[srcOffset1 + 1];
        const z1 = src1[srcOffset1 + 2];
        const w1 = src1[srcOffset1 + 3];
        dst[dstOffset] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
        dst[dstOffset + 1] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
        dst[dstOffset + 2] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
        dst[dstOffset + 3] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;
        return dst;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get w() {
        return this._w;
    }
    set w(value) {
        this._w = value;
        this._onChangeCallback();
    }
    set(x, y, z, w) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._w);
    }
    copy(quaternion) {
        this._x = quaternion.x;
        this._y = quaternion.y;
        this._z = quaternion.z;
        this._w = quaternion.w;
        this._onChangeCallback();
        return this;
    }
    setFromEuler(euler, update) {
        const x = euler._x, y = euler._y, z = euler._z, order = euler._order;
        // http://www.mathworks.com/matlabcentral/fileexchange/
        // 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
        //	content/SpinCalc.m
        const cos = Math.cos;
        const sin = Math.sin;
        const c1 = cos(x / 2);
        const c2 = cos(y / 2);
        const c3 = cos(z / 2);
        const s1 = sin(x / 2);
        const s2 = sin(y / 2);
        const s3 = sin(z / 2);
        switch(order){
            case 'XYZ':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'YXZ':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case 'ZXY':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'ZYX':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case 'YZX':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'XZY':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            default:
                console.warn('THREE.Quaternion: .setFromEuler() encountered an unknown order: ' + order);
        }
        if (update !== false) this._onChangeCallback();
        return this;
    }
    setFromAxisAngle(axis, angle) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm
        // assumes axis is normalized
        const halfAngle = angle / 2, s = Math.sin(halfAngle);
        this._x = axis.x * s;
        this._y = axis.y * s;
        this._z = axis.z * s;
        this._w = Math.cos(halfAngle);
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10], trace = m11 + m22 + m33;
        if (trace > 0) {
            const s = 0.5 / Math.sqrt(trace + 1.0);
            this._w = 0.25 / s;
            this._x = (m32 - m23) * s;
            this._y = (m13 - m31) * s;
            this._z = (m21 - m12) * s;
        } else if (m11 > m22 && m11 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);
            this._w = (m32 - m23) / s;
            this._x = 0.25 * s;
            this._y = (m12 + m21) / s;
            this._z = (m13 + m31) / s;
        } else if (m22 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);
            this._w = (m13 - m31) / s;
            this._x = (m12 + m21) / s;
            this._y = 0.25 * s;
            this._z = (m23 + m32) / s;
        } else {
            const s = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);
            this._w = (m21 - m12) / s;
            this._x = (m13 + m31) / s;
            this._y = (m23 + m32) / s;
            this._z = 0.25 * s;
        }
        this._onChangeCallback();
        return this;
    }
    setFromUnitVectors(vFrom, vTo) {
        // assumes direction vectors vFrom and vTo are normalized
        let r = vFrom.dot(vTo) + 1;
        if (r < Number.EPSILON) {
            // vFrom and vTo point in opposite directions
            r = 0;
            if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
                this._x = -vFrom.y;
                this._y = vFrom.x;
                this._z = 0;
                this._w = r;
            } else {
                this._x = 0;
                this._y = -vFrom.z;
                this._z = vFrom.y;
                this._w = r;
            }
        } else {
            // crossVectors( vFrom, vTo ); // inlined to avoid cyclic dependency on Vector3
            this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
            this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
            this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
            this._w = r;
        }
        return this.normalize();
    }
    angleTo(q) {
        return 2 * Math.acos(Math.abs($28c1a1744a38aaaa$var$clamp(this.dot(q), -1, 1)));
    }
    rotateTowards(q, step) {
        const angle = this.angleTo(q);
        if (angle === 0) return this;
        const t = Math.min(1, step / angle);
        this.slerp(q, t);
        return this;
    }
    identity() {
        return this.set(0, 0, 0, 1);
    }
    invert() {
        // quaternion is assumed to have unit length
        return this.conjugate();
    }
    conjugate() {
        this._x *= -1;
        this._y *= -1;
        this._z *= -1;
        this._onChangeCallback();
        return this;
    }
    dot(v) {
        return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
    }
    lengthSq() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
    length() {
        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
    normalize() {
        let l = this.length();
        if (l === 0) {
            this._x = 0;
            this._y = 0;
            this._z = 0;
            this._w = 1;
        } else {
            l = 1 / l;
            this._x = this._x * l;
            this._y = this._y * l;
            this._z = this._z * l;
            this._w = this._w * l;
        }
        this._onChangeCallback();
        return this;
    }
    multiply(q) {
        return this.multiplyQuaternions(this, q);
    }
    premultiply(q) {
        return this.multiplyQuaternions(q, this);
    }
    multiplyQuaternions(a, b) {
        // from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm
        const qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
        const qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;
        this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
        this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
        this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
        this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
        this._onChangeCallback();
        return this;
    }
    slerp(qb, t) {
        if (t === 0) return this;
        if (t === 1) return this.copy(qb);
        const x = this._x, y = this._y, z = this._z, w = this._w;
        // http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/
        let cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;
        if (cosHalfTheta < 0) {
            this._w = -qb._w;
            this._x = -qb._x;
            this._y = -qb._y;
            this._z = -qb._z;
            cosHalfTheta = -cosHalfTheta;
        } else this.copy(qb);
        if (cosHalfTheta >= 1.0) {
            this._w = w;
            this._x = x;
            this._y = y;
            this._z = z;
            return this;
        }
        const sqrSinHalfTheta = 1.0 - cosHalfTheta * cosHalfTheta;
        if (sqrSinHalfTheta <= Number.EPSILON) {
            const s = 1 - t;
            this._w = s * w + t * this._w;
            this._x = s * x + t * this._x;
            this._y = s * y + t * this._y;
            this._z = s * z + t * this._z;
            this.normalize();
            this._onChangeCallback();
            return this;
        }
        const sinHalfTheta = Math.sqrt(sqrSinHalfTheta);
        const halfTheta = Math.atan2(sinHalfTheta, cosHalfTheta);
        const ratioA = Math.sin((1 - t) * halfTheta) / sinHalfTheta, ratioB = Math.sin(t * halfTheta) / sinHalfTheta;
        this._w = w * ratioA + this._w * ratioB;
        this._x = x * ratioA + this._x * ratioB;
        this._y = y * ratioA + this._y * ratioB;
        this._z = z * ratioA + this._z * ratioB;
        this._onChangeCallback();
        return this;
    }
    slerpQuaternions(qa, qb, t) {
        return this.copy(qa).slerp(qb, t);
    }
    random() {
        // Derived from http://planning.cs.uiuc.edu/node198.html
        // Note, this source uses w, x, y, z ordering,
        // so we swap the order below.
        const u1 = Math.random();
        const sqrt1u1 = Math.sqrt(1 - u1);
        const sqrtu1 = Math.sqrt(u1);
        const u2 = 2 * Math.PI * Math.random();
        const u3 = 2 * Math.PI * Math.random();
        return this.set(sqrt1u1 * Math.cos(u2), sqrtu1 * Math.sin(u3), sqrtu1 * Math.cos(u3), sqrt1u1 * Math.sin(u2));
    }
    equals(quaternion) {
        return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;
    }
    fromArray(array, offset = 0) {
        this._x = array[offset];
        this._y = array[offset + 1];
        this._z = array[offset + 2];
        this._w = array[offset + 3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._w;
        return array;
    }
    // fromBufferAttribute( attribute, index ) {
    // 	this._x = attribute.getX( index );
    // 	this._y = attribute.getY( index );
    // 	this._z = attribute.getZ( index );
    // 	this._w = attribute.getW( index );
    // 	return this;
    // }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._w;
    }
}
class $28c1a1744a38aaaa$export$64b5c384219d3699 {
    constructor(x = 0, y = 0, z = 0){
        $28c1a1744a38aaaa$export$64b5c384219d3699.prototype.isVector3 = true;
        this.x = x;
        this.y = y;
        this.z = z;
    }
    set(x, y, z) {
        if (z === undefined) z = this.z; // sprite.scale.set(x,y)
        this.x = x;
        this.y = y;
        this.z = z;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        return this;
    }
    multiplyVectors(a, b) {
        this.x = a.x * b.x;
        this.y = a.y * b.y;
        this.z = a.z * b.z;
        return this;
    }
    applyEuler(euler) {
        return this.applyQuaternion($28c1a1744a38aaaa$var$_quaternion$1.setFromEuler(euler));
    }
    applyAxisAngle(axis, angle) {
        return this.applyQuaternion($28c1a1744a38aaaa$var$_quaternion$1.setFromAxisAngle(axis, angle));
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6] * z;
        this.y = e[1] * x + e[4] * y + e[7] * z;
        this.z = e[2] * x + e[5] * y + e[8] * z;
        return this;
    }
    applyNormalMatrix(m) {
        return this.applyMatrix3(m).normalize();
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        const w = 1 / (e[3] * x + e[7] * y + e[11] * z + e[15]);
        this.x = (e[0] * x + e[4] * y + e[8] * z + e[12]) * w;
        this.y = (e[1] * x + e[5] * y + e[9] * z + e[13]) * w;
        this.z = (e[2] * x + e[6] * y + e[10] * z + e[14]) * w;
        return this;
    }
    applyQuaternion(q) {
        const x = this.x, y = this.y, z = this.z;
        const qx = q.x, qy = q.y, qz = q.z, qw = q.w;
        // calculate quat * vector
        const ix = qw * x + qy * z - qz * y;
        const iy = qw * y + qz * x - qx * z;
        const iz = qw * z + qx * y - qy * x;
        const iw = -qx * x - qy * y - qz * z;
        // calculate result * inverse quat
        this.x = ix * qw + iw * -qx + iy * -qz - iz * -qy;
        this.y = iy * qw + iw * -qy + iz * -qx - ix * -qz;
        this.z = iz * qw + iw * -qz + ix * -qy - iy * -qx;
        return this;
    }
    // project( camera ) {
    // 	return this.applyMatrix4( camera.matrixWorldInverse ).applyMatrix4( camera.projectionMatrix );
    // }
    // unproject( camera ) {
    // 	return this.applyMatrix4( camera.projectionMatrixInverse ).applyMatrix4( camera.matrixWorld );
    // }
    transformDirection(m) {
        // input: THREE.Matrix4 affine matrix
        // vector interpreted as a direction
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z;
        this.y = e[1] * x + e[5] * y + e[9] * z;
        this.z = e[2] * x + e[6] * y + e[10] * z;
        return this.normalize();
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        this.z /= v.z;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        return this;
    }
    roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z;
    }
    // TODO lengthSquared?
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        return this;
    }
    cross(v) {
        return this.crossVectors(this, v);
    }
    crossVectors(a, b) {
        const ax = a.x, ay = a.y, az = a.z;
        const bx = b.x, by = b.y, bz = b.z;
        this.x = ay * bz - az * by;
        this.y = az * bx - ax * bz;
        this.z = ax * by - ay * bx;
        return this;
    }
    projectOnVector(v) {
        const denominator = v.lengthSq();
        if (denominator === 0) return this.set(0, 0, 0);
        const scalar = v.dot(this) / denominator;
        return this.copy(v).multiplyScalar(scalar);
    }
    projectOnPlane(planeNormal) {
        $28c1a1744a38aaaa$var$_vector$3.copy(this).projectOnVector(planeNormal);
        return this.sub($28c1a1744a38aaaa$var$_vector$3);
    }
    reflect(normal) {
        // reflect incident vector off plane orthogonal to normal
        // normal is assumed to have unit length
        return this.sub($28c1a1744a38aaaa$var$_vector$3.copy(normal).multiplyScalar(2 * this.dot(normal)));
    }
    angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($28c1a1744a38aaaa$var$clamp(theta, -1, 1));
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;
        return dx * dx + dy * dy + dz * dz;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y) + Math.abs(this.z - v.z);
    }
    setFromSpherical(s) {
        return this.setFromSphericalCoords(s.radius, s.phi, s.theta);
    }
    setFromSphericalCoords(radius, phi, theta) {
        const sinPhiRadius = Math.sin(phi) * radius;
        this.x = sinPhiRadius * Math.sin(theta);
        this.y = Math.cos(phi) * radius;
        this.z = sinPhiRadius * Math.cos(theta);
        return this;
    }
    setFromCylindrical(c) {
        return this.setFromCylindricalCoords(c.radius, c.theta, c.y);
    }
    setFromCylindricalCoords(radius, theta, y) {
        this.x = radius * Math.sin(theta);
        this.y = y;
        this.z = radius * Math.cos(theta);
        return this;
    }
    setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        return this;
    }
    setFromMatrixScale(m) {
        const sx = this.setFromMatrixColumn(m, 0).length();
        const sy = this.setFromMatrixColumn(m, 1).length();
        const sz = this.setFromMatrixColumn(m, 2).length();
        this.x = sx;
        this.y = sy;
        this.z = sz;
        return this;
    }
    setFromMatrixColumn(m, index) {
        return this.fromArray(m.elements, index * 4);
    }
    setFromMatrix3Column(m, index) {
        return this.fromArray(m.elements, index * 3);
    }
    setFromEuler(e) {
        this.x = e._x;
        this.y = e._y;
        this.z = e._z;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        return array;
    }
    // fromBufferAttribute( attribute, index ) {
    // 	this.x = attribute.getX( index );
    // 	this.y = attribute.getY( index );
    // 	this.z = attribute.getZ( index );
    // 	return this;
    // }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        return this;
    }
    randomDirection() {
        // Derived from https://mathworld.wolfram.com/SpherePointPicking.html
        const u = (Math.random() - 0.5) * 2;
        const t = Math.random() * Math.PI * 2;
        const f = Math.sqrt(1 - u ** 2);
        this.x = f * Math.cos(t);
        this.y = f * Math.sin(t);
        this.z = u;
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
    }
}
const $28c1a1744a38aaaa$var$_vector$3 = /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699();
const $28c1a1744a38aaaa$var$_quaternion$1 = /*@__PURE__*/ new $28c1a1744a38aaaa$export$23d6a54f0bbc85a3();
const $28c1a1744a38aaaa$var$_vector$2 = /*@__PURE__*/ new $28c1a1744a38aaaa$export$c977b3e384af9ae1();
class $28c1a1744a38aaaa$export$60f553fa130f08b0 {
    constructor(min = new $28c1a1744a38aaaa$export$c977b3e384af9ae1(Infinity, Infinity), max = new $28c1a1744a38aaaa$export$c977b3e384af9ae1(-Infinity, -Infinity)){
        this.isBox2 = true;
        this.min = min;
        this.max = max;
    }
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = $28c1a1744a38aaaa$var$_vector$2.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = Infinity;
        this.max.x = this.max.y = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y;
    }
    getCenter(target = new $28c1a1744a38aaaa$export$c977b3e384af9ae1()) {
        return this.isEmpty() ? target.set(0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target = new $28c1a1744a38aaaa$export$c977b3e384af9ae1()) {
        return this.isEmpty() ? target.set(0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    containsPoint(point) {
        return point.x < this.min.x || point.x > this.max.x || point.y < this.min.y || point.y > this.max.y ? false : true;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y));
    }
    intersectsBox(box) {
        // using 4 splitting planes to rule out intersections
        return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y ? false : true;
    }
    clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        const clampedPoint = $28c1a1744a38aaaa$var$_vector$2.copy(point).clamp(this.min, this.max);
        return clampedPoint.sub(point).length();
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
class $28c1a1744a38aaaa$export$6f7d5a9418ab2aa3 {
    constructor(min = new $28c1a1744a38aaaa$export$64b5c384219d3699(Infinity, Infinity, Infinity), max = new $28c1a1744a38aaaa$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity)){
        this.isBox3 = true;
        this.min = min;
        this.max = max;
    }
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromArray(array) {
        let minX = Infinity;
        let minY = Infinity;
        let minZ = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        let maxZ = -Infinity;
        for(let i = 0, l = array.length; i < l; i += 3){
            const x = array[i];
            const y = array[i + 1];
            const z = array[i + 2];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (z < minZ) minZ = z;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
            if (z > maxZ) maxZ = z;
        }
        this.min.set(minX, minY, minZ);
        this.max.set(maxX, maxY, maxZ);
        return this;
    }
    // setFromBufferAttribute( attribute ) {
    // 	let minX = + Infinity;
    // 	let minY = + Infinity;
    // 	let minZ = + Infinity;
    // 	let maxX = - Infinity;
    // 	let maxY = - Infinity;
    // 	let maxZ = - Infinity;
    // 	for ( let i = 0, l = attribute.count; i < l; i ++ ) {
    // 		const x = attribute.getX( i );
    // 		const y = attribute.getY( i );
    // 		const z = attribute.getZ( i );
    // 		if ( x < minX ) minX = x;
    // 		if ( y < minY ) minY = y;
    // 		if ( z < minZ ) minZ = z;
    // 		if ( x > maxX ) maxX = x;
    // 		if ( y > maxY ) maxY = y;
    // 		if ( z > maxZ ) maxZ = z;
    // 	}
    // 	this.min.set( minX, minY, minZ );
    // 	this.max.set( maxX, maxY, maxZ );
    // 	return this;
    // }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = $28c1a1744a38aaaa$var$_vector$1.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    setFromObject(object, precise = false) {
        this.makeEmpty();
        return this.expandByObject(object, precise);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = this.min.z = Infinity;
        this.max.x = this.max.y = this.max.z = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
    getCenter(target = new $28c1a1744a38aaaa$export$64b5c384219d3699()) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target = new $28c1a1744a38aaaa$export$64b5c384219d3699()) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    // expandByObject( object, precise = false ) {
    // 	// Computes the world-axis-aligned bounding box of an object (including its children),
    // 	// accounting for both the object's, and children's, world transforms
    // 	object.updateWorldMatrix( false, false );
    // 	const geometry = object.geometry;
    // 	if ( geometry !== undefined ) {
    // 		if ( precise && geometry.attributes != undefined && geometry.attributes.position !== undefined ) {
    // 			const position = geometry.attributes.position;
    // 			for ( let i = 0, l = position.count; i < l; i ++ ) {
    // 				_vector.fromBufferAttribute( position, i ).applyMatrix4( object.matrixWorld );
    // 				this.expandByPoint( _vector );
    // 			}
    // 		} else {
    // 			if ( geometry.boundingBox === null ) {
    // 				geometry.computeBoundingBox();
    // 			}
    // 			_box.copy( geometry.boundingBox );
    // 			_box.applyMatrix4( object.matrixWorld );
    // 			this.union( _box );
    // 		}
    // 	}
    // 	const children = object.children;
    // 	for ( let i = 0, l = children.length; i < l; i ++ ) {
    // 		this.expandByObject( children[ i ], precise );
    // 	}
    // 	return this;
    // }
    containsPoint(point) {
        return point.x < this.min.x || point.x > this.max.x || point.y < this.min.y || point.y > this.max.y || point.z < this.min.z || point.z > this.max.z ? false : true;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y && this.min.z <= box.min.z && box.max.z <= this.max.z;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y), (point.z - this.min.z) / (this.max.z - this.min.z));
    }
    intersectsBox(box) {
        // using 6 splitting planes to rule out intersections.
        return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y || box.max.z < this.min.z || box.min.z > this.max.z ? false : true;
    }
    intersectsSphere(sphere) {
        // Find the point on the AABB closest to the sphere center.
        this.clampPoint(sphere.center, $28c1a1744a38aaaa$var$_vector$1);
        // If that point is inside the sphere, the AABB and sphere intersect.
        return $28c1a1744a38aaaa$var$_vector$1.distanceToSquared(sphere.center) <= sphere.radius * sphere.radius;
    }
    intersectsPlane(plane) {
        // We compute the minimum and maximum dot product values. If those values
        // are on the same side (back or front) of the plane, then there is no intersection.
        let min, max;
        if (plane.normal.x > 0) {
            min = plane.normal.x * this.min.x;
            max = plane.normal.x * this.max.x;
        } else {
            min = plane.normal.x * this.max.x;
            max = plane.normal.x * this.min.x;
        }
        if (plane.normal.y > 0) {
            min += plane.normal.y * this.min.y;
            max += plane.normal.y * this.max.y;
        } else {
            min += plane.normal.y * this.max.y;
            max += plane.normal.y * this.min.y;
        }
        if (plane.normal.z > 0) {
            min += plane.normal.z * this.min.z;
            max += plane.normal.z * this.max.z;
        } else {
            min += plane.normal.z * this.max.z;
            max += plane.normal.z * this.min.z;
        }
        return min <= -plane.constant && max >= -plane.constant;
    }
    intersectsTriangle(triangle) {
        if (this.isEmpty()) return false;
        // compute box center and extents
        this.getCenter($28c1a1744a38aaaa$var$_center);
        $28c1a1744a38aaaa$var$_extents.subVectors(this.max, $28c1a1744a38aaaa$var$_center);
        // translate triangle to aabb origin
        $28c1a1744a38aaaa$var$_v0$1.subVectors(triangle.a, $28c1a1744a38aaaa$var$_center);
        $28c1a1744a38aaaa$var$_v1$3.subVectors(triangle.b, $28c1a1744a38aaaa$var$_center);
        $28c1a1744a38aaaa$var$_v2$1.subVectors(triangle.c, $28c1a1744a38aaaa$var$_center);
        // compute edge vectors for triangle
        $28c1a1744a38aaaa$var$_f0.subVectors($28c1a1744a38aaaa$var$_v1$3, $28c1a1744a38aaaa$var$_v0$1);
        $28c1a1744a38aaaa$var$_f1.subVectors($28c1a1744a38aaaa$var$_v2$1, $28c1a1744a38aaaa$var$_v1$3);
        $28c1a1744a38aaaa$var$_f2.subVectors($28c1a1744a38aaaa$var$_v0$1, $28c1a1744a38aaaa$var$_v2$1);
        // test against axes that are given by cross product combinations of the edges of the triangle and the edges of the aabb
        // make an axis testing of each of the 3 sides of the aabb against each of the 3 sides of the triangle = 9 axis of separation
        // axis_ij = u_i x f_j (u0, u1, u2 = face normals of aabb = x,y,z axes vectors since aabb is axis aligned)
        let axes = [
            0,
            -$28c1a1744a38aaaa$var$_f0.z,
            $28c1a1744a38aaaa$var$_f0.y,
            0,
            -$28c1a1744a38aaaa$var$_f1.z,
            $28c1a1744a38aaaa$var$_f1.y,
            0,
            -$28c1a1744a38aaaa$var$_f2.z,
            $28c1a1744a38aaaa$var$_f2.y,
            $28c1a1744a38aaaa$var$_f0.z,
            0,
            -$28c1a1744a38aaaa$var$_f0.x,
            $28c1a1744a38aaaa$var$_f1.z,
            0,
            -$28c1a1744a38aaaa$var$_f1.x,
            $28c1a1744a38aaaa$var$_f2.z,
            0,
            -$28c1a1744a38aaaa$var$_f2.x,
            -$28c1a1744a38aaaa$var$_f0.y,
            $28c1a1744a38aaaa$var$_f0.x,
            0,
            -$28c1a1744a38aaaa$var$_f1.y,
            $28c1a1744a38aaaa$var$_f1.x,
            0,
            -$28c1a1744a38aaaa$var$_f2.y,
            $28c1a1744a38aaaa$var$_f2.x,
            0
        ];
        if (!$28c1a1744a38aaaa$var$satForAxes(axes, $28c1a1744a38aaaa$var$_v0$1, $28c1a1744a38aaaa$var$_v1$3, $28c1a1744a38aaaa$var$_v2$1, $28c1a1744a38aaaa$var$_extents)) return false;
        // test 3 face normals from the aabb
        axes = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (!$28c1a1744a38aaaa$var$satForAxes(axes, $28c1a1744a38aaaa$var$_v0$1, $28c1a1744a38aaaa$var$_v1$3, $28c1a1744a38aaaa$var$_v2$1, $28c1a1744a38aaaa$var$_extents)) return false;
        // finally testing the face normal of the triangle
        // use already existing triangle edge vectors here
        $28c1a1744a38aaaa$var$_triangleNormal.crossVectors($28c1a1744a38aaaa$var$_f0, $28c1a1744a38aaaa$var$_f1);
        axes = [
            $28c1a1744a38aaaa$var$_triangleNormal.x,
            $28c1a1744a38aaaa$var$_triangleNormal.y,
            $28c1a1744a38aaaa$var$_triangleNormal.z
        ];
        return $28c1a1744a38aaaa$var$satForAxes(axes, $28c1a1744a38aaaa$var$_v0$1, $28c1a1744a38aaaa$var$_v1$3, $28c1a1744a38aaaa$var$_v2$1, $28c1a1744a38aaaa$var$_extents);
    }
    clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        const clampedPoint = $28c1a1744a38aaaa$var$_vector$1.copy(point).clamp(this.min, this.max);
        return clampedPoint.sub(point).length();
    }
    getBoundingSphere(target) {
        this.getCenter(target.center);
        target.radius = this.getSize($28c1a1744a38aaaa$var$_vector$1).length() * 0.5;
        return target;
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        // ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    applyMatrix4(matrix) {
        // transform of empty box is an empty box.
        if (this.isEmpty()) return this;
        // NOTE: I am using a binary pattern to specify all 2^3 combinations below
        $28c1a1744a38aaaa$var$_points[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(matrix); // 000
        $28c1a1744a38aaaa$var$_points[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(matrix); // 001
        $28c1a1744a38aaaa$var$_points[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(matrix); // 010
        $28c1a1744a38aaaa$var$_points[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(matrix); // 011
        $28c1a1744a38aaaa$var$_points[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(matrix); // 100
        $28c1a1744a38aaaa$var$_points[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(matrix); // 101
        $28c1a1744a38aaaa$var$_points[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(matrix); // 110
        $28c1a1744a38aaaa$var$_points[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(matrix); // 111
        this.setFromPoints($28c1a1744a38aaaa$var$_points);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
const $28c1a1744a38aaaa$var$_points = [
    /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699(),
    /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699(),
    /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699(),
    /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699(),
    /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699(),
    /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699(),
    /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699(),
    /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699()
];
const $28c1a1744a38aaaa$var$_vector$1 = /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699();
const $28c1a1744a38aaaa$var$_box$1 = /*@__PURE__*/ new $28c1a1744a38aaaa$export$6f7d5a9418ab2aa3();
// triangle centered vertices
const $28c1a1744a38aaaa$var$_v0$1 = /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699();
const $28c1a1744a38aaaa$var$_v1$3 = /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699();
const $28c1a1744a38aaaa$var$_v2$1 = /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699();
// triangle edge vectors
const $28c1a1744a38aaaa$var$_f0 = /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699();
const $28c1a1744a38aaaa$var$_f1 = /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699();
const $28c1a1744a38aaaa$var$_f2 = /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699();
const $28c1a1744a38aaaa$var$_center = /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699();
const $28c1a1744a38aaaa$var$_extents = /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699();
const $28c1a1744a38aaaa$var$_triangleNormal = /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699();
const $28c1a1744a38aaaa$var$_testAxis = /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699();
function $28c1a1744a38aaaa$var$satForAxes(axes, v0, v1, v2, extents) {
    for(let i = 0, j = axes.length - 3; i <= j; i += 3){
        $28c1a1744a38aaaa$var$_testAxis.fromArray(axes, i);
        // project the aabb onto the separating axis
        const r = extents.x * Math.abs($28c1a1744a38aaaa$var$_testAxis.x) + extents.y * Math.abs($28c1a1744a38aaaa$var$_testAxis.y) + extents.z * Math.abs($28c1a1744a38aaaa$var$_testAxis.z);
        // project all 3 vertices of the triangle onto the separating axis
        const p0 = v0.dot($28c1a1744a38aaaa$var$_testAxis);
        const p1 = v1.dot($28c1a1744a38aaaa$var$_testAxis);
        const p2 = v2.dot($28c1a1744a38aaaa$var$_testAxis);
        // actual test, basically see if either of the most extreme of the triangle points intersects r
        if (Math.max(-Math.max(p0, p1, p2), Math.min(p0, p1, p2)) > r) // points of the projected triangle are outside the projected half-length of the aabb
        // the axis is separating and we can exit
        return false;
    }
    return true;
}
function $28c1a1744a38aaaa$export$22855367bc41ba49(c) {
    return c < 0.04045 ? c * 0.0773993808 : Math.pow(c * 0.9478672986 + 0.0521327014, 2.4);
}
function $28c1a1744a38aaaa$export$cb64753382238f37(c) {
    return c < 0.0031308 ? c * 12.92 : 1.055 * Math.pow(c, 0.41666) - 0.055;
}
// JavaScript RGB-to-RGB transforms, defined as
// FN[InputColorSpace][OutputColorSpace] callback functions.
const $28c1a1744a38aaaa$var$FN = {
    [$28c1a1744a38aaaa$export$561f394b24edfcaa]: {
        [$28c1a1744a38aaaa$export$42429b3acfb233a4]: $28c1a1744a38aaaa$export$22855367bc41ba49
    },
    [$28c1a1744a38aaaa$export$42429b3acfb233a4]: {
        [$28c1a1744a38aaaa$export$561f394b24edfcaa]: $28c1a1744a38aaaa$export$cb64753382238f37
    }
};
const $28c1a1744a38aaaa$export$5e6fd513f44698c = {
    legacyMode: true,
    get workingColorSpace () {
        return $28c1a1744a38aaaa$export$42429b3acfb233a4;
    },
    set workingColorSpace (colorSpace){
        console.warn('THREE.ColorManagement: .workingColorSpace is readonly.');
    },
    convert: function(color, sourceColorSpace, targetColorSpace) {
        if (this.legacyMode || sourceColorSpace === targetColorSpace || !sourceColorSpace || !targetColorSpace) return color;
        if ($28c1a1744a38aaaa$var$FN[sourceColorSpace] && $28c1a1744a38aaaa$var$FN[sourceColorSpace][targetColorSpace] !== undefined) {
            const fn = $28c1a1744a38aaaa$var$FN[sourceColorSpace][targetColorSpace];
            color.r = fn(color.r);
            color.g = fn(color.g);
            color.b = fn(color.b);
            return color;
        }
        throw new Error('Unsupported color space conversion.');
    },
    fromWorkingColorSpace: function(color, targetColorSpace) {
        return this.convert(color, this.workingColorSpace, targetColorSpace);
    },
    toWorkingColorSpace: function(color, sourceColorSpace) {
        return this.convert(color, sourceColorSpace, this.workingColorSpace);
    }
};
const $28c1a1744a38aaaa$var$_colorKeywords = {
    'aliceblue': 0xF0F8FF,
    'antiquewhite': 0xFAEBD7,
    'aqua': 0x00FFFF,
    'aquamarine': 0x7FFFD4,
    'azure': 0xF0FFFF,
    'beige': 0xF5F5DC,
    'bisque': 0xFFE4C4,
    'black': 0x000000,
    'blanchedalmond': 0xFFEBCD,
    'blue': 0x0000FF,
    'blueviolet': 0x8A2BE2,
    'brown': 0xA52A2A,
    'burlywood': 0xDEB887,
    'cadetblue': 0x5F9EA0,
    'chartreuse': 0x7FFF00,
    'chocolate': 0xD2691E,
    'coral': 0xFF7F50,
    'cornflowerblue': 0x6495ED,
    'cornsilk': 0xFFF8DC,
    'crimson': 0xDC143C,
    'cyan': 0x00FFFF,
    'darkblue': 0x00008B,
    'darkcyan': 0x008B8B,
    'darkgoldenrod': 0xB8860B,
    'darkgray': 0xA9A9A9,
    'darkgreen': 0x006400,
    'darkgrey': 0xA9A9A9,
    'darkkhaki': 0xBDB76B,
    'darkmagenta': 0x8B008B,
    'darkolivegreen': 0x556B2F,
    'darkorange': 0xFF8C00,
    'darkorchid': 0x9932CC,
    'darkred': 0x8B0000,
    'darksalmon': 0xE9967A,
    'darkseagreen': 0x8FBC8F,
    'darkslateblue': 0x483D8B,
    'darkslategray': 0x2F4F4F,
    'darkslategrey': 0x2F4F4F,
    'darkturquoise': 0x00CED1,
    'darkviolet': 0x9400D3,
    'deeppink': 0xFF1493,
    'deepskyblue': 0x00BFFF,
    'dimgray': 0x696969,
    'dimgrey': 0x696969,
    'dodgerblue': 0x1E90FF,
    'firebrick': 0xB22222,
    'floralwhite': 0xFFFAF0,
    'forestgreen': 0x228B22,
    'fuchsia': 0xFF00FF,
    'gainsboro': 0xDCDCDC,
    'ghostwhite': 0xF8F8FF,
    'gold': 0xFFD700,
    'goldenrod': 0xDAA520,
    'gray': 0x808080,
    'green': 0x008000,
    'greenyellow': 0xADFF2F,
    'grey': 0x808080,
    'honeydew': 0xF0FFF0,
    'hotpink': 0xFF69B4,
    'indianred': 0xCD5C5C,
    'indigo': 0x4B0082,
    'ivory': 0xFFFFF0,
    'khaki': 0xF0E68C,
    'lavender': 0xE6E6FA,
    'lavenderblush': 0xFFF0F5,
    'lawngreen': 0x7CFC00,
    'lemonchiffon': 0xFFFACD,
    'lightblue': 0xADD8E6,
    'lightcoral': 0xF08080,
    'lightcyan': 0xE0FFFF,
    'lightgoldenrodyellow': 0xFAFAD2,
    'lightgray': 0xD3D3D3,
    'lightgreen': 0x90EE90,
    'lightgrey': 0xD3D3D3,
    'lightpink': 0xFFB6C1,
    'lightsalmon': 0xFFA07A,
    'lightseagreen': 0x20B2AA,
    'lightskyblue': 0x87CEFA,
    'lightslategray': 0x778899,
    'lightslategrey': 0x778899,
    'lightsteelblue': 0xB0C4DE,
    'lightyellow': 0xFFFFE0,
    'lime': 0x00FF00,
    'limegreen': 0x32CD32,
    'linen': 0xFAF0E6,
    'magenta': 0xFF00FF,
    'maroon': 0x800000,
    'mediumaquamarine': 0x66CDAA,
    'mediumblue': 0x0000CD,
    'mediumorchid': 0xBA55D3,
    'mediumpurple': 0x9370DB,
    'mediumseagreen': 0x3CB371,
    'mediumslateblue': 0x7B68EE,
    'mediumspringgreen': 0x00FA9A,
    'mediumturquoise': 0x48D1CC,
    'mediumvioletred': 0xC71585,
    'midnightblue': 0x191970,
    'mintcream': 0xF5FFFA,
    'mistyrose': 0xFFE4E1,
    'moccasin': 0xFFE4B5,
    'navajowhite': 0xFFDEAD,
    'navy': 0x000080,
    'oldlace': 0xFDF5E6,
    'olive': 0x808000,
    'olivedrab': 0x6B8E23,
    'orange': 0xFFA500,
    'orangered': 0xFF4500,
    'orchid': 0xDA70D6,
    'palegoldenrod': 0xEEE8AA,
    'palegreen': 0x98FB98,
    'paleturquoise': 0xAFEEEE,
    'palevioletred': 0xDB7093,
    'papayawhip': 0xFFEFD5,
    'peachpuff': 0xFFDAB9,
    'peru': 0xCD853F,
    'pink': 0xFFC0CB,
    'plum': 0xDDA0DD,
    'powderblue': 0xB0E0E6,
    'purple': 0x800080,
    'rebeccapurple': 0x663399,
    'red': 0xFF0000,
    'rosybrown': 0xBC8F8F,
    'royalblue': 0x4169E1,
    'saddlebrown': 0x8B4513,
    'salmon': 0xFA8072,
    'sandybrown': 0xF4A460,
    'seagreen': 0x2E8B57,
    'seashell': 0xFFF5EE,
    'sienna': 0xA0522D,
    'silver': 0xC0C0C0,
    'skyblue': 0x87CEEB,
    'slateblue': 0x6A5ACD,
    'slategray': 0x708090,
    'slategrey': 0x708090,
    'snow': 0xFFFAFA,
    'springgreen': 0x00FF7F,
    'steelblue': 0x4682B4,
    'tan': 0xD2B48C,
    'teal': 0x008080,
    'thistle': 0xD8BFD8,
    'tomato': 0xFF6347,
    'turquoise': 0x40E0D0,
    'violet': 0xEE82EE,
    'wheat': 0xF5DEB3,
    'white': 0xFFFFFF,
    'whitesmoke': 0xF5F5F5,
    'yellow': 0xFFFF00,
    'yellowgreen': 0x9ACD32
};
const $28c1a1744a38aaaa$var$_rgb = {
    r: 0,
    g: 0,
    b: 0
};
const $28c1a1744a38aaaa$var$_hslA = {
    h: 0,
    s: 0,
    l: 0
};
const $28c1a1744a38aaaa$var$_hslB = {
    h: 0,
    s: 0,
    l: 0
};
function $28c1a1744a38aaaa$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * 6 * (2 / 3 - t);
    return p;
}
function $28c1a1744a38aaaa$var$toComponents(source, target) {
    target.r = source.r;
    target.g = source.g;
    target.b = source.b;
    return target;
}
class $28c1a1744a38aaaa$export$892596cec99bc70e {
    constructor(r, g, b){
        this.isColor = true;
        this.r = 1;
        this.g = 1;
        this.b = 1;
        if (g === undefined && b === undefined) // r is THREE.Color, hex or string
        return this.set(r);
        return this.setRGB(r, g, b);
    }
    set(value) {
        if (value && value.isColor) this.copy(value);
        else if (typeof value === 'number') this.setHex(value);
        else if (typeof value === 'string') this.setStyle(value);
        return this;
    }
    setScalar(scalar) {
        this.r = scalar;
        this.g = scalar;
        this.b = scalar;
        return this;
    }
    setHex(hex, colorSpace1 = $28c1a1744a38aaaa$export$561f394b24edfcaa) {
        hex = Math.floor(hex);
        this.r = (hex >> 16 & 255) / 255;
        this.g = (hex >> 8 & 255) / 255;
        this.b = (hex & 255) / 255;
        $28c1a1744a38aaaa$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
        return this;
    }
    setRGB(r, g, b, colorSpace1 = $28c1a1744a38aaaa$export$5e6fd513f44698c.workingColorSpace) {
        this.r = r;
        this.g = g;
        this.b = b;
        $28c1a1744a38aaaa$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
        return this;
    }
    setHSL(h, s, l, colorSpace1 = $28c1a1744a38aaaa$export$5e6fd513f44698c.workingColorSpace) {
        // h,s,l ranges are in 0.0 - 1.0
        h = $28c1a1744a38aaaa$var$euclideanModulo(h, 1);
        s = $28c1a1744a38aaaa$var$clamp(s, 0, 1);
        l = $28c1a1744a38aaaa$var$clamp(l, 0, 1);
        if (s === 0) this.r = this.g = this.b = l;
        else {
            const p = l <= 0.5 ? l * (1 + s) : l + s - l * s;
            const q = 2 * l - p;
            this.r = $28c1a1744a38aaaa$var$hue2rgb(q, p, h + 1 / 3);
            this.g = $28c1a1744a38aaaa$var$hue2rgb(q, p, h);
            this.b = $28c1a1744a38aaaa$var$hue2rgb(q, p, h - 1 / 3);
        }
        $28c1a1744a38aaaa$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
        return this;
    }
    setStyle(style, colorSpace1 = $28c1a1744a38aaaa$export$561f394b24edfcaa) {
        function handleAlpha(string) {
            if (string === undefined) return;
            if (parseFloat(string) < 1) console.warn('THREE.Color: Alpha component of ' + style + ' will be ignored.');
        }
        let m;
        if (m = /^((?:rgb|hsl)a?)\(([^\)]*)\)/.exec(style)) {
            // rgb / hsl
            let color;
            const name = m[1];
            const components = m[2];
            switch(name){
                case 'rgb':
                case 'rgba':
                    if (color = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(255,0,0) rgba(255,0,0,0.5)
                        this.r = Math.min(255, parseInt(color[1], 10)) / 255;
                        this.g = Math.min(255, parseInt(color[2], 10)) / 255;
                        this.b = Math.min(255, parseInt(color[3], 10)) / 255;
                        $28c1a1744a38aaaa$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
                        handleAlpha(color[4]);
                        return this;
                    }
                    if (color = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)
                        this.r = Math.min(100, parseInt(color[1], 10)) / 100;
                        this.g = Math.min(100, parseInt(color[2], 10)) / 100;
                        this.b = Math.min(100, parseInt(color[3], 10)) / 100;
                        $28c1a1744a38aaaa$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
                        handleAlpha(color[4]);
                        return this;
                    }
                    break;
                case 'hsl':
                case 'hsla':
                    if (color = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // hsl(120,50%,50%) hsla(120,50%,50%,0.5)
                        const h = parseFloat(color[1]) / 360;
                        const s = parseFloat(color[2]) / 100;
                        const l = parseFloat(color[3]) / 100;
                        handleAlpha(color[4]);
                        return this.setHSL(h, s, l, colorSpace1);
                    }
                    break;
            }
        } else if (m = /^\#([A-Fa-f\d]+)$/.exec(style)) {
            // hex color
            const hex = m[1];
            const size = hex.length;
            if (size === 3) {
                // #ff0
                this.r = parseInt(hex.charAt(0) + hex.charAt(0), 16) / 255;
                this.g = parseInt(hex.charAt(1) + hex.charAt(1), 16) / 255;
                this.b = parseInt(hex.charAt(2) + hex.charAt(2), 16) / 255;
                $28c1a1744a38aaaa$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
                return this;
            } else if (size === 6) {
                // #ff0000
                this.r = parseInt(hex.charAt(0) + hex.charAt(1), 16) / 255;
                this.g = parseInt(hex.charAt(2) + hex.charAt(3), 16) / 255;
                this.b = parseInt(hex.charAt(4) + hex.charAt(5), 16) / 255;
                $28c1a1744a38aaaa$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
                return this;
            }
        }
        if (style && style.length > 0) return this.setColorName(style, colorSpace1);
        return this;
    }
    setColorName(style, colorSpace1 = $28c1a1744a38aaaa$export$561f394b24edfcaa) {
        // color keywords
        const hex = $28c1a1744a38aaaa$var$_colorKeywords[style.toLowerCase()];
        if (hex !== undefined) // red
        this.setHex(hex, colorSpace1);
        else // unknown color
        console.warn('THREE.Color: Unknown color ' + style);
        return this;
    }
    clone() {
        return new this.constructor(this.r, this.g, this.b);
    }
    copy(color) {
        this.r = color.r;
        this.g = color.g;
        this.b = color.b;
        return this;
    }
    copySRGBToLinear(color) {
        this.r = $28c1a1744a38aaaa$export$22855367bc41ba49(color.r);
        this.g = $28c1a1744a38aaaa$export$22855367bc41ba49(color.g);
        this.b = $28c1a1744a38aaaa$export$22855367bc41ba49(color.b);
        return this;
    }
    copyLinearToSRGB(color) {
        this.r = $28c1a1744a38aaaa$export$cb64753382238f37(color.r);
        this.g = $28c1a1744a38aaaa$export$cb64753382238f37(color.g);
        this.b = $28c1a1744a38aaaa$export$cb64753382238f37(color.b);
        return this;
    }
    convertSRGBToLinear() {
        this.copySRGBToLinear(this);
        return this;
    }
    convertLinearToSRGB() {
        this.copyLinearToSRGB(this);
        return this;
    }
    getHex(colorSpace1 = $28c1a1744a38aaaa$export$561f394b24edfcaa) {
        $28c1a1744a38aaaa$export$5e6fd513f44698c.fromWorkingColorSpace($28c1a1744a38aaaa$var$toComponents(this, $28c1a1744a38aaaa$var$_rgb), colorSpace1);
        return $28c1a1744a38aaaa$var$clamp($28c1a1744a38aaaa$var$_rgb.r * 255, 0, 255) << 16 ^ $28c1a1744a38aaaa$var$clamp($28c1a1744a38aaaa$var$_rgb.g * 255, 0, 255) << 8 ^ $28c1a1744a38aaaa$var$clamp($28c1a1744a38aaaa$var$_rgb.b * 255, 0, 255) << 0;
    }
    getHexString(colorSpace1 = $28c1a1744a38aaaa$export$561f394b24edfcaa) {
        return ('000000' + this.getHex(colorSpace1).toString(16)).slice(-6);
    }
    getHSL(target, colorSpace1 = $28c1a1744a38aaaa$export$5e6fd513f44698c.workingColorSpace) {
        // h,s,l ranges are in 0.0 - 1.0
        $28c1a1744a38aaaa$export$5e6fd513f44698c.fromWorkingColorSpace($28c1a1744a38aaaa$var$toComponents(this, $28c1a1744a38aaaa$var$_rgb), colorSpace1);
        const r = $28c1a1744a38aaaa$var$_rgb.r, g = $28c1a1744a38aaaa$var$_rgb.g, b = $28c1a1744a38aaaa$var$_rgb.b;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        let hue, saturation;
        const lightness = (min + max) / 2.0;
        if (min === max) {
            hue = 0;
            saturation = 0;
        } else {
            const delta = max - min;
            saturation = lightness <= 0.5 ? delta / (max + min) : delta / (2 - max - min);
            switch(max){
                case r:
                    hue = (g - b) / delta + (g < b ? 6 : 0);
                    break;
                case g:
                    hue = (b - r) / delta + 2;
                    break;
                case b:
                    hue = (r - g) / delta + 4;
                    break;
            }
            hue /= 6;
        }
        target.h = hue;
        target.s = saturation;
        target.l = lightness;
        return target;
    }
    getRGB(target, colorSpace1 = $28c1a1744a38aaaa$export$5e6fd513f44698c.workingColorSpace) {
        $28c1a1744a38aaaa$export$5e6fd513f44698c.fromWorkingColorSpace($28c1a1744a38aaaa$var$toComponents(this, $28c1a1744a38aaaa$var$_rgb), colorSpace1);
        target.r = $28c1a1744a38aaaa$var$_rgb.r;
        target.g = $28c1a1744a38aaaa$var$_rgb.g;
        target.b = $28c1a1744a38aaaa$var$_rgb.b;
        return target;
    }
    getStyle(colorSpace1 = $28c1a1744a38aaaa$export$561f394b24edfcaa) {
        $28c1a1744a38aaaa$export$5e6fd513f44698c.fromWorkingColorSpace($28c1a1744a38aaaa$var$toComponents(this, $28c1a1744a38aaaa$var$_rgb), colorSpace1);
        if (colorSpace1 !== $28c1a1744a38aaaa$export$561f394b24edfcaa) // Requires CSS Color Module Level 4 (https://www.w3.org/TR/css-color-4/).
        return `color(${colorSpace1} ${$28c1a1744a38aaaa$var$_rgb.r} ${$28c1a1744a38aaaa$var$_rgb.g} ${$28c1a1744a38aaaa$var$_rgb.b})`;
        return `rgb(${$28c1a1744a38aaaa$var$_rgb.r * 255 | 0},${$28c1a1744a38aaaa$var$_rgb.g * 255 | 0},${$28c1a1744a38aaaa$var$_rgb.b * 255 | 0})`;
    }
    offsetHSL(h, s, l) {
        this.getHSL($28c1a1744a38aaaa$var$_hslA);
        $28c1a1744a38aaaa$var$_hslA.h += h;
        $28c1a1744a38aaaa$var$_hslA.s += s;
        $28c1a1744a38aaaa$var$_hslA.l += l;
        this.setHSL($28c1a1744a38aaaa$var$_hslA.h, $28c1a1744a38aaaa$var$_hslA.s, $28c1a1744a38aaaa$var$_hslA.l);
        return this;
    }
    add(color) {
        this.r += color.r;
        this.g += color.g;
        this.b += color.b;
        return this;
    }
    addColors(color1, color2) {
        this.r = color1.r + color2.r;
        this.g = color1.g + color2.g;
        this.b = color1.b + color2.b;
        return this;
    }
    addScalar(s) {
        this.r += s;
        this.g += s;
        this.b += s;
        return this;
    }
    sub(color) {
        this.r = Math.max(0, this.r - color.r);
        this.g = Math.max(0, this.g - color.g);
        this.b = Math.max(0, this.b - color.b);
        return this;
    }
    multiply(color) {
        this.r *= color.r;
        this.g *= color.g;
        this.b *= color.b;
        return this;
    }
    multiplyScalar(s) {
        this.r *= s;
        this.g *= s;
        this.b *= s;
        return this;
    }
    lerp(color, alpha) {
        this.r += (color.r - this.r) * alpha;
        this.g += (color.g - this.g) * alpha;
        this.b += (color.b - this.b) * alpha;
        return this;
    }
    lerpColors(color1, color2, alpha) {
        this.r = color1.r + (color2.r - color1.r) * alpha;
        this.g = color1.g + (color2.g - color1.g) * alpha;
        this.b = color1.b + (color2.b - color1.b) * alpha;
        return this;
    }
    lerpHSL(color, alpha) {
        this.getHSL($28c1a1744a38aaaa$var$_hslA);
        color.getHSL($28c1a1744a38aaaa$var$_hslB);
        const h = $28c1a1744a38aaaa$var$lerp($28c1a1744a38aaaa$var$_hslA.h, $28c1a1744a38aaaa$var$_hslB.h, alpha);
        const s = $28c1a1744a38aaaa$var$lerp($28c1a1744a38aaaa$var$_hslA.s, $28c1a1744a38aaaa$var$_hslB.s, alpha);
        const l = $28c1a1744a38aaaa$var$lerp($28c1a1744a38aaaa$var$_hslA.l, $28c1a1744a38aaaa$var$_hslB.l, alpha);
        this.setHSL(h, s, l);
        return this;
    }
    equals(c) {
        return c.r === this.r && c.g === this.g && c.b === this.b;
    }
    fromArray(array, offset = 0) {
        this.r = array[offset];
        this.g = array[offset + 1];
        this.b = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.r;
        array[offset + 1] = this.g;
        array[offset + 2] = this.b;
        return array;
    }
    // fromBufferAttribute( attribute, index ) {
    // 	this.r = attribute.getX( index );
    // 	this.g = attribute.getY( index );
    // 	this.b = attribute.getZ( index );
    // 	if ( attribute.normalized === true ) {
    // 		// assuming Uint8Array
    // 		this.r /= 255;
    // 		this.g /= 255;
    // 		this.b /= 255;
    // 	}
    // 	return this;
    // }
    toJSON() {
        return this.getHex();
    }
    *[Symbol.iterator]() {
        yield this.r;
        yield this.g;
        yield this.b;
    }
}
$28c1a1744a38aaaa$export$892596cec99bc70e.NAMES = $28c1a1744a38aaaa$var$_colorKeywords;
/**
 * Ref: https://en.wikipedia.org/wiki/Cylindrical_coordinate_system
 */ class $28c1a1744a38aaaa$export$287165bb2177f4fd {
    constructor(radius = 1, theta = 0, y = 0){
        this.radius = radius; // distance from the origin to a point in the x-z plane
        this.theta = theta; // counterclockwise angle in the x-z plane measured in radians from the positive z-axis
        this.y = y; // height above the x-z plane
        return this;
    }
    set(radius, theta, y) {
        this.radius = radius;
        this.theta = theta;
        this.y = y;
        return this;
    }
    copy(other) {
        this.radius = other.radius;
        this.theta = other.theta;
        this.y = other.y;
        return this;
    }
    setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + z * z);
        this.theta = Math.atan2(x, z);
        this.y = y;
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $28c1a1744a38aaaa$export$2ae72fc923e5eb5 {
    constructor(){
        $28c1a1744a38aaaa$export$2ae72fc923e5eb5.prototype.isMatrix4 = true;
        this.elements = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ];
    }
    set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
        const te = this.elements;
        te[0] = n11;
        te[4] = n12;
        te[8] = n13;
        te[12] = n14;
        te[1] = n21;
        te[5] = n22;
        te[9] = n23;
        te[13] = n24;
        te[2] = n31;
        te[6] = n32;
        te[10] = n33;
        te[14] = n34;
        te[3] = n41;
        te[7] = n42;
        te[11] = n43;
        te[15] = n44;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    clone() {
        return new $28c1a1744a38aaaa$export$2ae72fc923e5eb5().fromArray(this.elements);
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        te[9] = me[9];
        te[10] = me[10];
        te[11] = me[11];
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        te[15] = me[15];
        return this;
    }
    copyPosition(m) {
        const te = this.elements, me = m.elements;
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        return this;
    }
    setFromMatrix3(m) {
        const me = m.elements;
        this.set(me[0], me[3], me[6], 0, me[1], me[4], me[7], 0, me[2], me[5], me[8], 0, 0, 0, 0, 1);
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrixColumn(this, 0);
        yAxis.setFromMatrixColumn(this, 1);
        zAxis.setFromMatrixColumn(this, 2);
        return this;
    }
    makeBasis(xAxis, yAxis, zAxis) {
        this.set(xAxis.x, yAxis.x, zAxis.x, 0, xAxis.y, yAxis.y, zAxis.y, 0, xAxis.z, yAxis.z, zAxis.z, 0, 0, 0, 0, 1);
        return this;
    }
    extractRotation(m) {
        // this method does not support reflection matrices
        const te = this.elements;
        const me = m.elements;
        const scaleX = 1 / $28c1a1744a38aaaa$var$_v1$2.setFromMatrixColumn(m, 0).length();
        const scaleY = 1 / $28c1a1744a38aaaa$var$_v1$2.setFromMatrixColumn(m, 1).length();
        const scaleZ = 1 / $28c1a1744a38aaaa$var$_v1$2.setFromMatrixColumn(m, 2).length();
        te[0] = me[0] * scaleX;
        te[1] = me[1] * scaleX;
        te[2] = me[2] * scaleX;
        te[3] = 0;
        te[4] = me[4] * scaleY;
        te[5] = me[5] * scaleY;
        te[6] = me[6] * scaleY;
        te[7] = 0;
        te[8] = me[8] * scaleZ;
        te[9] = me[9] * scaleZ;
        te[10] = me[10] * scaleZ;
        te[11] = 0;
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromEuler(euler) {
        const te = this.elements;
        const x = euler.x, y = euler.y, z = euler.z;
        const a = Math.cos(x), b = Math.sin(x);
        const c = Math.cos(y), d = Math.sin(y);
        const e = Math.cos(z), f = Math.sin(z);
        if (euler.order === 'XYZ') {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = -c * f;
            te[8] = d;
            te[1] = af + be * d;
            te[5] = ae - bf * d;
            te[9] = -b * c;
            te[2] = bf - ae * d;
            te[6] = be + af * d;
            te[10] = a * c;
        } else if (euler.order === 'YXZ') {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce + df * b;
            te[4] = de * b - cf;
            te[8] = a * d;
            te[1] = a * f;
            te[5] = a * e;
            te[9] = -b;
            te[2] = cf * b - de;
            te[6] = df + ce * b;
            te[10] = a * c;
        } else if (euler.order === 'ZXY') {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce - df * b;
            te[4] = -a * f;
            te[8] = de + cf * b;
            te[1] = cf + de * b;
            te[5] = a * e;
            te[9] = df - ce * b;
            te[2] = -a * d;
            te[6] = b;
            te[10] = a * c;
        } else if (euler.order === 'ZYX') {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = be * d - af;
            te[8] = ae * d + bf;
            te[1] = c * f;
            te[5] = bf * d + ae;
            te[9] = af * d - be;
            te[2] = -d;
            te[6] = b * c;
            te[10] = a * c;
        } else if (euler.order === 'YZX') {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = bd - ac * f;
            te[8] = bc * f + ad;
            te[1] = f;
            te[5] = a * e;
            te[9] = -b * e;
            te[2] = -d * e;
            te[6] = ad * f + bc;
            te[10] = ac - bd * f;
        } else if (euler.order === 'XZY') {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = -f;
            te[8] = d * e;
            te[1] = ac * f + bd;
            te[5] = a * e;
            te[9] = ad * f - bc;
            te[2] = bc * f - ad;
            te[6] = b * e;
            te[10] = bd * f + ac;
        }
        // bottom row
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        // last column
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromQuaternion(q) {
        return this.compose($28c1a1744a38aaaa$var$_zero, q, $28c1a1744a38aaaa$var$_one);
    }
    lookAt(eye, target, up) {
        const te = this.elements;
        $28c1a1744a38aaaa$var$_z.subVectors(eye, target);
        if ($28c1a1744a38aaaa$var$_z.lengthSq() === 0) // eye and target are in the same position
        $28c1a1744a38aaaa$var$_z.z = 1;
        $28c1a1744a38aaaa$var$_z.normalize();
        $28c1a1744a38aaaa$var$_x.crossVectors(up, $28c1a1744a38aaaa$var$_z);
        if ($28c1a1744a38aaaa$var$_x.lengthSq() === 0) {
            // up and z are parallel
            if (Math.abs(up.z) === 1) $28c1a1744a38aaaa$var$_z.x += 0.0001;
            else $28c1a1744a38aaaa$var$_z.z += 0.0001;
            $28c1a1744a38aaaa$var$_z.normalize();
            $28c1a1744a38aaaa$var$_x.crossVectors(up, $28c1a1744a38aaaa$var$_z);
        }
        $28c1a1744a38aaaa$var$_x.normalize();
        $28c1a1744a38aaaa$var$_y.crossVectors($28c1a1744a38aaaa$var$_z, $28c1a1744a38aaaa$var$_x);
        te[0] = $28c1a1744a38aaaa$var$_x.x;
        te[4] = $28c1a1744a38aaaa$var$_y.x;
        te[8] = $28c1a1744a38aaaa$var$_z.x;
        te[1] = $28c1a1744a38aaaa$var$_x.y;
        te[5] = $28c1a1744a38aaaa$var$_y.y;
        te[9] = $28c1a1744a38aaaa$var$_z.y;
        te[2] = $28c1a1744a38aaaa$var$_x.z;
        te[6] = $28c1a1744a38aaaa$var$_y.z;
        te[10] = $28c1a1744a38aaaa$var$_z.z;
        return this;
    }
    multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[4], a13 = ae[8], a14 = ae[12];
        const a21 = ae[1], a22 = ae[5], a23 = ae[9], a24 = ae[13];
        const a31 = ae[2], a32 = ae[6], a33 = ae[10], a34 = ae[14];
        const a41 = ae[3], a42 = ae[7], a43 = ae[11], a44 = ae[15];
        const b11 = be[0], b12 = be[4], b13 = be[8], b14 = be[12];
        const b21 = be[1], b22 = be[5], b23 = be[9], b24 = be[13];
        const b31 = be[2], b32 = be[6], b33 = be[10], b34 = be[14];
        const b41 = be[3], b42 = be[7], b43 = be[11], b44 = be[15];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
        te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
        te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
        te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
        te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
        te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
        te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
        te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
        te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
        te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
        te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
        te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
        te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
        te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[4] *= s;
        te[8] *= s;
        te[12] *= s;
        te[1] *= s;
        te[5] *= s;
        te[9] *= s;
        te[13] *= s;
        te[2] *= s;
        te[6] *= s;
        te[10] *= s;
        te[14] *= s;
        te[3] *= s;
        te[7] *= s;
        te[11] *= s;
        te[15] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const n11 = te[0], n12 = te[4], n13 = te[8], n14 = te[12];
        const n21 = te[1], n22 = te[5], n23 = te[9], n24 = te[13];
        const n31 = te[2], n32 = te[6], n33 = te[10], n34 = te[14];
        const n41 = te[3], n42 = te[7], n43 = te[11], n44 = te[15];
        //TODO: make this more efficient
        //( based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm )
        return n41 * (+n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34) + n42 * (+n11 * n23 * n34 - n11 * n24 * n33 + n14 * n21 * n33 - n13 * n21 * n34 + n13 * n24 * n31 - n14 * n23 * n31) + n43 * (+n11 * n24 * n32 - n11 * n22 * n34 - n14 * n21 * n32 + n12 * n21 * n34 + n14 * n22 * n31 - n12 * n24 * n31) + n44 * (-n13 * n22 * n31 - n11 * n23 * n32 + n11 * n22 * n33 + n13 * n21 * n32 - n12 * n21 * n33 + n12 * n23 * n31);
    }
    transpose() {
        const te = this.elements;
        let tmp;
        tmp = te[1];
        te[1] = te[4];
        te[4] = tmp;
        tmp = te[2];
        te[2] = te[8];
        te[8] = tmp;
        tmp = te[6];
        te[6] = te[9];
        te[9] = tmp;
        tmp = te[3];
        te[3] = te[12];
        te[12] = tmp;
        tmp = te[7];
        te[7] = te[13];
        te[13] = tmp;
        tmp = te[11];
        te[11] = te[14];
        te[14] = tmp;
        return this;
    }
    setPosition(x, y, z) {
        const te = this.elements;
        if (x.isVector3) {
            te[12] = x.x;
            te[13] = x.y;
            te[14] = x.z;
        } else {
            te[12] = x;
            te[13] = y;
            te[14] = z;
        }
        return this;
    }
    invert() {
        // based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n41 = te[3], n12 = te[4], n22 = te[5], n32 = te[6], n42 = te[7], n13 = te[8], n23 = te[9], n33 = te[10], n43 = te[11], n14 = te[12], n24 = te[13], n34 = te[14], n44 = te[15], t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44, t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44, t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44, t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
        const det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44) * detInv;
        te[2] = (n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44) * detInv;
        te[3] = (n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43) * detInv;
        te[4] = t12 * detInv;
        te[5] = (n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44) * detInv;
        te[6] = (n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44) * detInv;
        te[7] = (n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43) * detInv;
        te[8] = t13 * detInv;
        te[9] = (n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44) * detInv;
        te[10] = (n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44) * detInv;
        te[11] = (n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43) * detInv;
        te[12] = t14 * detInv;
        te[13] = (n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34) * detInv;
        te[14] = (n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34) * detInv;
        te[15] = (n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33) * detInv;
        return this;
    }
    scale(v) {
        const te = this.elements;
        const x = v.x, y = v.y, z = v.z;
        te[0] *= x;
        te[4] *= y;
        te[8] *= z;
        te[1] *= x;
        te[5] *= y;
        te[9] *= z;
        te[2] *= x;
        te[6] *= y;
        te[10] *= z;
        te[3] *= x;
        te[7] *= y;
        te[11] *= z;
        return this;
    }
    getMaxScaleOnAxis() {
        const te = this.elements;
        const scaleXSq = te[0] * te[0] + te[1] * te[1] + te[2] * te[2];
        const scaleYSq = te[4] * te[4] + te[5] * te[5] + te[6] * te[6];
        const scaleZSq = te[8] * te[8] + te[9] * te[9] + te[10] * te[10];
        return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
    }
    makeTranslation(x, y, z) {
        this.set(1, 0, 0, x, 0, 1, 0, y, 0, 0, 1, z, 0, 0, 0, 1);
        return this;
    }
    makeRotationX(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(1, 0, 0, 0, 0, c, -s, 0, 0, s, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationY(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, 0, s, 0, 0, 1, 0, 0, -s, 0, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationZ(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, -s, 0, 0, s, c, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationAxis(axis, angle) {
        // Based on http://www.gamedev.net/reference/articles/article1199.asp
        const c = Math.cos(angle);
        const s = Math.sin(angle);
        const t = 1 - c;
        const x = axis.x, y = axis.y, z = axis.z;
        const tx = t * x, ty = t * y;
        this.set(tx * x + c, tx * y - s * z, tx * z + s * y, 0, tx * y + s * z, ty * y + c, ty * z - s * x, 0, tx * z - s * y, ty * z + s * x, t * z * z + c, 0, 0, 0, 0, 1);
        return this;
    }
    makeScale(x, y, z) {
        this.set(x, 0, 0, 0, 0, y, 0, 0, 0, 0, z, 0, 0, 0, 0, 1);
        return this;
    }
    makeShear(xy, xz, yx, yz, zx, zy) {
        this.set(1, yx, zx, 0, xy, 1, zy, 0, xz, yz, 1, 0, 0, 0, 0, 1);
        return this;
    }
    compose(position, quaternion, scale) {
        const te = this.elements;
        const x = quaternion._x, y = quaternion._y, z = quaternion._z, w = quaternion._w;
        const x2 = x + x, y2 = y + y, z2 = z + z;
        const xx = x * x2, xy = x * y2, xz = x * z2;
        const yy = y * y2, yz = y * z2, zz = z * z2;
        const wx = w * x2, wy = w * y2, wz = w * z2;
        const sx = scale.x, sy = scale.y, sz = scale.z;
        te[0] = (1 - (yy + zz)) * sx;
        te[1] = (xy + wz) * sx;
        te[2] = (xz - wy) * sx;
        te[3] = 0;
        te[4] = (xy - wz) * sy;
        te[5] = (1 - (xx + zz)) * sy;
        te[6] = (yz + wx) * sy;
        te[7] = 0;
        te[8] = (xz + wy) * sz;
        te[9] = (yz - wx) * sz;
        te[10] = (1 - (xx + yy)) * sz;
        te[11] = 0;
        te[12] = position.x;
        te[13] = position.y;
        te[14] = position.z;
        te[15] = 1;
        return this;
    }
    decompose(position, quaternion, scale) {
        const te = this.elements;
        let sx = $28c1a1744a38aaaa$var$_v1$2.set(te[0], te[1], te[2]).length();
        const sy = $28c1a1744a38aaaa$var$_v1$2.set(te[4], te[5], te[6]).length();
        const sz = $28c1a1744a38aaaa$var$_v1$2.set(te[8], te[9], te[10]).length();
        // if determine is negative, we need to invert one scale
        const det = this.determinant();
        if (det < 0) sx = -sx;
        position.x = te[12];
        position.y = te[13];
        position.z = te[14];
        // scale the rotation part
        $28c1a1744a38aaaa$var$_m1.copy(this);
        const invSX = 1 / sx;
        const invSY = 1 / sy;
        const invSZ = 1 / sz;
        $28c1a1744a38aaaa$var$_m1.elements[0] *= invSX;
        $28c1a1744a38aaaa$var$_m1.elements[1] *= invSX;
        $28c1a1744a38aaaa$var$_m1.elements[2] *= invSX;
        $28c1a1744a38aaaa$var$_m1.elements[4] *= invSY;
        $28c1a1744a38aaaa$var$_m1.elements[5] *= invSY;
        $28c1a1744a38aaaa$var$_m1.elements[6] *= invSY;
        $28c1a1744a38aaaa$var$_m1.elements[8] *= invSZ;
        $28c1a1744a38aaaa$var$_m1.elements[9] *= invSZ;
        $28c1a1744a38aaaa$var$_m1.elements[10] *= invSZ;
        quaternion.setFromRotationMatrix($28c1a1744a38aaaa$var$_m1);
        scale.x = sx;
        scale.y = sy;
        scale.z = sz;
        return this;
    }
    makePerspective(left, right, top, bottom, near, far) {
        const te = this.elements;
        const x = 2 * near / (right - left);
        const y = 2 * near / (top - bottom);
        const a = (right + left) / (right - left);
        const b = (top + bottom) / (top - bottom);
        const c = -(far + near) / (far - near);
        const d = -2 * far * near / (far - near);
        te[0] = x;
        te[4] = 0;
        te[8] = a;
        te[12] = 0;
        te[1] = 0;
        te[5] = y;
        te[9] = b;
        te[13] = 0;
        te[2] = 0;
        te[6] = 0;
        te[10] = c;
        te[14] = d;
        te[3] = 0;
        te[7] = 0;
        te[11] = -1;
        te[15] = 0;
        return this;
    }
    makeOrthographic(left, right, top, bottom, near, far) {
        const te = this.elements;
        const w = 1.0 / (right - left);
        const h = 1.0 / (top - bottom);
        const p = 1.0 / (far - near);
        const x = (right + left) * w;
        const y = (top + bottom) * h;
        const z = (far + near) * p;
        te[0] = 2 * w;
        te[4] = 0;
        te[8] = 0;
        te[12] = -x;
        te[1] = 0;
        te[5] = 2 * h;
        te[9] = 0;
        te[13] = -y;
        te[2] = 0;
        te[6] = 0;
        te[10] = -2 * p;
        te[14] = -z;
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        te[15] = 1;
        return this;
    }
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 16; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 16; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        array[offset + 9] = te[9];
        array[offset + 10] = te[10];
        array[offset + 11] = te[11];
        array[offset + 12] = te[12];
        array[offset + 13] = te[13];
        array[offset + 14] = te[14];
        array[offset + 15] = te[15];
        return array;
    }
}
const $28c1a1744a38aaaa$var$_v1$2 = /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699();
const $28c1a1744a38aaaa$var$_m1 = /*@__PURE__*/ new $28c1a1744a38aaaa$export$2ae72fc923e5eb5();
const $28c1a1744a38aaaa$var$_zero = /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699(0, 0, 0);
const $28c1a1744a38aaaa$var$_one = /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699(1, 1, 1);
const $28c1a1744a38aaaa$var$_x = /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699();
const $28c1a1744a38aaaa$var$_y = /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699();
const $28c1a1744a38aaaa$var$_z = /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699();
const $28c1a1744a38aaaa$var$_matrix = /*@__PURE__*/ new $28c1a1744a38aaaa$export$2ae72fc923e5eb5();
const $28c1a1744a38aaaa$var$_quaternion = /*@__PURE__*/ new $28c1a1744a38aaaa$export$23d6a54f0bbc85a3();
class $28c1a1744a38aaaa$export$d93cc409a0768c5f {
    constructor(x = 0, y = 0, z = 0, order = $28c1a1744a38aaaa$export$d93cc409a0768c5f.DefaultOrder){
        this.isEuler = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get order() {
        return this._order;
    }
    set order(value) {
        this._order = value;
        this._onChangeCallback();
    }
    set(x, y, z, order = this._order) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._order);
    }
    copy(euler) {
        this._x = euler._x;
        this._y = euler._y;
        this._z = euler._z;
        this._order = euler._order;
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m, order = this._order, update = true) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements;
        const m11 = te[0], m12 = te[4], m13 = te[8];
        const m21 = te[1], m22 = te[5], m23 = te[9];
        const m31 = te[2], m32 = te[6], m33 = te[10];
        switch(order){
            case 'XYZ':
                this._y = Math.asin($28c1a1744a38aaaa$var$clamp(m13, -1, 1));
                if (Math.abs(m13) < 0.9999999) {
                    this._x = Math.atan2(-m23, m33);
                    this._z = Math.atan2(-m12, m11);
                } else {
                    this._x = Math.atan2(m32, m22);
                    this._z = 0;
                }
                break;
            case 'YXZ':
                this._x = Math.asin(-$28c1a1744a38aaaa$var$clamp(m23, -1, 1));
                if (Math.abs(m23) < 0.9999999) {
                    this._y = Math.atan2(m13, m33);
                    this._z = Math.atan2(m21, m22);
                } else {
                    this._y = Math.atan2(-m31, m11);
                    this._z = 0;
                }
                break;
            case 'ZXY':
                this._x = Math.asin($28c1a1744a38aaaa$var$clamp(m32, -1, 1));
                if (Math.abs(m32) < 0.9999999) {
                    this._y = Math.atan2(-m31, m33);
                    this._z = Math.atan2(-m12, m22);
                } else {
                    this._y = 0;
                    this._z = Math.atan2(m21, m11);
                }
                break;
            case 'ZYX':
                this._y = Math.asin(-$28c1a1744a38aaaa$var$clamp(m31, -1, 1));
                if (Math.abs(m31) < 0.9999999) {
                    this._x = Math.atan2(m32, m33);
                    this._z = Math.atan2(m21, m11);
                } else {
                    this._x = 0;
                    this._z = Math.atan2(-m12, m22);
                }
                break;
            case 'YZX':
                this._z = Math.asin($28c1a1744a38aaaa$var$clamp(m21, -1, 1));
                if (Math.abs(m21) < 0.9999999) {
                    this._x = Math.atan2(-m23, m22);
                    this._y = Math.atan2(-m31, m11);
                } else {
                    this._x = 0;
                    this._y = Math.atan2(m13, m33);
                }
                break;
            case 'XZY':
                this._z = Math.asin(-$28c1a1744a38aaaa$var$clamp(m12, -1, 1));
                if (Math.abs(m12) < 0.9999999) {
                    this._x = Math.atan2(m32, m22);
                    this._y = Math.atan2(m13, m11);
                } else {
                    this._x = Math.atan2(-m23, m33);
                    this._y = 0;
                }
                break;
            default:
                console.warn('THREE.Euler: .setFromRotationMatrix() encountered an unknown order: ' + order);
        }
        this._order = order;
        if (update === true) this._onChangeCallback();
        return this;
    }
    setFromQuaternion(q, order, update) {
        $28c1a1744a38aaaa$var$_matrix.makeRotationFromQuaternion(q);
        return this.setFromRotationMatrix($28c1a1744a38aaaa$var$_matrix, order, update);
    }
    setFromVector3(v, order = this._order) {
        return this.set(v.x, v.y, v.z, order);
    }
    reorder(newOrder) {
        // WARNING: this discards revolution information -bhouston
        $28c1a1744a38aaaa$var$_quaternion.setFromEuler(this);
        return this.setFromQuaternion($28c1a1744a38aaaa$var$_quaternion, newOrder);
    }
    equals(euler) {
        return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
    }
    fromArray(array) {
        this._x = array[0];
        this._y = array[1];
        this._z = array[2];
        if (array[3] !== undefined) this._order = array[3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._order;
        return array;
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._order;
    }
    // @deprecated since r138, 02cf0df1cb4575d5842fef9c85bb5a89fe020d53
    toVector3() {
        console.error('THREE.Euler: .toVector3() has been removed. Use Vector3.setFromEuler() instead');
    }
}
$28c1a1744a38aaaa$export$d93cc409a0768c5f.DefaultOrder = 'XYZ';
$28c1a1744a38aaaa$export$d93cc409a0768c5f.RotationOrders = [
    'XYZ',
    'YZX',
    'ZXY',
    'XZY',
    'YXZ',
    'ZYX'
];
/**
 * Abstract base class of interpolants over parametric samples.
 *
 * The parameter domain is one dimensional, typically the time or a path
 * along a curve defined by the data.
 *
 * The sample values can have any dimensionality and derived classes may
 * apply special interpretations to the data.
 *
 * This class provides the interval seek in a Template Method, deferring
 * the actual interpolation to derived classes.
 *
 * Time complexity is O(1) for linear access crossing at most two points
 * and O(log N) for random access, where N is the number of positions.
 *
 * References:
 *
 * 		http://www.oodesign.com/template-method-pattern.html
 *
 */ class $28c1a1744a38aaaa$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        this.parameterPositions = parameterPositions;
        this._cachedIndex = 0;
        this.resultBuffer = resultBuffer !== undefined ? resultBuffer : new sampleValues.constructor(sampleSize);
        this.sampleValues = sampleValues;
        this.valueSize = sampleSize;
        this.settings = null;
        this.DefaultSettings_ = {};
    }
    evaluate(t) {
        const pp = this.parameterPositions;
        let i1 = this._cachedIndex, t1 = pp[i1], t0 = pp[i1 - 1];
        validate_interval: {
            seek: {
                let right;
                linear_scan: {
                    //- See http://jsperf.com/comparison-to-undefined/3
                    //- slower code:
                    //-
                    //- 				if ( t >= t1 || t1 === undefined ) {
                    forward_scan: if (!(t < t1)) {
                        for(let giveUpAt = i1 + 2;;){
                            if (t1 === undefined) {
                                if (t < t0) break forward_scan;
                                // after end
                                i1 = pp.length;
                                this._cachedIndex = i1;
                                return this.copySampleValue_(i1 - 1);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t0 = t1;
                            t1 = pp[++i1];
                            if (t < t1) break seek;
                        }
                        // prepare binary search on the right side of the index
                        right = pp.length;
                        break linear_scan;
                    }
                    //- slower code:
                    //-					if ( t < t0 || t0 === undefined ) {
                    if (!(t >= t0)) {
                        // looping?
                        const t1global = pp[1];
                        if (t < t1global) {
                            i1 = 2; // + 1, using the scan for the details
                            t0 = t1global;
                        }
                        // linear reverse scan
                        for(let giveUpAt = i1 - 2;;){
                            if (t0 === undefined) {
                                // before start
                                this._cachedIndex = 0;
                                return this.copySampleValue_(0);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t1 = t0;
                            t0 = pp[--i1 - 1];
                            if (t >= t0) break seek;
                        }
                        // prepare binary search on the left side of the index
                        right = i1;
                        i1 = 0;
                        break linear_scan;
                    }
                    break validate_interval;
                } // linear scan
                // binary search
                while(i1 < right){
                    const mid = i1 + right >>> 1;
                    if (t < pp[mid]) right = mid;
                    else i1 = mid + 1;
                }
                t1 = pp[i1];
                t0 = pp[i1 - 1];
                // check boundary cases, again
                if (t0 === undefined) {
                    this._cachedIndex = 0;
                    return this.copySampleValue_(0);
                }
                if (t1 === undefined) {
                    i1 = pp.length;
                    this._cachedIndex = i1;
                    return this.copySampleValue_(i1 - 1);
                }
            } // seek
            this._cachedIndex = i1;
            this.intervalChanged_(i1, t0, t1);
        } // validate_interval
        return this.interpolate_(i1, t0, t, t1);
    }
    getSettings_() {
        return this.settings || this.DefaultSettings_;
    }
    copySampleValue_(index) {
        // copies a sample value to the result buffer
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset = index * stride;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset + i];
        return result;
    }
    // Template methods for derived classes:
    interpolate_() {
        throw new Error('call to abstract method');
    // implementations shall return this.resultBuffer
    }
    intervalChanged_() {
    // empty
    }
}
const $28c1a1744a38aaaa$var$_startP = /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699();
const $28c1a1744a38aaaa$var$_startEnd = /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699();
class $28c1a1744a38aaaa$export$e0ba6359f1954fd3 {
    constructor(start = new $28c1a1744a38aaaa$export$64b5c384219d3699(), end = new $28c1a1744a38aaaa$export$64b5c384219d3699()){
        this.start = start;
        this.end = end;
    }
    set(start, end) {
        this.start.copy(start);
        this.end.copy(end);
        return this;
    }
    copy(line) {
        this.start.copy(line.start);
        this.end.copy(line.end);
        return this;
    }
    getCenter(target) {
        return target.addVectors(this.start, this.end).multiplyScalar(0.5);
    }
    delta(target) {
        return target.subVectors(this.end, this.start);
    }
    distanceSq() {
        return this.start.distanceToSquared(this.end);
    }
    distance() {
        return this.start.distanceTo(this.end);
    }
    at(t, target) {
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    closestPointToPointParameter(point, clampToLine) {
        $28c1a1744a38aaaa$var$_startP.subVectors(point, this.start);
        $28c1a1744a38aaaa$var$_startEnd.subVectors(this.end, this.start);
        const startEnd2 = $28c1a1744a38aaaa$var$_startEnd.dot($28c1a1744a38aaaa$var$_startEnd);
        const startEnd_startP = $28c1a1744a38aaaa$var$_startEnd.dot($28c1a1744a38aaaa$var$_startP);
        let t = startEnd_startP / startEnd2;
        if (clampToLine) t = $28c1a1744a38aaaa$var$clamp(t, 0, 1);
        return t;
    }
    closestPointToPoint(point, clampToLine, target) {
        const t = this.closestPointToPointParameter(point, clampToLine);
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    applyMatrix4(matrix) {
        this.start.applyMatrix4(matrix);
        this.end.applyMatrix4(matrix);
        return this;
    }
    equals(line) {
        return line.start.equals(this.start) && line.end.equals(this.end);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $28c1a1744a38aaaa$export$8ff26dafa08918 {
    constructor(){
        $28c1a1744a38aaaa$export$8ff26dafa08918.prototype.isMatrix3 = true;
        this.elements = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
    }
    set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
        const te = this.elements;
        te[0] = n11;
        te[1] = n21;
        te[2] = n31;
        te[3] = n12;
        te[4] = n22;
        te[5] = n32;
        te[6] = n13;
        te[7] = n23;
        te[8] = n33;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 1, 0, 0, 0, 1);
        return this;
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrix3Column(this, 0);
        yAxis.setFromMatrix3Column(this, 1);
        zAxis.setFromMatrix3Column(this, 2);
        return this;
    }
    setFromMatrix4(m) {
        const me = m.elements;
        this.set(me[0], me[4], me[8], me[1], me[5], me[9], me[2], me[6], me[10]);
        return this;
    }
    multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[3], a13 = ae[6];
        const a21 = ae[1], a22 = ae[4], a23 = ae[7];
        const a31 = ae[2], a32 = ae[5], a33 = ae[8];
        const b11 = be[0], b12 = be[3], b13 = be[6];
        const b21 = be[1], b22 = be[4], b23 = be[7];
        const b31 = be[2], b32 = be[5], b33 = be[8];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31;
        te[3] = a11 * b12 + a12 * b22 + a13 * b32;
        te[6] = a11 * b13 + a12 * b23 + a13 * b33;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31;
        te[4] = a21 * b12 + a22 * b22 + a23 * b32;
        te[7] = a21 * b13 + a22 * b23 + a23 * b33;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31;
        te[5] = a31 * b12 + a32 * b22 + a33 * b32;
        te[8] = a31 * b13 + a32 * b23 + a33 * b33;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[3] *= s;
        te[6] *= s;
        te[1] *= s;
        te[4] *= s;
        te[7] *= s;
        te[2] *= s;
        te[5] *= s;
        te[8] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const a = te[0], b = te[1], c = te[2], d = te[3], e = te[4], f = te[5], g = te[6], h = te[7], i = te[8];
        return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
    }
    invert() {
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n12 = te[3], n22 = te[4], n32 = te[5], n13 = te[6], n23 = te[7], n33 = te[8], t11 = n33 * n22 - n32 * n23, t12 = n32 * n13 - n33 * n12, t13 = n23 * n12 - n22 * n13, det = n11 * t11 + n21 * t12 + n31 * t13;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n31 * n23 - n33 * n21) * detInv;
        te[2] = (n32 * n21 - n31 * n22) * detInv;
        te[3] = t12 * detInv;
        te[4] = (n33 * n11 - n31 * n13) * detInv;
        te[5] = (n31 * n12 - n32 * n11) * detInv;
        te[6] = t13 * detInv;
        te[7] = (n21 * n13 - n23 * n11) * detInv;
        te[8] = (n22 * n11 - n21 * n12) * detInv;
        return this;
    }
    transpose() {
        let tmp;
        const m = this.elements;
        tmp = m[1];
        m[1] = m[3];
        m[3] = tmp;
        tmp = m[2];
        m[2] = m[6];
        m[6] = tmp;
        tmp = m[5];
        m[5] = m[7];
        m[7] = tmp;
        return this;
    }
    getNormalMatrix(matrix4) {
        return this.setFromMatrix4(matrix4).invert().transpose();
    }
    transposeIntoArray(r) {
        const m = this.elements;
        r[0] = m[0];
        r[1] = m[3];
        r[2] = m[6];
        r[3] = m[1];
        r[4] = m[4];
        r[5] = m[7];
        r[6] = m[2];
        r[7] = m[5];
        r[8] = m[8];
        return this;
    }
    setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {
        const c = Math.cos(rotation);
        const s = Math.sin(rotation);
        this.set(sx * c, sx * s, -sx * (c * cx + s * cy) + cx + tx, -sy * s, sy * c, -sy * (-s * cx + c * cy) + cy + ty, 0, 0, 1);
        return this;
    }
    //
    scale(sx, sy) {
        this.premultiply($28c1a1744a38aaaa$var$_m3.makeScale(sx, sy));
        return this;
    }
    rotate(theta) {
        this.premultiply($28c1a1744a38aaaa$var$_m3.makeRotation(-theta));
        return this;
    }
    translate(tx, ty) {
        this.premultiply($28c1a1744a38aaaa$var$_m3.makeTranslation(tx, ty));
        return this;
    }
    // for 2D Transforms
    makeTranslation(x, y) {
        this.set(1, 0, x, 0, 1, y, 0, 0, 1);
        return this;
    }
    makeRotation(theta) {
        // counterclockwise
        const c = Math.cos(theta);
        const s = Math.sin(theta);
        this.set(c, -s, 0, s, c, 0, 0, 0, 1);
        return this;
    }
    makeScale(x, y) {
        this.set(x, 0, 0, 0, y, 0, 0, 0, 1);
        return this;
    }
    //
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 9; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 9; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        return array;
    }
    clone() {
        return new this.constructor().fromArray(this.elements);
    }
}
const $28c1a1744a38aaaa$var$_m3 = /*@__PURE__*/ new $28c1a1744a38aaaa$export$8ff26dafa08918();
const $28c1a1744a38aaaa$var$_vector1 = /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699();
const $28c1a1744a38aaaa$var$_vector2 = /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699();
const $28c1a1744a38aaaa$var$_normalMatrix = /*@__PURE__*/ new $28c1a1744a38aaaa$export$8ff26dafa08918();
class $28c1a1744a38aaaa$export$7ff5ac152ef991b0 {
    constructor(normal = new $28c1a1744a38aaaa$export$64b5c384219d3699(1, 0, 0), constant = 0){
        this.isPlane = true;
        // normal is assumed to be normalized
        this.normal = normal;
        this.constant = constant;
    }
    set(normal, constant) {
        this.normal.copy(normal);
        this.constant = constant;
        return this;
    }
    setComponents(x, y, z, w) {
        this.normal.set(x, y, z);
        this.constant = w;
        return this;
    }
    setFromNormalAndCoplanarPoint(normal, point) {
        this.normal.copy(normal);
        this.constant = -point.dot(this.normal);
        return this;
    }
    setFromCoplanarPoints(a, b, c) {
        const normal = $28c1a1744a38aaaa$var$_vector1.subVectors(c, b).cross($28c1a1744a38aaaa$var$_vector2.subVectors(a, b)).normalize();
        // Q: should an error be thrown if normal is zero (e.g. degenerate plane)?
        this.setFromNormalAndCoplanarPoint(normal, a);
        return this;
    }
    copy(plane) {
        this.normal.copy(plane.normal);
        this.constant = plane.constant;
        return this;
    }
    normalize() {
        // Note: will lead to a divide by zero if the plane is invalid.
        const inverseNormalLength = 1.0 / this.normal.length();
        this.normal.multiplyScalar(inverseNormalLength);
        this.constant *= inverseNormalLength;
        return this;
    }
    negate() {
        this.constant *= -1;
        this.normal.negate();
        return this;
    }
    distanceToPoint(point) {
        return this.normal.dot(point) + this.constant;
    }
    distanceToSphere(sphere) {
        return this.distanceToPoint(sphere.center) - sphere.radius;
    }
    projectPoint(point, target) {
        return target.copy(this.normal).multiplyScalar(-this.distanceToPoint(point)).add(point);
    }
    intersectLine(line, target) {
        const direction = line.delta($28c1a1744a38aaaa$var$_vector1);
        const denominator = this.normal.dot(direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (this.distanceToPoint(line.start) === 0) return target.copy(line.start);
            // Unsure if this is the correct method to handle this case.
            return null;
        }
        const t = -(line.start.dot(this.normal) + this.constant) / denominator;
        if (t < 0 || t > 1) return null;
        return target.copy(direction).multiplyScalar(t).add(line.start);
    }
    intersectsLine(line) {
        // Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.
        const startSign = this.distanceToPoint(line.start);
        const endSign = this.distanceToPoint(line.end);
        return startSign < 0 && endSign > 0 || endSign < 0 && startSign > 0;
    }
    intersectsBox(box) {
        return box.intersectsPlane(this);
    }
    intersectsSphere(sphere) {
        return sphere.intersectsPlane(this);
    }
    coplanarPoint(target) {
        return target.copy(this.normal).multiplyScalar(-this.constant);
    }
    applyMatrix4(matrix, optionalNormalMatrix) {
        const normalMatrix = optionalNormalMatrix || $28c1a1744a38aaaa$var$_normalMatrix.getNormalMatrix(matrix);
        const referencePoint = this.coplanarPoint($28c1a1744a38aaaa$var$_vector1).applyMatrix4(matrix);
        const normal = this.normal.applyMatrix3(normalMatrix).normalize();
        this.constant = -referencePoint.dot(normal);
        return this;
    }
    translate(offset) {
        this.constant -= offset.dot(this.normal);
        return this;
    }
    equals(plane) {
        return plane.normal.equals(this.normal) && plane.constant === this.constant;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $28c1a1744a38aaaa$var$_vector = /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699();
const $28c1a1744a38aaaa$var$_segCenter = /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699();
const $28c1a1744a38aaaa$var$_segDir = /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699();
const $28c1a1744a38aaaa$var$_diff = /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699();
const $28c1a1744a38aaaa$var$_edge1 = /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699();
const $28c1a1744a38aaaa$var$_edge2 = /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699();
const $28c1a1744a38aaaa$var$_normal = /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699();
class $28c1a1744a38aaaa$export$a186db52eed6d40e {
    constructor(origin = new $28c1a1744a38aaaa$export$64b5c384219d3699(), direction = new $28c1a1744a38aaaa$export$64b5c384219d3699(0, 0, -1)){
        this.origin = origin;
        this.direction = direction;
    }
    set(origin, direction) {
        this.origin.copy(origin);
        this.direction.copy(direction);
        return this;
    }
    copy(ray) {
        this.origin.copy(ray.origin);
        this.direction.copy(ray.direction);
        return this;
    }
    at(t, target = new $28c1a1744a38aaaa$export$64b5c384219d3699()) {
        return target.copy(this.direction).multiplyScalar(t).add(this.origin);
    }
    lookAt(v) {
        this.direction.copy(v).sub(this.origin).normalize();
        return this;
    }
    recast(t) {
        this.origin.copy(this.at(t, $28c1a1744a38aaaa$var$_vector));
        return this;
    }
    closestPointToPoint(point, target = new $28c1a1744a38aaaa$export$64b5c384219d3699()) {
        target.subVectors(point, this.origin);
        const directionDistance = target.dot(this.direction);
        if (directionDistance < 0) return target.copy(this.origin);
        return target.copy(this.direction).multiplyScalar(directionDistance).add(this.origin);
    }
    distanceToPoint(point) {
        return Math.sqrt(this.distanceSqToPoint(point));
    }
    distanceSqToPoint(point) {
        const directionDistance = $28c1a1744a38aaaa$var$_vector.subVectors(point, this.origin).dot(this.direction);
        // point behind the ray
        if (directionDistance < 0) return this.origin.distanceToSquared(point);
        $28c1a1744a38aaaa$var$_vector.copy(this.direction).multiplyScalar(directionDistance).add(this.origin);
        return $28c1a1744a38aaaa$var$_vector.distanceToSquared(point);
    }
    distanceSqToSegment(v0, v1, optionalPointOnRay, optionalPointOnSegment) {
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteDistRaySegment.h
        // It returns the min distance between the ray and the segment
        // defined by v0 and v1
        // It can also set two optional targets :
        // - The closest point on the ray
        // - The closest point on the segment
        $28c1a1744a38aaaa$var$_segCenter.copy(v0).add(v1).multiplyScalar(0.5);
        $28c1a1744a38aaaa$var$_segDir.copy(v1).sub(v0).normalize();
        $28c1a1744a38aaaa$var$_diff.copy(this.origin).sub($28c1a1744a38aaaa$var$_segCenter);
        const segExtent = v0.distanceTo(v1) * 0.5;
        const a01 = -this.direction.dot($28c1a1744a38aaaa$var$_segDir);
        const b0 = $28c1a1744a38aaaa$var$_diff.dot(this.direction);
        const b1 = -$28c1a1744a38aaaa$var$_diff.dot($28c1a1744a38aaaa$var$_segDir);
        const c = $28c1a1744a38aaaa$var$_diff.lengthSq();
        const det = Math.abs(1 - a01 * a01);
        let s0, s1, sqrDist, extDet;
        if (det > 0) {
            // The ray and segment are not parallel.
            s0 = a01 * b1 - b0;
            s1 = a01 * b0 - b1;
            extDet = segExtent * det;
            if (s0 >= 0) {
                if (s1 >= -extDet) {
                    if (s1 <= extDet) {
                        // region 0
                        // Minimum at interior points of ray and segment.
                        const invDet = 1 / det;
                        s0 *= invDet;
                        s1 *= invDet;
                        sqrDist = s0 * (s0 + a01 * s1 + 2 * b0) + s1 * (a01 * s0 + s1 + 2 * b1) + c;
                    } else {
                        // region 1
                        s1 = segExtent;
                        s0 = Math.max(0, -(a01 * s1 + b0));
                        sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                    }
                } else {
                    // region 5
                    s1 = -segExtent;
                    s0 = Math.max(0, -(a01 * s1 + b0));
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            } else {
                if (s1 <= -extDet) {
                    // region 4
                    s0 = Math.max(0, -(-a01 * segExtent + b0));
                    s1 = s0 > 0 ? -segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                } else if (s1 <= extDet) {
                    // region 3
                    s0 = 0;
                    s1 = Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = s1 * (s1 + 2 * b1) + c;
                } else {
                    // region 2
                    s0 = Math.max(0, -(a01 * segExtent + b0));
                    s1 = s0 > 0 ? segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            }
        } else {
            // Ray and segment are parallel.
            s1 = a01 > 0 ? -segExtent : segExtent;
            s0 = Math.max(0, -(a01 * s1 + b0));
            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
        }
        if (optionalPointOnRay) optionalPointOnRay.copy(this.direction).multiplyScalar(s0).add(this.origin);
        if (optionalPointOnSegment) optionalPointOnSegment.copy($28c1a1744a38aaaa$var$_segDir).multiplyScalar(s1).add($28c1a1744a38aaaa$var$_segCenter);
        return sqrDist;
    }
    intersectSphere(sphere, target = new $28c1a1744a38aaaa$export$64b5c384219d3699()) {
        $28c1a1744a38aaaa$var$_vector.subVectors(sphere.center, this.origin);
        const tca = $28c1a1744a38aaaa$var$_vector.dot(this.direction);
        const d2 = $28c1a1744a38aaaa$var$_vector.dot($28c1a1744a38aaaa$var$_vector) - tca * tca;
        const radius2 = sphere.radius * sphere.radius;
        if (d2 > radius2) return null;
        const thc = Math.sqrt(radius2 - d2);
        // t0 = first intersect point - entrance on front of sphere
        const t0 = tca - thc;
        // t1 = second intersect point - exit point on back of sphere
        const t1 = tca + thc;
        // test to see if both t0 and t1 are behind the ray - if so, return null
        if (t0 < 0 && t1 < 0) return null;
        // test to see if t0 is behind the ray:
        // if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
        // in order to always return an intersect point that is in front of the ray.
        if (t0 < 0) return this.at(t1, target);
        // else t0 is in front of the ray, so return the first collision point scaled by t0
        return this.at(t0, target);
    }
    intersectsSphere(sphere) {
        return this.distanceSqToPoint(sphere.center) <= sphere.radius * sphere.radius;
    }
    distanceToPlane(plane) {
        const denominator = plane.normal.dot(this.direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (plane.distanceToPoint(this.origin) === 0) return 0;
            // Null is preferable to undefined since undefined means.... it is undefined
            return null;
        }
        const t = -(this.origin.dot(plane.normal) + plane.constant) / denominator;
        // Return if the ray never intersects the plane
        return t >= 0 ? t : null;
    }
    intersectPlane(plane, target) {
        const t = this.distanceToPlane(plane);
        if (t === null) return null;
        return this.at(t, target);
    }
    intersectsPlane(plane) {
        // check if the ray lies on the plane first
        const distToPoint = plane.distanceToPoint(this.origin);
        if (distToPoint === 0) return true;
        const denominator = plane.normal.dot(this.direction);
        if (denominator * distToPoint < 0) return true;
        // ray origin is behind the plane (and is pointing behind it)
        return false;
    }
    intersectBox(box, target) {
        let tmin, tmax, tymin, tymax, tzmin, tzmax;
        const invdirx = 1 / this.direction.x, invdiry = 1 / this.direction.y, invdirz = 1 / this.direction.z;
        const origin = this.origin;
        if (invdirx >= 0) {
            tmin = (box.min.x - origin.x) * invdirx;
            tmax = (box.max.x - origin.x) * invdirx;
        } else {
            tmin = (box.max.x - origin.x) * invdirx;
            tmax = (box.min.x - origin.x) * invdirx;
        }
        if (invdiry >= 0) {
            tymin = (box.min.y - origin.y) * invdiry;
            tymax = (box.max.y - origin.y) * invdiry;
        } else {
            tymin = (box.max.y - origin.y) * invdiry;
            tymax = (box.min.y - origin.y) * invdiry;
        }
        if (tmin > tymax || tymin > tmax) return null;
        // These lines also handle the case where tmin or tmax is NaN
        // (result of 0 * Infinity). x !== x returns true if x is NaN
        if (tymin > tmin || tmin !== tmin) tmin = tymin;
        if (tymax < tmax || tmax !== tmax) tmax = tymax;
        if (invdirz >= 0) {
            tzmin = (box.min.z - origin.z) * invdirz;
            tzmax = (box.max.z - origin.z) * invdirz;
        } else {
            tzmin = (box.max.z - origin.z) * invdirz;
            tzmax = (box.min.z - origin.z) * invdirz;
        }
        if (tmin > tzmax || tzmin > tmax) return null;
        if (tzmin > tmin || tmin !== tmin) tmin = tzmin;
        if (tzmax < tmax || tmax !== tmax) tmax = tzmax;
        //return point closest to the ray (positive side)
        if (tmax < 0) return null;
        return this.at(tmin >= 0 ? tmin : tmax, target);
    }
    intersectsBox(box) {
        return this.intersectBox(box, $28c1a1744a38aaaa$var$_vector) !== null;
    }
    intersectTriangle(a, b, c, backfaceCulling, target) {
        // Compute the offset origin, edges, and normal.
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h
        $28c1a1744a38aaaa$var$_edge1.subVectors(b, a);
        $28c1a1744a38aaaa$var$_edge2.subVectors(c, a);
        $28c1a1744a38aaaa$var$_normal.crossVectors($28c1a1744a38aaaa$var$_edge1, $28c1a1744a38aaaa$var$_edge2);
        // Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
        // E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
        //   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
        //   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
        //   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
        let DdN = this.direction.dot($28c1a1744a38aaaa$var$_normal);
        let sign;
        if (DdN > 0) {
            if (backfaceCulling) return null;
            sign = 1;
        } else if (DdN < 0) {
            sign = -1;
            DdN = -DdN;
        } else return null;
        $28c1a1744a38aaaa$var$_diff.subVectors(this.origin, a);
        const DdQxE2 = sign * this.direction.dot($28c1a1744a38aaaa$var$_edge2.crossVectors($28c1a1744a38aaaa$var$_diff, $28c1a1744a38aaaa$var$_edge2));
        // b1 < 0, no intersection
        if (DdQxE2 < 0) return null;
        const DdE1xQ = sign * this.direction.dot($28c1a1744a38aaaa$var$_edge1.cross($28c1a1744a38aaaa$var$_diff));
        // b2 < 0, no intersection
        if (DdE1xQ < 0) return null;
        // b1+b2 > 1, no intersection
        if (DdQxE2 + DdE1xQ > DdN) return null;
        // Line intersects triangle, check if ray does.
        const QdN = -sign * $28c1a1744a38aaaa$var$_diff.dot($28c1a1744a38aaaa$var$_normal);
        // t < 0, no intersection
        if (QdN < 0) return null;
        // Ray intersects triangle.
        return this.at(QdN / DdN, target);
    }
    applyMatrix4(matrix4) {
        this.origin.applyMatrix4(matrix4);
        this.direction.transformDirection(matrix4);
        return this;
    }
    equals(ray) {
        return ray.origin.equals(this.origin) && ray.direction.equals(this.direction);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $28c1a1744a38aaaa$var$_box = /*@__PURE__*/ new $28c1a1744a38aaaa$export$6f7d5a9418ab2aa3();
const $28c1a1744a38aaaa$var$_v1$1 = /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699();
const $28c1a1744a38aaaa$var$_toFarthestPoint = /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699();
const $28c1a1744a38aaaa$var$_toPoint = /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699();
class $28c1a1744a38aaaa$export$805e8b72413ccaba {
    constructor(center = new $28c1a1744a38aaaa$export$64b5c384219d3699(), radius = -1){
        this.center = center;
        this.radius = radius;
    }
    set(center, radius) {
        this.center.copy(center);
        this.radius = radius;
        return this;
    }
    setFromPoints(points, optionalCenter) {
        const center = this.center;
        if (optionalCenter !== undefined) center.copy(optionalCenter);
        else $28c1a1744a38aaaa$var$_box.setFromPoints(points).getCenter(center);
        let maxRadiusSq = 0;
        for(let i = 0, il = points.length; i < il; i++)maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(points[i]));
        this.radius = Math.sqrt(maxRadiusSq);
        return this;
    }
    copy(sphere) {
        this.center.copy(sphere.center);
        this.radius = sphere.radius;
        return this;
    }
    isEmpty() {
        return this.radius < 0;
    }
    makeEmpty() {
        this.center.set(0, 0, 0);
        this.radius = -1;
        return this;
    }
    containsPoint(point) {
        return point.distanceToSquared(this.center) <= this.radius * this.radius;
    }
    distanceToPoint(point) {
        return point.distanceTo(this.center) - this.radius;
    }
    intersectsSphere(sphere) {
        const radiusSum = this.radius + sphere.radius;
        return sphere.center.distanceToSquared(this.center) <= radiusSum * radiusSum;
    }
    intersectsBox(box) {
        return box.intersectsSphere(this);
    }
    intersectsPlane(plane) {
        return Math.abs(plane.distanceToPoint(this.center)) <= this.radius;
    }
    clampPoint(point, target) {
        const deltaLengthSq = this.center.distanceToSquared(point);
        target.copy(point);
        if (deltaLengthSq > this.radius * this.radius) {
            target.sub(this.center).normalize();
            target.multiplyScalar(this.radius).add(this.center);
        }
        return target;
    }
    getBoundingBox(target) {
        if (this.isEmpty()) {
            // Empty sphere produces empty bounding box
            target.makeEmpty();
            return target;
        }
        target.set(this.center, this.center);
        target.expandByScalar(this.radius);
        return target;
    }
    applyMatrix4(matrix) {
        this.center.applyMatrix4(matrix);
        this.radius = this.radius * matrix.getMaxScaleOnAxis();
        return this;
    }
    translate(offset) {
        this.center.add(offset);
        return this;
    }
    expandByPoint(point) {
        if (this.isEmpty()) {
            this.center.copy(point);
            this.radius = 0;
            return this;
        }
        // from https://github.com/juj/MathGeoLib/blob/2940b99b99cfe575dd45103ef20f4019dee15b54/src/Geometry/Sphere.cpp#L649-L671
        $28c1a1744a38aaaa$var$_toPoint.subVectors(point, this.center);
        const lengthSq = $28c1a1744a38aaaa$var$_toPoint.lengthSq();
        if (lengthSq > this.radius * this.radius) {
            const length = Math.sqrt(lengthSq);
            const missingRadiusHalf = (length - this.radius) * 0.5;
            // Nudge this sphere towards the target point. Add half the missing distance to radius,
            // and the other half to position. This gives a tighter enclosure, instead of if
            // the whole missing distance were just added to radius.
            this.center.add($28c1a1744a38aaaa$var$_toPoint.multiplyScalar(missingRadiusHalf / length));
            this.radius += missingRadiusHalf;
        }
        return this;
    }
    union(sphere) {
        // handle empty sphere cases
        if (sphere.isEmpty()) return;
        else if (this.isEmpty()) {
            this.copy(sphere);
            return this;
        }
        // from https://github.com/juj/MathGeoLib/blob/2940b99b99cfe575dd45103ef20f4019dee15b54/src/Geometry/Sphere.cpp#L759-L769
        // To enclose another sphere into this sphere, we only need to enclose two points:
        // 1) Enclose the farthest point on the other sphere into this sphere.
        // 2) Enclose the opposite point of the farthest point into this sphere.
        if (this.center.equals(sphere.center) === true) $28c1a1744a38aaaa$var$_toFarthestPoint.set(0, 0, 1).multiplyScalar(sphere.radius);
        else $28c1a1744a38aaaa$var$_toFarthestPoint.subVectors(sphere.center, this.center).normalize().multiplyScalar(sphere.radius);
        this.expandByPoint($28c1a1744a38aaaa$var$_v1$1.copy(sphere.center).add($28c1a1744a38aaaa$var$_toFarthestPoint));
        this.expandByPoint($28c1a1744a38aaaa$var$_v1$1.copy(sphere.center).sub($28c1a1744a38aaaa$var$_toFarthestPoint));
        return this;
    }
    equals(sphere) {
        return sphere.center.equals(this.center) && sphere.radius === this.radius;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
/**
 * Ref: https://en.wikipedia.org/wiki/Spherical_coordinate_system
 *
 * The polar angle (phi) is measured from the positive y-axis. The positive y-axis is up.
 * The azimuthal angle (theta) is measured from the positive z-axis.
 */ class $28c1a1744a38aaaa$export$d712cd887b4a00f7 {
    constructor(radius = 1, phi = 0, theta = 0){
        this.radius = radius;
        this.phi = phi; // polar angle
        this.theta = theta; // azimuthal angle
        return this;
    }
    set(radius, phi, theta) {
        this.radius = radius;
        this.phi = phi;
        this.theta = theta;
        return this;
    }
    copy(other) {
        this.radius = other.radius;
        this.phi = other.phi;
        this.theta = other.theta;
        return this;
    }
    // restrict phi to be between EPS and PI-EPS
    makeSafe() {
        const EPS = 0.000001;
        this.phi = Math.max(EPS, Math.min(Math.PI - EPS, this.phi));
        return this;
    }
    setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + y * y + z * z);
        if (this.radius === 0) {
            this.theta = 0;
            this.phi = 0;
        } else {
            this.theta = Math.atan2(x, z);
            this.phi = Math.acos($28c1a1744a38aaaa$var$clamp(y / this.radius, -1, 1));
        }
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $28c1a1744a38aaaa$var$_v0 = /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699();
const $28c1a1744a38aaaa$var$_v1 = /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699();
const $28c1a1744a38aaaa$var$_v2 = /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699();
const $28c1a1744a38aaaa$var$_v3 = /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699();
const $28c1a1744a38aaaa$var$_vab = /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699();
const $28c1a1744a38aaaa$var$_vac = /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699();
const $28c1a1744a38aaaa$var$_vbc = /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699();
const $28c1a1744a38aaaa$var$_vap = /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699();
const $28c1a1744a38aaaa$var$_vbp = /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699();
const $28c1a1744a38aaaa$var$_vcp = /*@__PURE__*/ new $28c1a1744a38aaaa$export$64b5c384219d3699();
class $28c1a1744a38aaaa$export$5a465592bfe74b48 {
    constructor(a = new $28c1a1744a38aaaa$export$64b5c384219d3699(), b = new $28c1a1744a38aaaa$export$64b5c384219d3699(), c = new $28c1a1744a38aaaa$export$64b5c384219d3699()){
        this.a = a;
        this.b = b;
        this.c = c;
    }
    static getNormal(a, b, c, target) {
        target.subVectors(c, b);
        $28c1a1744a38aaaa$var$_v0.subVectors(a, b);
        target.cross($28c1a1744a38aaaa$var$_v0);
        const targetLengthSq = target.lengthSq();
        if (targetLengthSq > 0) return target.multiplyScalar(1 / Math.sqrt(targetLengthSq));
        return target.set(0, 0, 0);
    }
    // static/instance method to calculate barycentric coordinates
    // based on: http://www.blackpawn.com/texts/pointinpoly/default.html
    static getBarycoord(point, a, b, c, target) {
        $28c1a1744a38aaaa$var$_v0.subVectors(c, a);
        $28c1a1744a38aaaa$var$_v1.subVectors(b, a);
        $28c1a1744a38aaaa$var$_v2.subVectors(point, a);
        const dot00 = $28c1a1744a38aaaa$var$_v0.dot($28c1a1744a38aaaa$var$_v0);
        const dot01 = $28c1a1744a38aaaa$var$_v0.dot($28c1a1744a38aaaa$var$_v1);
        const dot02 = $28c1a1744a38aaaa$var$_v0.dot($28c1a1744a38aaaa$var$_v2);
        const dot11 = $28c1a1744a38aaaa$var$_v1.dot($28c1a1744a38aaaa$var$_v1);
        const dot12 = $28c1a1744a38aaaa$var$_v1.dot($28c1a1744a38aaaa$var$_v2);
        const denom = dot00 * dot11 - dot01 * dot01;
        // collinear or singular triangle
        if (denom === 0) // arbitrary location outside of triangle?
        // not sure if this is the best idea, maybe should be returning undefined
        return target.set(-2, -1, -1);
        const invDenom = 1 / denom;
        const u = (dot11 * dot02 - dot01 * dot12) * invDenom;
        const v = (dot00 * dot12 - dot01 * dot02) * invDenom;
        // barycentric coordinates must always sum to 1
        return target.set(1 - u - v, v, u);
    }
    static containsPoint(point, a, b, c) {
        this.getBarycoord(point, a, b, c, $28c1a1744a38aaaa$var$_v3);
        return $28c1a1744a38aaaa$var$_v3.x >= 0 && $28c1a1744a38aaaa$var$_v3.y >= 0 && $28c1a1744a38aaaa$var$_v3.x + $28c1a1744a38aaaa$var$_v3.y <= 1;
    }
    static getUV(point, p1, p2, p3, uv1, uv2, uv3, target) {
        this.getBarycoord(point, p1, p2, p3, $28c1a1744a38aaaa$var$_v3);
        target.set(0, 0);
        target.addScaledVector(uv1, $28c1a1744a38aaaa$var$_v3.x);
        target.addScaledVector(uv2, $28c1a1744a38aaaa$var$_v3.y);
        target.addScaledVector(uv3, $28c1a1744a38aaaa$var$_v3.z);
        return target;
    }
    static isFrontFacing(a, b, c, direction) {
        $28c1a1744a38aaaa$var$_v0.subVectors(c, b);
        $28c1a1744a38aaaa$var$_v1.subVectors(a, b);
        // strictly front facing
        return $28c1a1744a38aaaa$var$_v0.cross($28c1a1744a38aaaa$var$_v1).dot(direction) < 0 ? true : false;
    }
    set(a, b, c) {
        this.a.copy(a);
        this.b.copy(b);
        this.c.copy(c);
        return this;
    }
    setFromPointsAndIndices(points, i0, i1, i2) {
        this.a.copy(points[i0]);
        this.b.copy(points[i1]);
        this.c.copy(points[i2]);
        return this;
    }
    // setFromAttributeAndIndices( attribute, i0, i1, i2 ) {
    // 	this.a.fromBufferAttribute( attribute, i0 );
    // 	this.b.fromBufferAttribute( attribute, i1 );
    // 	this.c.fromBufferAttribute( attribute, i2 );
    // 	return this;
    // }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(triangle) {
        this.a.copy(triangle.a);
        this.b.copy(triangle.b);
        this.c.copy(triangle.c);
        return this;
    }
    getArea() {
        $28c1a1744a38aaaa$var$_v0.subVectors(this.c, this.b);
        $28c1a1744a38aaaa$var$_v1.subVectors(this.a, this.b);
        return $28c1a1744a38aaaa$var$_v0.cross($28c1a1744a38aaaa$var$_v1).length() * 0.5;
    }
    getMidpoint(target) {
        return target.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }
    getNormal(target) {
        return $28c1a1744a38aaaa$export$5a465592bfe74b48.getNormal(this.a, this.b, this.c, target);
    }
    getPlane(target) {
        return target.setFromCoplanarPoints(this.a, this.b, this.c);
    }
    getBarycoord(point, target) {
        return $28c1a1744a38aaaa$export$5a465592bfe74b48.getBarycoord(point, this.a, this.b, this.c, target);
    }
    getUV(point, uv1, uv2, uv3, target) {
        return $28c1a1744a38aaaa$export$5a465592bfe74b48.getUV(point, this.a, this.b, this.c, uv1, uv2, uv3, target);
    }
    containsPoint(point) {
        return $28c1a1744a38aaaa$export$5a465592bfe74b48.containsPoint(point, this.a, this.b, this.c);
    }
    isFrontFacing(direction) {
        return $28c1a1744a38aaaa$export$5a465592bfe74b48.isFrontFacing(this.a, this.b, this.c, direction);
    }
    intersectsBox(box) {
        return box.intersectsTriangle(this);
    }
    closestPointToPoint(p, target) {
        const a = this.a, b = this.b, c = this.c;
        let v, w;
        // algorithm thanks to Real-Time Collision Detection by Christer Ericson,
        // published by Morgan Kaufmann Publishers, (c) 2005 Elsevier Inc.,
        // under the accompanying license; see chapter 5.1.5 for detailed explanation.
        // basically, we're distinguishing which of the voronoi regions of the triangle
        // the point lies in with the minimum amount of redundant computation.
        $28c1a1744a38aaaa$var$_vab.subVectors(b, a);
        $28c1a1744a38aaaa$var$_vac.subVectors(c, a);
        $28c1a1744a38aaaa$var$_vap.subVectors(p, a);
        const d1 = $28c1a1744a38aaaa$var$_vab.dot($28c1a1744a38aaaa$var$_vap);
        const d2 = $28c1a1744a38aaaa$var$_vac.dot($28c1a1744a38aaaa$var$_vap);
        if (d1 <= 0 && d2 <= 0) // vertex region of A; barycentric coords (1, 0, 0)
        return target.copy(a);
        $28c1a1744a38aaaa$var$_vbp.subVectors(p, b);
        const d3 = $28c1a1744a38aaaa$var$_vab.dot($28c1a1744a38aaaa$var$_vbp);
        const d4 = $28c1a1744a38aaaa$var$_vac.dot($28c1a1744a38aaaa$var$_vbp);
        if (d3 >= 0 && d4 <= d3) // vertex region of B; barycentric coords (0, 1, 0)
        return target.copy(b);
        const vc = d1 * d4 - d3 * d2;
        if (vc <= 0 && d1 >= 0 && d3 <= 0) {
            v = d1 / (d1 - d3);
            // edge region of AB; barycentric coords (1-v, v, 0)
            return target.copy(a).addScaledVector($28c1a1744a38aaaa$var$_vab, v);
        }
        $28c1a1744a38aaaa$var$_vcp.subVectors(p, c);
        const d5 = $28c1a1744a38aaaa$var$_vab.dot($28c1a1744a38aaaa$var$_vcp);
        const d6 = $28c1a1744a38aaaa$var$_vac.dot($28c1a1744a38aaaa$var$_vcp);
        if (d6 >= 0 && d5 <= d6) // vertex region of C; barycentric coords (0, 0, 1)
        return target.copy(c);
        const vb = d5 * d2 - d1 * d6;
        if (vb <= 0 && d2 >= 0 && d6 <= 0) {
            w = d2 / (d2 - d6);
            // edge region of AC; barycentric coords (1-w, 0, w)
            return target.copy(a).addScaledVector($28c1a1744a38aaaa$var$_vac, w);
        }
        const va = d3 * d6 - d5 * d4;
        if (va <= 0 && d4 - d3 >= 0 && d5 - d6 >= 0) {
            $28c1a1744a38aaaa$var$_vbc.subVectors(c, b);
            w = (d4 - d3) / (d4 - d3 + (d5 - d6));
            // edge region of BC; barycentric coords (0, 1-w, w)
            return target.copy(b).addScaledVector($28c1a1744a38aaaa$var$_vbc, w); // edge region of BC
        }
        // face region
        const denom = 1 / (va + vb + vc);
        // u = va * denom
        v = vb * denom;
        w = vc * denom;
        return target.copy(a).addScaledVector($28c1a1744a38aaaa$var$_vab, v).addScaledVector($28c1a1744a38aaaa$var$_vac, w);
    }
    equals(triangle) {
        return triangle.a.equals(this.a) && triangle.b.equals(this.b) && triangle.c.equals(this.c);
    }
}
class $28c1a1744a38aaaa$export$fa7daccca11cdbe3 {
    constructor(x = 0, y = 0, z = 0, w = 1){
        $28c1a1744a38aaaa$export$fa7daccca11cdbe3.prototype.isVector4 = true;
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
    }
    get width() {
        return this.z;
    }
    set width(value) {
        this.z = value;
    }
    get height() {
        return this.w;
    }
    set height(value) {
        this.w = value;
    }
    set(x, y, z, w) {
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        this.w = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setW(w) {
        this.w = w;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            case 3:
                this.w = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            case 3:
                return this.w;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z, this.w);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        this.w = v.w !== undefined ? v.w : 1;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        this.w += v.w;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        this.w += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        this.w = a.w + b.w;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        this.w += v.w * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        this.w -= v.w;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        this.w -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        this.w = a.w - b.w;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        this.w *= v.w;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        this.w *= scalar;
        return this;
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z, w = this.w;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z + e[12] * w;
        this.y = e[1] * x + e[5] * y + e[9] * z + e[13] * w;
        this.z = e[2] * x + e[6] * y + e[10] * z + e[14] * w;
        this.w = e[3] * x + e[7] * y + e[11] * z + e[15] * w;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    setAxisAngleFromQuaternion(q) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm
        // q is assumed to be normalized
        this.w = 2 * Math.acos(q.w);
        const s = Math.sqrt(1 - q.w * q.w);
        if (s < 0.0001) {
            this.x = 1;
            this.y = 0;
            this.z = 0;
        } else {
            this.x = q.x / s;
            this.y = q.y / s;
            this.z = q.z / s;
        }
        return this;
    }
    setAxisAngleFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        let angle, x, y, z; // variables for result
        const epsilon = 0.01, epsilon2 = 0.1, te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10];
        if (Math.abs(m12 - m21) < epsilon && Math.abs(m13 - m31) < epsilon && Math.abs(m23 - m32) < epsilon) {
            // singularity found
            // first check for identity matrix which must have +1 for all terms
            // in leading diagonal and zero in other terms
            if (Math.abs(m12 + m21) < epsilon2 && Math.abs(m13 + m31) < epsilon2 && Math.abs(m23 + m32) < epsilon2 && Math.abs(m11 + m22 + m33 - 3) < epsilon2) {
                // this singularity is identity matrix so angle = 0
                this.set(1, 0, 0, 0);
                return this; // zero angle, arbitrary axis
            }
            // otherwise this singularity is angle = 180
            angle = Math.PI;
            const xx = (m11 + 1) / 2;
            const yy = (m22 + 1) / 2;
            const zz = (m33 + 1) / 2;
            const xy = (m12 + m21) / 4;
            const xz = (m13 + m31) / 4;
            const yz = (m23 + m32) / 4;
            if (xx > yy && xx > zz) {
                // m11 is the largest diagonal term
                if (xx < epsilon) {
                    x = 0;
                    y = 0.707106781;
                    z = 0.707106781;
                } else {
                    x = Math.sqrt(xx);
                    y = xy / x;
                    z = xz / x;
                }
            } else if (yy > zz) {
                // m22 is the largest diagonal term
                if (yy < epsilon) {
                    x = 0.707106781;
                    y = 0;
                    z = 0.707106781;
                } else {
                    y = Math.sqrt(yy);
                    x = xy / y;
                    z = yz / y;
                }
            } else // m33 is the largest diagonal term so base result on this
            if (zz < epsilon) {
                x = 0.707106781;
                y = 0.707106781;
                z = 0;
            } else {
                z = Math.sqrt(zz);
                x = xz / z;
                y = yz / z;
            }
            this.set(x, y, z, angle);
            return this; // return 180 deg rotation
        }
        // as we have reached here there are no singularities so we can handle normally
        let s = Math.sqrt((m32 - m23) * (m32 - m23) + (m13 - m31) * (m13 - m31) + (m21 - m12) * (m21 - m12)); // used to normalize
        if (Math.abs(s) < 0.001) s = 1;
        // prevent divide by zero, should not happen if matrix is orthogonal and should be
        // caught by singularity test above, but I've left it in just in case
        this.x = (m32 - m23) / s;
        this.y = (m13 - m31) / s;
        this.z = (m21 - m12) / s;
        this.w = Math.acos((m11 + m22 + m33 - 1) / 2);
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        this.w = Math.min(this.w, v.w);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        this.w = Math.max(this.w, v.w);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        this.w = Math.max(min.w, Math.min(max.w, this.w));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        this.w = Math.max(minVal, Math.min(maxVal, this.w));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        this.w = Math.floor(this.w);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        this.w = Math.ceil(this.w);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        this.w = Math.round(this.w);
        return this;
    }
    roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
        this.w = this.w < 0 ? Math.ceil(this.w) : Math.floor(this.w);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        this.w = -this.w;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        this.w += (v.w - this.w) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        this.w = v1.w + (v2.w - v1.w) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z && v.w === this.w;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        this.w = array[offset + 3];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        array[offset + 3] = this.w;
        return array;
    }
    // fromBufferAttribute( attribute, index ) {
    // 	this.x = attribute.getX( index );
    // 	this.y = attribute.getY( index );
    // 	this.z = attribute.getZ( index );
    // 	this.w = attribute.getW( index );
    // 	return this;
    // }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        this.w = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
        yield this.w;
    }
}

});


parcelRegister("8Jhhz", function(module, exports) {
"use strict";
var $65afeea1bfd30bda$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AnnotationList = void 0;

var $bpdXW = parcelRequire("bpdXW");
var $65afeea1bfd30bda$var$AnnotationList = /** @class */ function(_super) {
    $65afeea1bfd30bda$var$__extends(AnnotationList, _super);
    function AnnotationList(label, jsonld, options) {
        var _this = _super.call(this, jsonld) || this;
        _this.label = label;
        _this.options = options;
        return _this;
    }
    AnnotationList.prototype.getIIIFResourceType = function() {
        return $bpdXW.Utils.normaliseType(this.getProperty("type"));
    };
    AnnotationList.prototype.getLabel = function() {
        return this.label;
    };
    AnnotationList.prototype.getResources = function() {
        var _this = this;
        var resources = this.getProperty("resources");
        return resources.map(function(resource) {
            return new $bpdXW.Annotation(resource, _this.options);
        });
    };
    AnnotationList.prototype.load = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            if (_this.isLoaded) resolve(_this);
            else {
                var id = _this.__jsonld.id;
                if (!id) id = _this.__jsonld["@id"];
                $bpdXW.Utils.loadManifest(id).then(function(data) {
                    _this.__jsonld = data;
                    _this.context = _this.getProperty("context");
                    _this.id = _this.getProperty("id");
                    _this.isLoaded = true;
                    resolve(_this);
                }).catch(reject);
            }
        });
    };
    return AnnotationList;
}($bpdXW.JSONLDResource);
module.exports.AnnotationList = $65afeea1bfd30bda$var$AnnotationList;

});

parcelRegister("8p5ST", function(module, exports) {
"use strict";
var $61e539047cdb1f38$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AnnotationPage = void 0;

var $bpdXW = parcelRequire("bpdXW");
var $61e539047cdb1f38$var$AnnotationPage = /** @class */ function(_super) {
    $61e539047cdb1f38$var$__extends(AnnotationPage, _super);
    function AnnotationPage(jsonld, options) {
        return _super.call(this, jsonld, options) || this;
    }
    AnnotationPage.prototype.getItems = function() {
        return this.getProperty("items");
    };
    return AnnotationPage;
}($bpdXW.ManifestResource);
module.exports.AnnotationPage = $61e539047cdb1f38$var$AnnotationPage;

});

parcelRegister("8wL7U", function(module, exports) {
"use strict";
var $6355de430a23ec2b$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $6355de430a23ec2b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Canvas = void 0;

var $loafo = parcelRequire("loafo");

var $bpdXW = parcelRequire("bpdXW");

// @ts-ignore
var $6355de430a23ec2b$var$flatten_1 = $6355de430a23ec2b$var$__importDefault((parcelRequire("20Rgr")));

// @ts-ignore
var $6355de430a23ec2b$var$flattenDeep_1 = $6355de430a23ec2b$var$__importDefault((parcelRequire("7JcvP")));
var $6355de430a23ec2b$var$Canvas = /** @class */ function(_super) {
    $6355de430a23ec2b$var$__extends(Canvas, _super);
    function Canvas(jsonld, options) {
        return _super.call(this, jsonld, options) || this;
    }
    // http://iiif.io/api/image/2.1/#canonical-uri-syntax
    Canvas.prototype.getCanonicalImageUri = function(w) {
        var id = null;
        var region = "full";
        var rotation = 0;
        var quality = "default";
        var width = w;
        var size;
        // if an info.json has been loaded
        if (this.externalResource && this.externalResource.data && this.externalResource.data["@id"]) {
            id = this.externalResource.data["@id"];
            if (!width) width = this.externalResource.data.width;
            if (this.externalResource.data["@context"]) {
                if (this.externalResource.data["@context"].indexOf("/1.0/context.json") > -1 || this.externalResource.data["@context"].indexOf("/1.1/context.json") > -1 || this.externalResource.data["@context"].indexOf("/1/context.json") > -1) quality = "native";
            }
        } else {
            // info.json hasn't been loaded yet
            var images = void 0;
            // presentation 2.0
            images = this.getImages();
            if (images && images.length) {
                var firstImage = images[0];
                var resource = firstImage.getResource();
                var services = resource.getServices();
                if (!width) width = resource.getWidth();
                var service = services ? services.find(function(service) {
                    return $bpdXW.Utils.isImageProfile(service.getProfile()) || $bpdXW.Utils.isImageServiceType(service.getIIIFResourceType());
                }) : null;
                if (service) {
                    id = service.id;
                    quality = $bpdXW.Utils.getImageQuality(service.getProfile());
                } else if (width === resource.getWidth()) // if the passed width is the same as the resource width
                // i.e. not looking for a thumbnail
                // return the full size image.
                // used for download options when loading static images.
                return resource.id;
            }
            // presentation 3.0
            images = this.getContent();
            if (images && images.length) {
                var firstImage = images[0];
                // Developer note: Since Canvas in Presentation 3 doesn't use
                // SpecificResource resources in the body, force a cast
                var body = firstImage.getBody();
                var anno = body[0];
                var services = anno.getServices();
                if (!width) width = anno.getWidth();
                var service = services ? services.find(function(service) {
                    return $bpdXW.Utils.isImageServiceType(service.getIIIFResourceType());
                }) : null;
                if (service) {
                    id = service.id;
                    quality = $bpdXW.Utils.getImageQuality(service.getProfile());
                } else if (width === anno.getWidth()) // if the passed width is the same as the resource width
                // i.e. not looking for a thumbnail
                // return the full size image.
                // used for download options when loading static images.
                return anno.id;
            }
            // todo: should this be moved to getThumbUri?
            if (!id) {
                var thumbnail = this.getProperty("thumbnail");
                if (thumbnail) {
                    if (typeof thumbnail === "string") return thumbnail;
                    else {
                        if (thumbnail["@id"]) return thumbnail["@id"];
                        else if (thumbnail.length) return thumbnail[0].id;
                    }
                }
            }
        }
        size = width + ",";
        // trim off trailing '/'
        if (id && id.endsWith("/")) id = id.substr(0, id.length - 1);
        var uri = [
            id,
            region,
            size,
            rotation,
            quality + ".jpg"
        ].join("/");
        return uri;
    };
    Canvas.prototype.getMaxDimensions = function() {
        var maxDimensions = null;
        var profile;
        if (this.externalResource && this.externalResource.data && this.externalResource.data.profile) {
            profile = this.externalResource.data.profile;
            if (Array.isArray(profile)) {
                profile = profile.filter(function(p) {
                    return p["maxWidth"];
                })[0];
                if (profile) maxDimensions = new $bpdXW.Size(profile.maxWidth, profile.maxHeight ? profile.maxHeight : profile.maxWidth);
            }
        }
        return maxDimensions;
    };
    // Presentation API 3.0
    Canvas.prototype.getContent = function() {
        var content = [];
        var items = this.__jsonld.items || this.__jsonld.content;
        if (!items) return content;
        // should be contained in an AnnotationPage
        var annotationPage = null;
        if (items.length) annotationPage = new $bpdXW.AnnotationPage(items[0], this.options);
        if (!annotationPage) return content;
        var annotations = annotationPage.getItems();
        for(var i = 0; i < annotations.length; i++){
            var a = annotations[i];
            var annotation = new $bpdXW.Annotation(a, this.options);
            content.push(annotation);
        }
        return content;
    };
    Canvas.prototype.getDuration = function() {
        return this.getProperty("duration");
    };
    // presentation 2.0
    Canvas.prototype.getImages = function() {
        var images = [];
        if (!this.__jsonld.images) return images;
        for(var i = 0; i < this.__jsonld.images.length; i++){
            var a = this.__jsonld.images[i];
            var annotation = new $bpdXW.Annotation(a, this.options);
            images.push(annotation);
        }
        return images;
    };
    Canvas.prototype.getIndex = function() {
        return this.getProperty("index");
    };
    Canvas.prototype.getOtherContent = function() {
        var _this = this;
        var otherContent = Array.isArray(this.getProperty("otherContent")) ? this.getProperty("otherContent") : [
            this.getProperty("otherContent")
        ];
        var canonicalComparison = function(typeA, typeB) {
            if (typeof typeA !== "string" || typeof typeB !== "string") return false;
            return typeA.toLowerCase() === typeA.toLowerCase();
        };
        var otherPromises = otherContent.filter(function(otherContent) {
            return otherContent && canonicalComparison(otherContent["@type"], "sc:AnnotationList");
        }).map(function(annotationList, i) {
            return new $bpdXW.AnnotationList(annotationList["label"] || "Annotation list ".concat(i), annotationList, _this.options);
        }).map(function(annotationList) {
            return annotationList.load();
        });
        return Promise.all(otherPromises);
    };
    // Prefer thumbnail service to image service if supplied and if
    // the thumbnail service can provide a satisfactory size +/- x pixels.
    // this is used to get thumb URIs *before* the info.json has been requested
    // and populate thumbnails in a viewer.
    // the publisher may also provide pre-computed fixed-size thumbs for better performance.
    //getThumbUri(width: number): string {
    //
    //    var uri;
    //    var images: IAnnotation[] = this.getImages();
    //
    //    if (images && images.length) {
    //        var firstImage = images[0];
    //        var resource: IResource = firstImage.getResource();
    //        var services: IService[] = resource.getServices();
    //
    //        for (let i = 0; i < services.length; i++) {
    //            var service: IService = services[i];
    //            var id = service.id;
    //
    //            if (!_endsWith(id, '/')) {
    //                id += '/';
    //            }
    //
    //            uri = id + 'full/' + width + ',/0/' + Utils.getImageQuality(service.getProfile()) + '.jpg';
    //        }
    //    }
    //
    //    return uri;
    //}
    //getType(): CanvasType {
    //    return new CanvasType(this.getProperty('@type').toLowerCase());
    //}
    Canvas.prototype.getWidth = function() {
        return this.getProperty("width");
    };
    Canvas.prototype.getHeight = function() {
        return this.getProperty("height");
    };
    Canvas.prototype.getViewingHint = function() {
        return this.getProperty("viewingHint");
    };
    Object.defineProperty(Canvas.prototype, "imageResources", {
        get: function() {
            var _this = this;
            var resources = (0, $6355de430a23ec2b$var$flattenDeep_1.default)([
                this.getImages().map(function(i) {
                    return i.getResource();
                }),
                this.getContent().map(function(i) {
                    return i.getBody();
                })
            ]);
            return (0, $6355de430a23ec2b$var$flatten_1.default)(resources.map(function(resource) {
                switch(resource.getProperty("type").toLowerCase()){
                    case $loafo.ExternalResourceType.CHOICE:
                    case $loafo.ExternalResourceType.OA_CHOICE:
                        return new Canvas({
                            images: (0, $6355de430a23ec2b$var$flatten_1.default)([
                                resource.getProperty("default"),
                                resource.getProperty("item")
                            ]).map(function(r) {
                                return {
                                    resource: r
                                };
                            })
                        }, _this.options).getImages().map(function(i) {
                            return i.getResource();
                        });
                    default:
                        return resource;
                }
            }));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Canvas.prototype, "resourceAnnotations", {
        get: function() {
            return (0, $6355de430a23ec2b$var$flattenDeep_1.default)([
                this.getImages(),
                this.getContent()
            ]);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Returns a given resource Annotation, based on a contained resource or body
     * id
     */ Canvas.prototype.resourceAnnotation = function(id) {
        return this.resourceAnnotations.find(function(anno) {
            return anno.getResource().id === id || (0, $6355de430a23ec2b$var$flatten_1.default)(new Array(anno.getBody())).some(function(body) {
                return body.id === id;
            });
        });
    };
    /**
     * Returns the fragment placement values if a resourceAnnotation is placed on
     * a canvas somewhere besides the full extent
     */ Canvas.prototype.onFragment = function(id) {
        var resourceAnnotation = this.resourceAnnotation(id);
        if (!resourceAnnotation) return undefined;
        // IIIF v2
        var on = resourceAnnotation.getProperty("on");
        // IIIF v3
        var target = resourceAnnotation.getProperty("target");
        if (!on || !target) return undefined;
        var fragmentMatch = (on || target).match(/xywh=(.*)$/);
        if (!fragmentMatch) return undefined;
        return fragmentMatch[1].split(",").map(function(str) {
            return parseInt(str, 10);
        });
    };
    Object.defineProperty(Canvas.prototype, "iiifImageResources", {
        get: function() {
            return this.imageResources.filter(function(r) {
                return r && r.getServices()[0] && r.getServices()[0].id;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Canvas.prototype, "imageServiceIds", {
        get: function() {
            return this.iiifImageResources.map(function(r) {
                return r.getServices()[0].id;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Canvas.prototype, "aspectRatio", {
        get: function() {
            return this.getWidth() / this.getHeight();
        },
        enumerable: false,
        configurable: true
    });
    return Canvas;
}($bpdXW.Resource);
module.exports.Canvas = $6355de430a23ec2b$var$Canvas;

});
parcelRegister("20Rgr", function(module, exports) {

var $fgBHx = parcelRequire("fgBHx");
/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $1774e6065e7ade58$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $fgBHx(array, 1) : [];
}
module.exports = $1774e6065e7ade58$var$flatten;

});
parcelRegister("fgBHx", function(module, exports) {

var $hynws = parcelRequire("hynws");

var $hStNq = parcelRequire("hStNq");
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $b1d5985487d54dea$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $hStNq);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $b1d5985487d54dea$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $hynws(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $b1d5985487d54dea$var$baseFlatten;

});
parcelRegister("hynws", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $cc77dbb7c08db6a8$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $cc77dbb7c08db6a8$var$arrayPush;

});

parcelRegister("hStNq", function(module, exports) {

var $57wYk = parcelRequire("57wYk");

var $aJD6g = parcelRequire("aJD6g");

var $o8HxT = parcelRequire("o8HxT");
/** Built-in value references. */ var $035bd928078475ee$var$spreadableSymbol = $57wYk ? $57wYk.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $035bd928078475ee$var$isFlattenable(value) {
    return $o8HxT(value) || $aJD6g(value) || !!($035bd928078475ee$var$spreadableSymbol && value && value[$035bd928078475ee$var$spreadableSymbol]);
}
module.exports = $035bd928078475ee$var$isFlattenable;

});
parcelRegister("57wYk", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/** Built-in value references. */ var $3ba72ebe7e4419b5$var$Symbol = $23YZo.Symbol;
module.exports = $3ba72ebe7e4419b5$var$Symbol;

});
parcelRegister("23YZo", function(module, exports) {

var $ljJ8G = parcelRequire("ljJ8G");
/** Detect free variable `self`. */ var $180b2bc3c0deaf6c$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $180b2bc3c0deaf6c$var$root = $ljJ8G || $180b2bc3c0deaf6c$var$freeSelf || Function('return this')();
module.exports = $180b2bc3c0deaf6c$var$root;

});
parcelRegister("ljJ8G", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $f84e62f9db5b9ccd$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $f84e62f9db5b9ccd$var$freeGlobal;

});



parcelRegister("aJD6g", function(module, exports) {

var $lB3aj = parcelRequire("lB3aj");

var $8l89S = parcelRequire("8l89S");
/** Used for built-in method references. */ var $7d0c6fd0eb26be0e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7d0c6fd0eb26be0e$var$hasOwnProperty = $7d0c6fd0eb26be0e$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $7d0c6fd0eb26be0e$var$propertyIsEnumerable = $7d0c6fd0eb26be0e$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $7d0c6fd0eb26be0e$var$isArguments = $lB3aj(function() {
    return arguments;
}()) ? $lB3aj : function(value) {
    return $8l89S(value) && $7d0c6fd0eb26be0e$var$hasOwnProperty.call(value, 'callee') && !$7d0c6fd0eb26be0e$var$propertyIsEnumerable.call(value, 'callee');
};
module.exports = $7d0c6fd0eb26be0e$var$isArguments;

});
parcelRegister("lB3aj", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $fb8f823cdc90f511$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $fb8f823cdc90f511$var$baseIsArguments(value) {
    return $8l89S(value) && $eq6CV(value) == $fb8f823cdc90f511$var$argsTag;
}
module.exports = $fb8f823cdc90f511$var$baseIsArguments;

});
parcelRegister("eq6CV", function(module, exports) {

var $57wYk = parcelRequire("57wYk");

var $iMn5C = parcelRequire("iMn5C");

var $5tDQy = parcelRequire("5tDQy");
/** `Object#toString` result references. */ var $a7f8a2555793d7d3$var$nullTag = '[object Null]', $a7f8a2555793d7d3$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $a7f8a2555793d7d3$var$symToStringTag = $57wYk ? $57wYk.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $a7f8a2555793d7d3$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $a7f8a2555793d7d3$var$undefinedTag : $a7f8a2555793d7d3$var$nullTag;
    return $a7f8a2555793d7d3$var$symToStringTag && $a7f8a2555793d7d3$var$symToStringTag in Object(value) ? $iMn5C(value) : $5tDQy(value);
}
module.exports = $a7f8a2555793d7d3$var$baseGetTag;

});
parcelRegister("iMn5C", function(module, exports) {

var $57wYk = parcelRequire("57wYk");
/** Used for built-in method references. */ var $dabe9ecbecc6d0b5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dabe9ecbecc6d0b5$var$hasOwnProperty = $dabe9ecbecc6d0b5$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $dabe9ecbecc6d0b5$var$nativeObjectToString = $dabe9ecbecc6d0b5$var$objectProto.toString;
/** Built-in value references. */ var $dabe9ecbecc6d0b5$var$symToStringTag = $57wYk ? $57wYk.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $dabe9ecbecc6d0b5$var$getRawTag(value) {
    var isOwn = $dabe9ecbecc6d0b5$var$hasOwnProperty.call(value, $dabe9ecbecc6d0b5$var$symToStringTag), tag = value[$dabe9ecbecc6d0b5$var$symToStringTag];
    try {
        value[$dabe9ecbecc6d0b5$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $dabe9ecbecc6d0b5$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$dabe9ecbecc6d0b5$var$symToStringTag] = tag;
        else delete value[$dabe9ecbecc6d0b5$var$symToStringTag];
    }
    return result;
}
module.exports = $dabe9ecbecc6d0b5$var$getRawTag;

});

parcelRegister("5tDQy", function(module, exports) {
/** Used for built-in method references. */ var $3fce91ec3914aaed$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3fce91ec3914aaed$var$nativeObjectToString = $3fce91ec3914aaed$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $3fce91ec3914aaed$var$objectToString(value) {
    return $3fce91ec3914aaed$var$nativeObjectToString.call(value);
}
module.exports = $3fce91ec3914aaed$var$objectToString;

});


parcelRegister("8l89S", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $61269cf1f3e020be$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $61269cf1f3e020be$var$isObjectLike;

});



parcelRegister("o8HxT", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $0488fde9aa355453$var$isArray = Array.isArray;
module.exports = $0488fde9aa355453$var$isArray;

});




parcelRegister("7JcvP", function(module, exports) {

var $fgBHx = parcelRequire("fgBHx");
/** Used as references for various `Number` constants. */ var $5a06711408304e05$var$INFINITY = 1 / 0;
/**
 * Recursively flattens `array`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flattenDeep([1, [2, [3, [4]], 5]]);
 * // => [1, 2, 3, 4, 5]
 */ function $5a06711408304e05$var$flattenDeep(array) {
    var length = array == null ? 0 : array.length;
    return length ? $fgBHx(array, $5a06711408304e05$var$INFINITY) : [];
}
module.exports = $5a06711408304e05$var$flattenDeep;

});


parcelRegister("5hZtU", function(module, exports) {
"use strict";
var $3d9e3b37c05774f0$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Collection = void 0;

var $loafo = parcelRequire("loafo");

var $bpdXW = parcelRequire("bpdXW");
var $3d9e3b37c05774f0$var$Collection = /** @class */ function(_super) {
    $3d9e3b37c05774f0$var$__extends(Collection, _super);
    function Collection(jsonld, options) {
        var _this = _super.call(this, jsonld, options) || this;
        _this.items = [];
        _this._collections = null;
        _this._manifests = null;
        jsonld.__collection = _this;
        return _this;
    }
    Collection.prototype.getCollections = function() {
        if (this._collections) return this._collections;
        return this._collections = this.items.filter(function(m) {
            return m.isCollection();
        });
    };
    Collection.prototype.getManifests = function() {
        if (this._manifests) return this._manifests;
        return this._manifests = this.items.filter(function(m) {
            return m.isManifest();
        });
    };
    Collection.prototype.getCollectionByIndex = function(collectionIndex) {
        var collections = this.getCollections();
        var collection;
        for(var i = 0; i < collections.length; i++){
            var c = collections[i];
            if (c.index === collectionIndex) collection = c;
        }
        if (collection) {
            collection.options.index = collectionIndex;
            // id for collection MUST be dereferenceable
            return collection.load();
        } else throw new Error("Collection index not found");
    };
    Collection.prototype.getManifestByIndex = function(manifestIndex) {
        var manifests = this.getManifests();
        var manifest;
        for(var i = 0; i < manifests.length; i++){
            var m = manifests[i];
            if (m.index === manifestIndex) manifest = m;
        }
        if (manifest) {
            manifest.options.index = manifestIndex;
            return manifest.load();
        } else throw new Error("Manifest index not found");
    };
    Collection.prototype.getTotalCollections = function() {
        return this.getCollections().length;
    };
    Collection.prototype.getTotalManifests = function() {
        return this.getManifests().length;
    };
    Collection.prototype.getTotalItems = function() {
        return this.items.length;
    };
    Collection.prototype.getViewingDirection = function() {
        if (this.getProperty("viewingDirection")) return this.getProperty("viewingDirection");
        return $loafo.ViewingDirection.LEFT_TO_RIGHT;
    };
    /**
     * Note: this only will return the first behavior as per the manifesto convention
     * IIIF v3 supports multiple behaviors
     */ Collection.prototype.getBehavior = function() {
        var behavior = this.getProperty("behavior");
        if (Array.isArray(behavior)) behavior = behavior[0];
        if (behavior) return behavior;
        return null;
    };
    Collection.prototype.getViewingHint = function() {
        return this.getProperty("viewingHint");
    };
    /**
     * Get a tree of sub collections and manifests, using each child manifest's first 'top' range.
     */ Collection.prototype.getDefaultTree = function() {
        _super.prototype.getDefaultTree.call(this);
        //console.log("get default tree for ", this.id);
        this.defaultTree.data.type = $bpdXW.Utils.normaliseType($bpdXW.TreeNodeType.COLLECTION);
        this._parseManifests(this);
        this._parseCollections(this);
        $bpdXW.Utils.generateTreeNodeIds(this.defaultTree);
        return this.defaultTree;
    };
    Collection.prototype._parseManifests = function(parentCollection) {
        if (parentCollection.getManifests() && parentCollection.getManifests().length) for(var i = 0; i < parentCollection.getManifests().length; i++){
            var manifest = parentCollection.getManifests()[i];
            var tree = manifest.getDefaultTree();
            tree.label = manifest.parentLabel || manifest.getLabel().getValue(this.options.locale) || "manifest " + (i + 1);
            tree.navDate = manifest.getNavDate();
            tree.data.id = manifest.id;
            tree.data.type = $bpdXW.Utils.normaliseType($bpdXW.TreeNodeType.MANIFEST);
            parentCollection.defaultTree.addNode(tree);
        }
    };
    Collection.prototype._parseCollections = function(parentCollection) {
        //console.log("parse collections for ", parentCollection.id);
        if (parentCollection.getCollections() && parentCollection.getCollections().length) for(var i = 0; i < parentCollection.getCollections().length; i++){
            var collection = parentCollection.getCollections()[i];
            var tree = collection.getDefaultTree();
            tree.label = collection.parentLabel || collection.getLabel().getValue(this.options.locale) || "collection " + (i + 1);
            tree.navDate = collection.getNavDate();
            tree.data.id = collection.id;
            tree.data.type = $bpdXW.Utils.normaliseType($bpdXW.TreeNodeType.COLLECTION);
            parentCollection.defaultTree.addNode(tree);
        }
    };
    return Collection;
}($bpdXW.IIIFResource);
module.exports.Collection = $3d9e3b37c05774f0$var$Collection;

});

parcelRegister("dKTPk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Duration = void 0;
var $a03ae04e2c3ae305$var$Duration = /** @class */ function() {
    function Duration(start, end) {
        this.start = start;
        this.end = end;
    }
    Duration.prototype.getLength = function() {
        return this.end - this.start;
    };
    return Duration;
}();
module.exports.Duration = $a03ae04e2c3ae305$var$Duration;

});

parcelRegister("Gt4Z0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("1tewS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("br9Gf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("gNUMp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("eTMqj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("aiIi8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("8elFM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LabelValuePair = void 0;

var $bpdXW = parcelRequire("bpdXW");
var $5fe07156eb60c638$var$LabelValuePair = /** @class */ function() {
    function LabelValuePair(defaultLocale) {
        this.defaultLocale = defaultLocale;
    }
    LabelValuePair.prototype.parse = function(resource) {
        this.resource = resource;
        this.label = $bpdXW.PropertyValue.parse(this.resource.label, this.defaultLocale);
        this.value = $bpdXW.PropertyValue.parse(this.resource.value, this.defaultLocale);
    };
    // shortcuts to get/set values based on user or default locale
    LabelValuePair.prototype.getLabel = function(locale) {
        if (this.label === null) return null;
        if (Array.isArray(locale) && !locale.length) locale = undefined;
        return this.label.getValue(locale || this.defaultLocale);
    };
    LabelValuePair.prototype.setLabel = function(value) {
        if (this.label === null) this.label = new $bpdXW.PropertyValue([]);
        this.label.setValue(value, this.defaultLocale);
    };
    LabelValuePair.prototype.getValue = function(locale, joinWith) {
        if (joinWith === void 0) joinWith = "<br/>";
        if (this.value === null) return null;
        if (Array.isArray(locale) && !locale.length) locale = undefined;
        return this.value.getValue(locale || this.defaultLocale, joinWith);
    };
    LabelValuePair.prototype.getValues = function(locale) {
        if (this.value === null) return [];
        if (Array.isArray(locale) && !locale.length) locale = undefined;
        return this.value.getValues(locale || this.defaultLocale);
    };
    LabelValuePair.prototype.setValue = function(value) {
        if (this.value === null) this.value = new $bpdXW.PropertyValue([]);
        this.value.setValue(value, this.defaultLocale);
    };
    return LabelValuePair;
}();
module.exports.LabelValuePair = $5fe07156eb60c638$var$LabelValuePair;

});

parcelRegister("hIWZm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("hngIS", function(module, exports) {
"use strict";
var $ca618e7318c2ca0a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LanguageMap = void 0;
/** @deprecated Use PropertyValue instead */ var $ca618e7318c2ca0a$var$LanguageMap = /** @class */ function(_super) {
    $ca618e7318c2ca0a$var$__extends(LanguageMap, _super);
    function LanguageMap() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /** @deprecated Use the `PropertyValue#getValue` instance method instead */ LanguageMap.getValue = function(languageCollection, locale) {
        return languageCollection.getValue(locale, "<br/>");
    };
    /** @deprecated Use the `PropertyValue#getValues` instance method instead */ LanguageMap.getValues = function(languageCollection, locale) {
        return languageCollection.getValues(locale);
    };
    return LanguageMap;
}(Array);
module.exports.LanguageMap = $ca618e7318c2ca0a$var$LanguageMap;

});

parcelRegister("4UQGi", function(module, exports) {
"use strict";
var $394541c3e878b321$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PropertyValue = module.exports.LocalizedValue = void 0;

var $fFio0 = parcelRequire("fFio0");
/** Utility class to hold one or more values with their associated (optional) locale */ var $394541c3e878b321$var$LocalizedValue = /** @class */ function() {
    function LocalizedValue(value, locale, defaultLocale) {
        if (defaultLocale === void 0) defaultLocale = "none";
        if (Array.isArray(value) && value.length === 1) this._value = value[0];
        else this._value = value;
        if (locale === "none" || locale === "@none") locale = undefined;
        this._locale = locale;
        this._defaultLocale = defaultLocale;
    }
    /** Parse a localized value from a IIIF v2 property value
     *
     * @param {string | string[] | object | object[]} rawVal value from IIIF resource
     * @param {string | undefined} defaultLocale deprecated: defaultLocale the default locale to use for this value
     */ LocalizedValue.parseV2Value = function(rawVal, defaultLocale) {
        if (typeof rawVal === "string") return new LocalizedValue(rawVal, undefined, defaultLocale);
        else if (rawVal["@value"]) return new LocalizedValue(rawVal["@value"], rawVal["@language"], defaultLocale);
        return null;
    };
    Object.defineProperty(LocalizedValue.prototype, "value", {
        /*** @deprecated Use PropertyValue#getValue instead */ get: function() {
            if (Array.isArray(this._value)) return this._value.join("<br/>");
            return this._value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LocalizedValue.prototype, "locale", {
        /*** @deprecated Don't use, only used for backwards compatibility reasons */ get: function() {
            if (this._locale === undefined) return this._defaultLocale;
            return this._locale;
        },
        enumerable: false,
        configurable: true
    });
    LocalizedValue.prototype.addValue = function(value) {
        if (!Array.isArray(this._value)) this._value = [
            this._value
        ];
        if (Array.isArray(value)) this._value = this._value.concat(value);
        else this._value.push(value);
    };
    return LocalizedValue;
}();
module.exports.LocalizedValue = $394541c3e878b321$var$LocalizedValue;
/***
 * Holds a collection of values and their (optional) languages and allows
 * language-based value retrieval as per the algorithm described in
 * https://iiif.io/api/presentation/2.1/#language-of-property-values
 */ var $394541c3e878b321$var$PropertyValue = /** @class */ function(_super) {
    $394541c3e878b321$var$__extends(PropertyValue, _super);
    function PropertyValue(values, defaultLocale) {
        if (values === void 0) values = [];
        var _this = _super.apply(this, values) || this;
        // Needed for ES5 compatibility, see https://stackoverflow.com/a/40967939
        _this.__proto__ = PropertyValue.prototype;
        _this._defaultLocale = defaultLocale;
        return _this;
    }
    PropertyValue.parse = function(rawVal, defaultLocale) {
        if (!rawVal) return new PropertyValue([], defaultLocale);
        if (Array.isArray(rawVal)) {
            // Collection of IIIF v2 property values
            var parsed = rawVal.map(function(v) {
                return $394541c3e878b321$var$LocalizedValue.parseV2Value(v, defaultLocale);
            }).filter(function(v) {
                return v !== null;
            });
            var byLocale = parsed.reduce(function(acc, lv) {
                var loc = lv._locale;
                if (!loc) // Cannot use undefined as an object key
                loc = "none";
                if (acc[loc]) acc[loc].addValue(lv._value);
                else acc[loc] = lv;
                return acc;
            }, {});
            return new PropertyValue(Object.values(byLocale), defaultLocale);
        } else if (typeof rawVal === "string") return new PropertyValue([
            new $394541c3e878b321$var$LocalizedValue(rawVal, undefined, defaultLocale)
        ], defaultLocale);
        else if (rawVal["@language"]) {
            // Single IIIF v2 property value
            var parsed = $394541c3e878b321$var$LocalizedValue.parseV2Value(rawVal);
            return new PropertyValue(parsed !== null ? [
                parsed
            ] : [], defaultLocale);
        } else if (rawVal["@value"]) {
            // Single IIIF v2 property value without language
            var parsed = $394541c3e878b321$var$LocalizedValue.parseV2Value(rawVal);
            return new PropertyValue(parsed !== null ? [
                parsed
            ] : [], defaultLocale);
        } else // IIIF v3 property value
        return new PropertyValue(Object.keys(rawVal).map(function(locale) {
            var val = rawVal[locale];
            if (!Array.isArray(val)) throw new Error("A IIIF v3 localized property value must have an array as the value for a given language.");
            return new $394541c3e878b321$var$LocalizedValue(val, locale, defaultLocale);
        }), defaultLocale);
    };
    /*** Try to find the available locale that best fit's the user's preferences. */ PropertyValue.prototype.getSuitableLocale = function(locales) {
        // If any of the values have a language associated with them, the client
        // must display all of the values associated with the language that best
        // matches the language preference.
        if (locales.length == 0 && this._defaultLocale) locales.push(this._defaultLocale);
        // create an array of the language codes for all different LocalizedValue instances in this PropertyValue
        var allLocales = new Array();
        for(var _i = 0, _a = this; _i < _a.length; _i++){
            var lv = _a[_i];
            if (lv._locale != undefined) allLocales.push(lv._locale);
        }
        var _loop_1 = function(userLocale) {
            var matchingLocale = allLocales.find(function(l) {
                return l === userLocale;
            });
            if (matchingLocale) return {
                value: matchingLocale
            };
        };
        // First, look for a precise match
        for(var _b = 0, locales_1 = locales; _b < locales_1.length; _b++){
            var userLocale = locales_1[_b];
            var state_1 = _loop_1(userLocale);
            if (typeof state_1 === "object") return state_1.value;
        }
        var _loop_2 = function(userLocale) {
            var matchingLocale = allLocales.find(function(l) {
                return $fFio0.Utils.getInexactLocale(l) === $fFio0.Utils.getInexactLocale(userLocale);
            });
            if (matchingLocale) return {
                value: matchingLocale
            };
        };
        // Look for an inexact match
        for(var _c = 0, locales_2 = locales; _c < locales_2.length; _c++){
            var userLocale = locales_2[_c];
            var state_2 = _loop_2(userLocale);
            if (typeof state_2 === "object") return state_2.value;
        }
        return undefined;
    };
    /**
     * Set the value(s) for a given locale.
     *
     * If there's an existing locale that matches the given locale, it will be updated.
     *
     * @param locale Locale to set the value for
     * @param value value to set
     */ PropertyValue.prototype.setValue = function(value, locale) {
        var existing = undefined;
        if (!locale) existing = this.find(function(lv) {
            return lv._locale === undefined;
        });
        else {
            var bestLocale_1 = this.getSuitableLocale([
                locale
            ]);
            if (bestLocale_1) existing = this.find(function(lv) {
                return lv._locale === bestLocale_1;
            });
        }
        if (existing) // Mutate existing localized value
        existing._value = value;
        else // Create a new localized value
        this.push(new $394541c3e878b321$var$LocalizedValue(value, locale, this._defaultLocale));
    };
    /**
     * Get a value in the most suitable locale.
     *
     * @param {string | string[] | undefined} locales Desired locale, can be a list of
     * locales sorted by descending priority.
     * @param {string | undefined} joinWith String to join multiple available values by,
     * if undefined only the first available value will be returned
     * @returns the first value in the most suitable locale or null if none could be found
     */ PropertyValue.prototype.getValue = function(locales, joinWith) {
        var vals = this.getValues(locales);
        if (vals.length === 0) return null;
        if (joinWith) return vals.join(joinWith);
        return vals[0];
    };
    /**
     * Get all values available in the most suitable locale.
     *
     * @param {string | string[]} userLocales Desired locale, can be a list of
     * locales sorted by descending priority.
     * @returns the values for the most suitable locale, empty if none could be found
     */ PropertyValue.prototype.getValues = function(userLocales) {
        if (!this.length) return [];
        var locales;
        if (!userLocales) locales = [];
        else if (!Array.isArray(userLocales)) locales = [
            userLocales
        ];
        else locales = userLocales;
        // If none of the values have a language associated with them, the client
        // must display all of the values.
        if (this.length === 1 && this[0]._locale === undefined) {
            var val = this[0]._value;
            return Array.isArray(val) ? val : [
                val
            ];
        }
        // Try to determine the available locale that best fits the user's preferences
        var matchingLocale = this.getSuitableLocale(locales);
        if (matchingLocale) {
            var val = this.find(function(lv) {
                return lv._locale === matchingLocale;
            })._value;
            return Array.isArray(val) ? val : [
                val
            ];
        }
        // If all of the values have a language associated with them, and none match
        // the language preference, the client must select a language and display
        // all of the values associated with that language.
        var allHaveLang = !this.find(function(lv) {
            return lv._locale === undefined;
        });
        if (allHaveLang) {
            var val = this[0]._value;
            return Array.isArray(val) ? val : [
                val
            ];
        }
        // If some of the values have a language associated with them, but none
        // match the language preference, the client must display all of the values
        // that do not have a language associated with them.
        var lv = this.find(function(lv) {
            return lv._locale === undefined;
        });
        if (lv) return Array.isArray(lv._value) ? lv._value : [
            lv._value
        ];
        return [];
    };
    return PropertyValue;
}(Array);
module.exports.PropertyValue = $394541c3e878b321$var$PropertyValue;

});
parcelRegister("fFio0", function(module, exports) {
"use strict";
var $b678f2721831ffd7$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $b678f2721831ffd7$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Utils = void 0;

var $bpdXW = parcelRequire("bpdXW");

var $loafo = parcelRequire("loafo");

var $jZjKO = parcelRequire("jZjKO");
parcelRequire("5MPpy");
var $b678f2721831ffd7$var$Utils = /** @class */ function() {
    function Utils() {}
    Utils.getMediaType = function(type) {
        type = type.toLowerCase();
        type = type.split(";")[0];
        return type.trim();
    };
    Utils.getImageQuality = function(profile) {
        if (profile === $loafo.ServiceProfile.IMAGE_0_COMPLIANCE_LEVEL_1 || profile === $loafo.ServiceProfile.IMAGE_0_COMPLIANCE_LEVEL_2 || profile === $loafo.ServiceProfile.IMAGE_1_COMPLIANCE_LEVEL_1 || profile === $loafo.ServiceProfile.IMAGE_1_COMPLIANCE_LEVEL_2 || profile === $loafo.ServiceProfile.IMAGE_0_CONFORMANCE_LEVEL_1 || profile === $loafo.ServiceProfile.IMAGE_0_CONFORMANCE_LEVEL_2 || profile === $loafo.ServiceProfile.IMAGE_1_CONFORMANCE_LEVEL_1 || profile === $loafo.ServiceProfile.IMAGE_1_CONFORMANCE_LEVEL_2 || profile === $loafo.ServiceProfile.IMAGE_1_LEVEL_1 || profile === $loafo.ServiceProfile.IMAGE_1_PROFILE_LEVEL_1 || profile === $loafo.ServiceProfile.IMAGE_1_LEVEL_2 || profile === $loafo.ServiceProfile.IMAGE_1_PROFILE_LEVEL_2) return "native";
        return "default";
    };
    Utils.getInexactLocale = function(locale) {
        if (locale.indexOf("-") !== -1) return locale.substr(0, locale.indexOf("-"));
        return locale;
    };
    Utils.getLocalisedValue = function(resource, locale) {
        // if the resource is not an array of translations, return the string.
        if (!Array.isArray(resource)) return resource;
        // test for exact match
        for(var i = 0; i < resource.length; i++){
            var value_1 = resource[i];
            var language_1 = value_1["@language"];
            if (locale === language_1) return value_1["@value"];
        }
        // test for inexact match
        var match = locale.substr(0, locale.indexOf("-"));
        for(var i = 0; i < resource.length; i++){
            var value = resource[i];
            var language = value["@language"];
            if (language === match) return value["@value"];
        }
        return null;
    };
    Utils.generateTreeNodeIds = function(treeNode, index) {
        if (index === void 0) index = 0;
        var id;
        if (!treeNode.parentNode) id = "0";
        else id = treeNode.parentNode.id + "-" + index;
        treeNode.id = id;
        for(var i = 0; i < treeNode.nodes.length; i++){
            var n = treeNode.nodes[i];
            Utils.generateTreeNodeIds(n, i);
        }
    };
    Utils.normaliseType = function(type) {
        type = (type || "").toLowerCase();
        if (type.indexOf(":") !== -1) {
            var split = type.split(":");
            return split[1];
        }
        return type;
    };
    Utils.normaliseUrl = function(url) {
        url = url.substr(url.indexOf("://"));
        if (url.indexOf("#") !== -1) url = url.split("#")[0];
        return url;
    };
    Utils.normalisedUrlsMatch = function(url1, url2) {
        return Utils.normaliseUrl(url1) === Utils.normaliseUrl(url2);
    };
    Utils.isImageProfile = function(profile) {
        if (Utils.normalisedUrlsMatch(profile, $loafo.ServiceProfile.IMAGE_0_COMPLIANCE_LEVEL_0) || Utils.normalisedUrlsMatch(profile, $loafo.ServiceProfile.IMAGE_0_COMPLIANCE_LEVEL_1) || Utils.normalisedUrlsMatch(profile, $loafo.ServiceProfile.IMAGE_0_COMPLIANCE_LEVEL_2) || Utils.normalisedUrlsMatch(profile, $loafo.ServiceProfile.IMAGE_1_COMPLIANCE_LEVEL_0) || Utils.normalisedUrlsMatch(profile, $loafo.ServiceProfile.IMAGE_1_COMPLIANCE_LEVEL_2) || Utils.normalisedUrlsMatch(profile, $loafo.ServiceProfile.IMAGE_0_CONFORMANCE_LEVEL_0) || Utils.normalisedUrlsMatch(profile, $loafo.ServiceProfile.IMAGE_0_CONFORMANCE_LEVEL_1) || Utils.normalisedUrlsMatch(profile, $loafo.ServiceProfile.IMAGE_0_CONFORMANCE_LEVEL_2) || Utils.normalisedUrlsMatch(profile, $loafo.ServiceProfile.IMAGE_1_CONFORMANCE_LEVEL_1) || Utils.normalisedUrlsMatch(profile, $loafo.ServiceProfile.IMAGE_1_CONFORMANCE_LEVEL_2) || Utils.normalisedUrlsMatch(profile, $loafo.ServiceProfile.IMAGE_1_LEVEL_0) || Utils.normalisedUrlsMatch(profile, $loafo.ServiceProfile.IMAGE_1_PROFILE_LEVEL_0) || Utils.normalisedUrlsMatch(profile, $loafo.ServiceProfile.IMAGE_1_LEVEL_1) || Utils.normalisedUrlsMatch(profile, $loafo.ServiceProfile.IMAGE_1_PROFILE_LEVEL_1) || Utils.normalisedUrlsMatch(profile, $loafo.ServiceProfile.IMAGE_1_LEVEL_2) || Utils.normalisedUrlsMatch(profile, $loafo.ServiceProfile.IMAGE_1_PROFILE_LEVEL_2) || Utils.normalisedUrlsMatch(profile, $loafo.ServiceProfile.IMAGE_2_LEVEL_0) || Utils.normalisedUrlsMatch(profile, $loafo.ServiceProfile.IMAGE_2_PROFILE_LEVEL_0) || Utils.normalisedUrlsMatch(profile, $loafo.ServiceProfile.IMAGE_2_LEVEL_1) || Utils.normalisedUrlsMatch(profile, $loafo.ServiceProfile.IMAGE_2_PROFILE_LEVEL_1) || Utils.normalisedUrlsMatch(profile, $loafo.ServiceProfile.IMAGE_2_LEVEL_2) || Utils.normalisedUrlsMatch(profile, $loafo.ServiceProfile.IMAGE_2_PROFILE_LEVEL_2)) return true;
        return false;
    };
    Utils.isImageServiceType = function(type) {
        return type !== null && type.toLowerCase() === $loafo.ServiceType.IMAGE_SERVICE_2.toLowerCase() || type === $loafo.ServiceType.IMAGE_SERVICE_3.toLowerCase();
    };
    Utils.isLevel0ImageProfile = function(profile) {
        if (Utils.normalisedUrlsMatch(profile, $loafo.ServiceProfile.IMAGE_0_COMPLIANCE_LEVEL_0) || Utils.normalisedUrlsMatch(profile, $loafo.ServiceProfile.IMAGE_1_COMPLIANCE_LEVEL_0) || Utils.normalisedUrlsMatch(profile, $loafo.ServiceProfile.IMAGE_0_CONFORMANCE_LEVEL_0) || Utils.normalisedUrlsMatch(profile, $loafo.ServiceProfile.IMAGE_1_CONFORMANCE_LEVEL_0) || Utils.normalisedUrlsMatch(profile, $loafo.ServiceProfile.IMAGE_1_LEVEL_0) || Utils.normalisedUrlsMatch(profile, $loafo.ServiceProfile.IMAGE_1_PROFILE_LEVEL_0) || Utils.normalisedUrlsMatch(profile, $loafo.ServiceProfile.IMAGE_2_LEVEL_0) || Utils.normalisedUrlsMatch(profile, $loafo.ServiceProfile.IMAGE_2_PROFILE_LEVEL_0)) return true;
        return false;
    };
    Utils.isLevel1ImageProfile = function(profile) {
        if (Utils.normalisedUrlsMatch(profile, $loafo.ServiceProfile.IMAGE_0_COMPLIANCE_LEVEL_1) || Utils.normalisedUrlsMatch(profile, $loafo.ServiceProfile.IMAGE_1_COMPLIANCE_LEVEL_1) || Utils.normalisedUrlsMatch(profile, $loafo.ServiceProfile.IMAGE_0_CONFORMANCE_LEVEL_1) || Utils.normalisedUrlsMatch(profile, $loafo.ServiceProfile.IMAGE_1_CONFORMANCE_LEVEL_1) || Utils.normalisedUrlsMatch(profile, $loafo.ServiceProfile.IMAGE_1_LEVEL_1) || Utils.normalisedUrlsMatch(profile, $loafo.ServiceProfile.IMAGE_1_PROFILE_LEVEL_1) || Utils.normalisedUrlsMatch(profile, $loafo.ServiceProfile.IMAGE_2_LEVEL_1) || Utils.normalisedUrlsMatch(profile, $loafo.ServiceProfile.IMAGE_2_PROFILE_LEVEL_1)) return true;
        return false;
    };
    Utils.isLevel2ImageProfile = function(profile) {
        if (Utils.normalisedUrlsMatch(profile, $loafo.ServiceProfile.IMAGE_0_COMPLIANCE_LEVEL_2) || Utils.normalisedUrlsMatch(profile, $loafo.ServiceProfile.IMAGE_1_COMPLIANCE_LEVEL_2) || Utils.normalisedUrlsMatch(profile, $loafo.ServiceProfile.IMAGE_0_CONFORMANCE_LEVEL_2) || Utils.normalisedUrlsMatch(profile, $loafo.ServiceProfile.IMAGE_1_CONFORMANCE_LEVEL_2) || Utils.normalisedUrlsMatch(profile, $loafo.ServiceProfile.IMAGE_1_LEVEL_2) || Utils.normalisedUrlsMatch(profile, $loafo.ServiceProfile.IMAGE_1_PROFILE_LEVEL_2) || Utils.normalisedUrlsMatch(profile, $loafo.ServiceProfile.IMAGE_2_LEVEL_2) || Utils.normalisedUrlsMatch(profile, $loafo.ServiceProfile.IMAGE_2_PROFILE_LEVEL_2)) return true;
        return false;
    };
    Utils.parseManifest = function(manifest, options) {
        return $bpdXW.Deserialiser.parse(manifest, options);
    };
    Utils.checkStatus = function(response) {
        if (response.ok) return response;
        else {
            var error = new Error(response.statusText);
            error.response = response;
            return Promise.reject(error);
        }
    };
    Utils.loadManifest = function(url) {
        return new Promise(function(resolve, reject) {
            fetch(url).then(Utils.checkStatus).then(function(r) {
                return r.json();
            }).then(function(data) {
                resolve(data);
            }).catch(function(err) {
                reject();
            });
        });
    };
    Utils.loadExternalResourcesAuth1 = function(resources, openContentProviderInteraction, openTokenService, getStoredAccessToken, userInteractedWithContentProvider, getContentProviderInteraction, handleMovedTemporarily, showOutOfOptionsMessages) {
        return new Promise(function(resolve, reject) {
            var promises = resources.map(function(resource) {
                return Utils.loadExternalResourceAuth1(resource, openContentProviderInteraction, openTokenService, getStoredAccessToken, userInteractedWithContentProvider, getContentProviderInteraction, handleMovedTemporarily, showOutOfOptionsMessages);
            });
            Promise.all(promises).then(function() {
                resolve(resources);
            })["catch"](function(error) {
                reject(error);
            });
        });
    };
    Utils.loadExternalResourceAuth1 = function(resource, openContentProviderInteraction, openTokenService, getStoredAccessToken, userInteractedWithContentProvider, getContentProviderInteraction, handleMovedTemporarily, showOutOfOptionsMessages) {
        return $b678f2721831ffd7$var$__awaiter(this, void 0, void 0, function() {
            var storedAccessToken;
            return $b678f2721831ffd7$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            getStoredAccessToken(resource)
                        ];
                    case 1:
                        storedAccessToken = _a.sent();
                        if (!storedAccessToken) return [
                            3 /*break*/ ,
                            6
                        ];
                        return [
                            4 /*yield*/ ,
                            resource.getData(storedAccessToken)
                        ];
                    case 2:
                        _a.sent();
                        if (!(resource.status === $jZjKO.OK)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            2 /*return*/ ,
                            resource
                        ];
                    case 3:
                        // the stored token is no good for this resource
                        return [
                            4 /*yield*/ ,
                            Utils.doAuthChain(resource, openContentProviderInteraction, openTokenService, userInteractedWithContentProvider, getContentProviderInteraction, handleMovedTemporarily, showOutOfOptionsMessages)
                        ];
                    case 4:
                        // the stored token is no good for this resource
                        _a.sent();
                        _a.label = 5;
                    case 5:
                        if (resource.status === $jZjKO.OK || resource.status === $jZjKO.MOVED_TEMPORARILY) return [
                            2 /*return*/ ,
                            resource
                        ];
                        throw Utils.createAuthorizationFailedError();
                    case 6:
                        return [
                            4 /*yield*/ ,
                            resource.getData()
                        ];
                    case 7:
                        _a.sent();
                        if (!(resource.status === $jZjKO.MOVED_TEMPORARILY || resource.status === $jZjKO.UNAUTHORIZED)) return [
                            3 /*break*/ ,
                            9
                        ];
                        return [
                            4 /*yield*/ ,
                            Utils.doAuthChain(resource, openContentProviderInteraction, openTokenService, userInteractedWithContentProvider, getContentProviderInteraction, handleMovedTemporarily, showOutOfOptionsMessages)
                        ];
                    case 8:
                        _a.sent();
                        _a.label = 9;
                    case 9:
                        if (resource.status === $jZjKO.OK || resource.status === $jZjKO.MOVED_TEMPORARILY) return [
                            2 /*return*/ ,
                            resource
                        ];
                        throw Utils.createAuthorizationFailedError();
                }
            });
        });
    };
    Utils.doAuthChain = function(resource, openContentProviderInteraction, openTokenService, userInteractedWithContentProvider, getContentProviderInteraction, handleMovedTemporarily, showOutOfOptionsMessages) {
        return $b678f2721831ffd7$var$__awaiter(this, void 0, void 0, function() {
            var externalService, kioskService, clickThroughService, loginService, serviceToTry, lastAttempted, kioskInteraction, contentProviderInteraction, contentProviderInteraction;
            return $b678f2721831ffd7$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        // This function enters the flowchart at the < External? > junction
                        // http://iiif.io/api/auth/1.0/#workflow-from-the-browser-client-perspective
                        if (!resource.isAccessControlled()) return [
                            2 /*return*/ ,
                            resource
                        ]; // no services found
                        externalService = resource.externalService;
                        if (externalService) externalService.options = resource.options;
                        kioskService = resource.kioskService;
                        if (kioskService) kioskService.options = resource.options;
                        clickThroughService = resource.clickThroughService;
                        if (clickThroughService) clickThroughService.options = resource.options;
                        loginService = resource.loginService;
                        if (loginService) loginService.options = resource.options;
                        if (!(!resource.isResponseHandled && resource.status === $jZjKO.MOVED_TEMPORARILY)) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            handleMovedTemporarily(resource)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            resource
                        ];
                    case 2:
                        serviceToTry = null;
                        lastAttempted = null;
                        // repetition of logic is left in these steps for clarity:
                        // Looking for external pattern
                        serviceToTry = externalService;
                        if (!serviceToTry) return [
                            3 /*break*/ ,
                            4
                        ];
                        lastAttempted = serviceToTry;
                        return [
                            4 /*yield*/ ,
                            Utils.attemptResourceWithToken(resource, openTokenService, serviceToTry)
                        ];
                    case 3:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            resource
                        ];
                    case 4:
                        // Looking for kiosk pattern
                        serviceToTry = kioskService;
                        if (!serviceToTry) return [
                            3 /*break*/ ,
                            7
                        ];
                        lastAttempted = serviceToTry;
                        kioskInteraction = openContentProviderInteraction(serviceToTry);
                        if (!kioskInteraction) return [
                            3 /*break*/ ,
                            7
                        ];
                        return [
                            4 /*yield*/ ,
                            userInteractedWithContentProvider(kioskInteraction)
                        ];
                    case 5:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            Utils.attemptResourceWithToken(resource, openTokenService, serviceToTry)
                        ];
                    case 6:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            resource
                        ];
                    case 7:
                        // The code for the next two patterns is identical (other than the profile name).
                        // The difference is in the expected behaviour of
                        //
                        //    await userInteractedWithContentProvider(contentProviderInteraction);
                        //
                        // For clickthrough the opened window should close immediately having established
                        // a session, whereas for login the user might spend some time entering credentials etc.
                        // Looking for clickthrough pattern
                        serviceToTry = clickThroughService;
                        if (!serviceToTry) return [
                            3 /*break*/ ,
                            11
                        ];
                        lastAttempted = serviceToTry;
                        return [
                            4 /*yield*/ ,
                            getContentProviderInteraction(resource, serviceToTry)
                        ];
                    case 8:
                        contentProviderInteraction = _a.sent();
                        if (!contentProviderInteraction) return [
                            3 /*break*/ ,
                            11
                        ];
                        // should close immediately
                        return [
                            4 /*yield*/ ,
                            userInteractedWithContentProvider(contentProviderInteraction)
                        ];
                    case 9:
                        // should close immediately
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            Utils.attemptResourceWithToken(resource, openTokenService, serviceToTry)
                        ];
                    case 10:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            resource
                        ];
                    case 11:
                        // Looking for login pattern
                        serviceToTry = loginService;
                        if (!serviceToTry) return [
                            3 /*break*/ ,
                            15
                        ];
                        lastAttempted = serviceToTry;
                        return [
                            4 /*yield*/ ,
                            getContentProviderInteraction(resource, serviceToTry)
                        ];
                    case 12:
                        contentProviderInteraction = _a.sent();
                        if (!contentProviderInteraction) return [
                            3 /*break*/ ,
                            15
                        ];
                        // we expect the user to spend some time interacting
                        return [
                            4 /*yield*/ ,
                            userInteractedWithContentProvider(contentProviderInteraction)
                        ];
                    case 13:
                        // we expect the user to spend some time interacting
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            Utils.attemptResourceWithToken(resource, openTokenService, serviceToTry)
                        ];
                    case 14:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            resource
                        ];
                    case 15:
                        // nothing worked! Use the most recently tried service as the source of
                        // messages to show to the user.
                        if (lastAttempted) showOutOfOptionsMessages(resource, lastAttempted);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Utils.attemptResourceWithToken = function(resource, openTokenService, authService) {
        return $b678f2721831ffd7$var$__awaiter(this, void 0, void 0, function() {
            var tokenService, tokenMessage;
            return $b678f2721831ffd7$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        tokenService = authService.getService($loafo.ServiceProfile.AUTH_1_TOKEN);
                        if (!tokenService) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            openTokenService(resource, tokenService)
                        ];
                    case 1:
                        tokenMessage = _a.sent();
                        if (!(tokenMessage && tokenMessage.accessToken)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            resource.getData(tokenMessage)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            resource
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Utils.loadExternalResourcesAuth09 = function(resources, tokenStorageStrategy, clickThrough, restricted, login, getAccessToken, storeAccessToken, getStoredAccessToken, handleResourceResponse, options) {
        return new Promise(function(resolve, reject) {
            var promises = resources.map(function(resource) {
                return Utils.loadExternalResourceAuth09(resource, tokenStorageStrategy, clickThrough, restricted, login, getAccessToken, storeAccessToken, getStoredAccessToken, handleResourceResponse, options);
            });
            Promise.all(promises).then(function() {
                resolve(resources);
            })["catch"](function(error) {
                reject(error);
            });
        });
    };
    // IIIF auth api pre v1.0
    // Keeping this around for now until the auth 1.0 implementation is stable
    Utils.loadExternalResourceAuth09 = function(resource, tokenStorageStrategy, clickThrough, restricted, login, getAccessToken, storeAccessToken, getStoredAccessToken, handleResourceResponse, options) {
        return new Promise(function(resolve, reject) {
            if (options && options.pessimisticAccessControl) // pessimistic: access control cookies may have been deleted.
            // always request the access token for every access controlled info.json request
            // returned access tokens are not stored, therefore the login window flashes for every request.
            resource.getData().then(function() {
                if (resource.isAccessControlled()) {
                    // if the resource has a click through service, use that.
                    if (resource.clickThroughService) {
                        resolve(clickThrough(resource));
                        //} else if(resource.restrictedService) {
                        resolve(restricted(resource));
                    } else login(resource).then(function() {
                        getAccessToken(resource, true).then(function(token) {
                            resource.getData(token).then(function() {
                                resolve(handleResourceResponse(resource));
                            })["catch"](function(message) {
                                reject(Utils.createInternalServerError(message));
                            });
                        })["catch"](function(message) {
                            reject(Utils.createInternalServerError(message));
                        });
                    })["catch"](function(message) {
                        reject(Utils.createInternalServerError(message));
                    });
                } else // this info.json isn't access controlled, therefore no need to request an access token.
                resolve(resource);
            })["catch"](function(message) {
                reject(Utils.createInternalServerError(message));
            });
            else // optimistic: access control cookies may not have been deleted.
            // store access tokens to avoid login window flashes.
            // if cookies are deleted a page refresh is required.
            // try loading the resource using an access token that matches the info.json domain.
            // if an access token is found, request the resource using it regardless of whether it is access controlled.
            getStoredAccessToken(resource, tokenStorageStrategy).then(function(storedAccessToken) {
                if (storedAccessToken) // try using the stored access token
                resource.getData(storedAccessToken).then(function() {
                    // if the info.json loaded using the stored access token
                    if (resource.status === $jZjKO.OK) resolve(handleResourceResponse(resource));
                    else // otherwise, load the resource data to determine the correct access control services.
                    // if access controlled, do login.
                    Utils.authorize(resource, tokenStorageStrategy, clickThrough, restricted, login, getAccessToken, storeAccessToken, getStoredAccessToken).then(function() {
                        resolve(handleResourceResponse(resource));
                    })["catch"](function(error) {
                        // if (resource.restrictedService){
                        //     reject(Utils.createRestrictedError());
                        // } else {
                        reject(Utils.createAuthorizationFailedError());
                    //}
                    });
                })["catch"](function(error) {
                    reject(Utils.createAuthorizationFailedError());
                });
                else Utils.authorize(resource, tokenStorageStrategy, clickThrough, restricted, login, getAccessToken, storeAccessToken, getStoredAccessToken).then(function() {
                    resolve(handleResourceResponse(resource));
                })["catch"](function(error) {
                    reject(Utils.createAuthorizationFailedError());
                });
            })["catch"](function(error) {
                reject(Utils.createAuthorizationFailedError());
            });
        });
    };
    Utils.createError = function(name, message) {
        var error = new Error();
        error.message = message;
        error.name = String(name);
        return error;
    };
    Utils.createAuthorizationFailedError = function() {
        return Utils.createError($bpdXW.StatusCode.AUTHORIZATION_FAILED, "Authorization failed");
    };
    Utils.createRestrictedError = function() {
        return Utils.createError($bpdXW.StatusCode.RESTRICTED, "Restricted");
    };
    Utils.createInternalServerError = function(message) {
        return Utils.createError($bpdXW.StatusCode.INTERNAL_SERVER_ERROR, message);
    };
    Utils.authorize = function(resource, tokenStorageStrategy, clickThrough, restricted, login, getAccessToken, storeAccessToken, getStoredAccessToken) {
        return new Promise(function(resolve, reject) {
            resource.getData().then(function() {
                if (resource.isAccessControlled()) getStoredAccessToken(resource, tokenStorageStrategy).then(function(storedAccessToken) {
                    if (storedAccessToken) // try using the stored access token
                    resource.getData(storedAccessToken).then(function() {
                        if (resource.status === $jZjKO.OK) resolve(resource); // happy path ended
                        else // the stored token is no good for this resource
                        Utils.showAuthInteraction(resource, tokenStorageStrategy, clickThrough, restricted, login, getAccessToken, storeAccessToken, resolve, reject);
                    })["catch"](function(message) {
                        reject(Utils.createInternalServerError(message));
                    });
                    else // There was no stored token, but the user might have a cookie that will grant a token
                    getAccessToken(resource, false).then(function(accessToken) {
                        if (accessToken) storeAccessToken(resource, accessToken, tokenStorageStrategy).then(function() {
                            // try using the fresh access token
                            resource.getData(accessToken).then(function() {
                                if (resource.status === $jZjKO.OK) resolve(resource);
                                else // User has a token, but it's not good enough
                                Utils.showAuthInteraction(resource, tokenStorageStrategy, clickThrough, restricted, login, getAccessToken, storeAccessToken, resolve, reject);
                            })["catch"](function(message) {
                                reject(Utils.createInternalServerError(message));
                            });
                        })["catch"](function(message) {
                            // not able to store access token
                            reject(Utils.createInternalServerError(message));
                        });
                        else // The user did not have a cookie that granted a token
                        Utils.showAuthInteraction(resource, tokenStorageStrategy, clickThrough, restricted, login, getAccessToken, storeAccessToken, resolve, reject);
                    });
                })["catch"](function(message) {
                    reject(Utils.createInternalServerError(message));
                });
                else // this info.json isn't access controlled, therefore there's no need to request an access token
                resolve(resource);
            });
        });
    };
    Utils.showAuthInteraction = function(resource, tokenStorageStrategy, clickThrough, restricted, login, getAccessToken, storeAccessToken, resolve, reject) {
        if (resource.status === $jZjKO.MOVED_TEMPORARILY && !resource.isResponseHandled) // if the resource was redirected to a degraded version
        // and the response hasn't been handled yet.
        // if the client wishes to trigger a login, set resource.isResponseHandled to true
        // and call loadExternalResources() again passing the resource.
        resolve(resource);
        else if (resource.clickThroughService && !resource.isResponseHandled) // if the resource has a click through service, use that.
        clickThrough(resource).then(function() {
            getAccessToken(resource, true).then(function(accessToken) {
                storeAccessToken(resource, accessToken, tokenStorageStrategy).then(function() {
                    resource.getData(accessToken).then(function() {
                        resolve(resource);
                    })["catch"](function(message) {
                        reject(Utils.createInternalServerError(message));
                    });
                })["catch"](function(message) {
                    reject(Utils.createInternalServerError(message));
                });
            })["catch"](function(message) {
                reject(Utils.createInternalServerError(message));
            });
        });
        else // get an access token
        login(resource).then(function() {
            getAccessToken(resource, true).then(function(accessToken) {
                storeAccessToken(resource, accessToken, tokenStorageStrategy).then(function() {
                    resource.getData(accessToken).then(function() {
                        resolve(resource);
                    })["catch"](function(message) {
                        reject(Utils.createInternalServerError(message));
                    });
                })["catch"](function(message) {
                    reject(Utils.createInternalServerError(message));
                });
            })["catch"](function(message) {
                reject(Utils.createInternalServerError(message));
            });
        });
    };
    Utils.getService = function(resource, profile) {
        var services = this.getServices(resource);
        for(var i = 0; i < services.length; i++){
            var service = services[i];
            if (service.getProfile() === profile) return service;
        }
        return null;
    };
    Utils.getResourceById = function(parentResource, id) {
        return Utils.traverseAndFind(parentResource.__jsonld, "@id", id);
    };
    /**
     * Does a depth first traversal of an Object, returning an Object that
     * matches provided k and v arguments
     * @example Utils.traverseAndFind({foo: 'bar'}, 'foo', 'bar')
     */ Utils.traverseAndFind = function(object, k, v) {
        if (object.hasOwnProperty(k) && object[k] === v) return object;
        for(var i = 0; i < Object.keys(object).length; i++)if (typeof object[Object.keys(object)[i]] === "object") {
            var o = Utils.traverseAndFind(object[Object.keys(object)[i]], k, v);
            if (o != null) return o;
        }
        return undefined;
    };
    Utils.getServices = function(resource, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.onlyService, onlyService = _c === void 0 ? false : _c, _d = _b.onlyServices, onlyServices = _d === void 0 ? false : _d, _e = _b.skipParentResources, skipParentResources = _e === void 0 ? false : _e;
        var services = [];
        // Resources can reference "services" on the manifest. This is a bit of a hack to just get the services from the manifest
        // too. What would be better is if this was used as a "Map" of full services.
        // So when you come across { id: '...' } without any data, you can "lookup" services from the manifest.
        // I would have implemented this if I was confident that it was reliable. Instead, I opted for the safest option that
        // should not break any existing services.
        if (!skipParentResources && resource && resource.options && resource.options.resource && resource.options.resource !== resource) services.push.apply(services, Utils.getServices(resource.options.resource, {
            onlyServices: true
        }));
        var service = !onlyServices ? (resource.__jsonld || resource).service || [] : [];
        // coerce to array
        if (!Array.isArray(service)) service = [
            service
        ];
        if (!onlyService) // Some resources also have a `.services` property.
        // https://iiif.io/api/presentation/3.0/#services
        service.push.apply(service, (resource.__jsonld || resource).services || []);
        if (service.length === 0) return services;
        for(var i = 0; i < service.length; i++){
            var s = service[i];
            if (typeof s === "string") {
                var r = this.getResourceById(resource.options.resource, s);
                if (r) services.push(new $bpdXW.Service(r.__jsonld || r, resource.options));
            } else services.push(new $bpdXW.Service(s, resource.options));
        }
        return services;
    };
    Utils.getTemporalComponent = function(target) {
        var temporal = /t=([^&]+)/g.exec(target);
        var t = null;
        if (temporal && temporal[1]) t = temporal[1].split(",");
        return t;
    };
    return Utils;
}();
module.exports.Utils = $b678f2721831ffd7$var$Utils;

});
parcelRegister("jZjKO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CONTINUE = 100;
module.exports.SWITCHING_PROTOCOLS = 101;
module.exports.PROCESSING = 102;
module.exports.OK = 200;
module.exports.CREATED = 201;
module.exports.ACCEPTED = 202;
module.exports.NON_AUTHORITATIVE_INFORMATION = 203;
module.exports.NO_CONTENT = 204;
module.exports.RESET_CONTENT = 205;
module.exports.PARTIAL_CONTENT = 206;
module.exports.MULTI_STATUS = 207;
module.exports.MULTIPLE_CHOICES = 300;
module.exports.MOVED_PERMANENTLY = 301;
module.exports.MOVED_TEMPORARILY = 302;
module.exports.SEE_OTHER = 303;
module.exports.NOT_MODIFIED = 304;
module.exports.USE_PROXY = 305;
module.exports.TEMPORARY_REDIRECT = 307;
module.exports.BAD_REQUEST = 400;
module.exports.UNAUTHORIZED = 401;
module.exports.PAYMENT_REQUIRED = 402;
module.exports.FORBIDDEN = 403;
module.exports.NOT_FOUND = 404;
module.exports.METHOD_NOT_ALLOWED = 405;
module.exports.NOT_ACCEPTABLE = 406;
module.exports.PROXY_AUTHENTICATION_REQUIRED = 407;
module.exports.REQUEST_TIME_OUT = 408;
module.exports.CONFLICT = 409;
module.exports.GONE = 410;
module.exports.LENGTH_REQUIRED = 411;
module.exports.PRECONDITION_FAILED = 412;
module.exports.REQUEST_ENTITY_TOO_LARGE = 413;
module.exports.REQUEST_URI_TOO_LARGE = 414;
module.exports.UNSUPPORTED_MEDIA_TYPE = 415;
module.exports.REQUESTED_RANGE_NOT_SATISFIABLE = 416;
module.exports.EXPECTATION_FAILED = 417;
module.exports.IM_A_TEAPOT = 418;
module.exports.UNPROCESSABLE_ENTITY = 422;
module.exports.LOCKED = 423;
module.exports.FAILED_DEPENDENCY = 424;
module.exports.UNORDERED_COLLECTION = 425;
module.exports.UPGRADE_REQUIRED = 426;
module.exports.PRECONDITION_REQUIRED = 428;
module.exports.TOO_MANY_REQUESTS = 429;
module.exports.REQUEST_HEADER_FIELDS_TOO_LARGE = 431;
module.exports.INTERNAL_SERVER_ERROR = 500;
module.exports.NOT_IMPLEMENTED = 501;
module.exports.BAD_GATEWAY = 502;
module.exports.SERVICE_UNAVAILABLE = 503;
module.exports.GATEWAY_TIME_OUT = 504;
module.exports.HTTP_VERSION_NOT_SUPPORTED = 505;
module.exports.VARIANT_ALSO_NEGOTIATES = 506;
module.exports.INSUFFICIENT_STORAGE = 507;
module.exports.BANDWIDTH_LIMIT_EXCEEDED = 509;
module.exports.NOT_EXTENDED = 510;
module.exports.NETWORK_AUTHENTICATION_REQUIRED = 511;

});

parcelRegister("5MPpy", function(module, exports) {


module.exports = self.fetch || (self.fetch = (parcelRequire("laOt8")).default || (parcelRequire("laOt8")));

});
parcelRegister("laOt8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f6a1ae3267718cab$export$2e2bcd8739ae039);
function $f6a1ae3267718cab$export$2e2bcd8739ae039(e, n) {
    return n = n || {}, new Promise(function(t, r) {
        var s = new XMLHttpRequest, o = [], u = [], i = {}, a = function() {
            return {
                ok: 2 == (s.status / 100 | 0),
                statusText: s.statusText,
                status: s.status,
                url: s.responseURL,
                text: function() {
                    return Promise.resolve(s.responseText);
                },
                json: function() {
                    return Promise.resolve(s.responseText).then(JSON.parse);
                },
                blob: function() {
                    return Promise.resolve(new Blob([
                        s.response
                    ]));
                },
                clone: a,
                headers: {
                    keys: function() {
                        return o;
                    },
                    entries: function() {
                        return u;
                    },
                    get: function(e) {
                        return i[e.toLowerCase()];
                    },
                    has: function(e) {
                        return e.toLowerCase() in i;
                    }
                }
            };
        };
        for(var l in s.open(n.method || "get", e, !0), s.onload = function() {
            s.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(e, n, t) {
                o.push(n = n.toLowerCase()), u.push([
                    n,
                    t
                ]), i[n] = i[n] ? i[n] + "," + t : t;
            }), t(a());
        }, s.onerror = r, s.withCredentials = "include" == n.credentials, n.headers)s.setRequestHeader(l, n.headers[l]);
        s.send(n.body || null);
    });
}

});




parcelRegister("1SB3n", function(module, exports) {
"use strict";
var $15e7939dece6a330$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Manifest = void 0;

var $loafo = parcelRequire("loafo");

var $bpdXW = parcelRequire("bpdXW");
/**
* @remarks Scenes are conveniently retrieved from a Manifest by iterating through
* Sequence in the Manifest, inner loop the Scenes in each sequence
* @see {@link Sequence }
*
* @example
* var manifest: Manifest;
* function doSomethingWithScene(scene:Scene)...
* ...
* foreach(var seq:Sequence of manifest.getSequences()
*   foreach(var scene : Scene of seq.getScenes()
*     doSomethingWithScene(scene);
**/ var $15e7939dece6a330$var$Manifest = /** @class */ function(_super) {
    $15e7939dece6a330$var$__extends(Manifest, _super);
    function Manifest(jsonld, options) {
        var _this = _super.call(this, jsonld, options) || this;
        _this.index = 0;
        _this._allRanges = null;
        _this.items = [];
        _this._topRanges = [];
        if (_this.__jsonld.structures && _this.__jsonld.structures.length) {
            var topRanges = _this._getTopRanges();
            for(var i = 0; i < topRanges.length; i++){
                var range = topRanges[i];
                _this._parseRanges(range, String(i));
            }
        }
        // initialization the cached _annotationIdMap to null
        // it will be populated if and only if client calls make a request
        // to the getter annotationIdMap
        _this._annotationIdMap = null;
        return _this;
    }
    /** @deprecated Use getAccompanyingCanvas instead */ Manifest.prototype.getPosterCanvas = function() {
        var posterCanvas = this.getProperty("posterCanvas");
        if (posterCanvas) posterCanvas = new $bpdXW.Canvas(posterCanvas, this.options);
        return posterCanvas;
    };
    Manifest.prototype.getAccompanyingCanvas = function() {
        var accompanyingCanvas = this.getProperty("accompanyingCanvas");
        if (accompanyingCanvas) accompanyingCanvas = new $bpdXW.Canvas(accompanyingCanvas, this.options);
        return accompanyingCanvas;
    };
    Manifest.prototype.getBehavior = function() {
        var behavior = this.getProperty("behavior");
        if (Array.isArray(behavior)) behavior = behavior[0];
        if (behavior) return behavior;
        return null;
    };
    Manifest.prototype.getDefaultTree = function() {
        _super.prototype.getDefaultTree.call(this);
        this.defaultTree.data.type = $bpdXW.Utils.normaliseType($bpdXW.TreeNodeType.MANIFEST);
        if (!this.isLoaded) return this.defaultTree;
        var topRanges = this.getTopRanges();
        // if there are any ranges in the manifest, default to the first 'top' range or generated placeholder
        if (topRanges.length) topRanges[0].getTree(this.defaultTree);
        $bpdXW.Utils.generateTreeNodeIds(this.defaultTree);
        return this.defaultTree;
    };
    Manifest.prototype._getTopRanges = function() {
        var topRanges = [];
        if (this.__jsonld.structures && this.__jsonld.structures.length) {
            for(var i = 0; i < this.__jsonld.structures.length; i++){
                var json = this.__jsonld.structures[i];
                if (json.viewingHint === $loafo.ViewingHint.TOP) topRanges.push(json);
            }
            // if no viewingHint="top" range was found, create a default one
            if (!topRanges.length) {
                var range = {};
                range.ranges = this.__jsonld.structures;
                topRanges.push(range);
            }
        }
        return topRanges;
    };
    Manifest.prototype.getTopRanges = function() {
        return this._topRanges;
    };
    Manifest.prototype._getRangeById = function(id) {
        if (this.__jsonld.structures && this.__jsonld.structures.length) for(var i = 0; i < this.__jsonld.structures.length; i++){
            var r = this.__jsonld.structures[i];
            if (r["@id"] === id || r.id === id) return r;
        }
        return null;
    };
    //private _parseRangeCanvas(json: any, range: Range): void {
    // todo: currently this isn't needed
    //var canvas: IJSONLDResource = new JSONLDResource(json);
    //range.items.push(<IManifestResource>canvas);
    //}
    Manifest.prototype._parseRanges = function(r, path, parentRange) {
        var range;
        var id = null;
        if (typeof r === "string") {
            id = r;
            r = this._getRangeById(id);
        }
        if (!r) {
            console.warn("Range:", id, "does not exist");
            return;
        }
        range = new $bpdXW.Range(r, this.options);
        range.parentRange = parentRange;
        range.path = path;
        if (!parentRange) this._topRanges.push(range);
        else parentRange.items.push(range);
        var items = r.items || r.members;
        if (items) for(var i = 0; i < items.length; i++){
            var item = items[i];
            // todo: use an ItemType constant?
            if (item["@type"] && item["@type"].toLowerCase() === "sc:range" || item["type"] && item["type"].toLowerCase() === "range") this._parseRanges(item, path + "/" + i, range);
            else if (item["@type"] && item["@type"].toLowerCase() === "sc:canvas" || item["type"] && item["type"].toLowerCase() === "canvas") {
                // store the ids on the __jsonld object to be used by Range.getCanvasIds()
                if (!range.canvases) range.canvases = [];
                var id_1 = item.id || item["@id"];
                range.canvases.push(id_1);
            }
        }
        else if (r.ranges) for(var i = 0; i < r.ranges.length; i++)this._parseRanges(r.ranges[i], path + "/" + i, range);
    };
    Manifest.prototype.getAllRanges = function() {
        if (this._allRanges != null) return this._allRanges;
        this._allRanges = [];
        var topRanges = this.getTopRanges();
        var _loop_1 = function(i) {
            var topRange = topRanges[i];
            if (topRange.id) this_1._allRanges.push(topRange); // it might be a placeholder root range
            var reducer = function(acc, next) {
                acc.add(next);
                var nextRanges = next.getRanges();
                if (nextRanges.length) return nextRanges.reduce(reducer, acc);
                return acc;
            };
            var subRanges = Array.from(topRange.getRanges().reduce(reducer, new Set()));
            this_1._allRanges = this_1._allRanges.concat(subRanges);
        };
        var this_1 = this;
        for(var i = 0; i < topRanges.length; i++)_loop_1(i);
        return this._allRanges;
    };
    Manifest.prototype.getRangeById = function(id) {
        var ranges = this.getAllRanges();
        for(var i = 0; i < ranges.length; i++){
            var range = ranges[i];
            if (range.id === id) return range;
        }
        return null;
    };
    Manifest.prototype.getRangeByPath = function(path) {
        var ranges = this.getAllRanges();
        for(var i = 0; i < ranges.length; i++){
            var range = ranges[i];
            if (range.path === path) return range;
        }
        return null;
    };
    /**
    * @returns Array of Sequence instances
    **/ Manifest.prototype.getSequences = function() {
        if (this.items.length) return this.items;
        // IxIF mediaSequences overrode sequences, so need to be checked first.
        // deprecate this when presentation 3 ships
        var items = this.__jsonld.mediaSequences || this.__jsonld.sequences;
        if (items) for(var i = 0; i < items.length; i++){
            var s = items[i];
            var sequence = new $bpdXW.Sequence(s, this.options);
            this.items.push(sequence);
        }
        else if (this.__jsonld.items) {
            var sequence = new $bpdXW.Sequence(this.__jsonld.items, this.options);
            this.items.push(sequence);
        }
        return this.items;
    };
    Manifest.prototype.getSequenceByIndex = function(sequenceIndex) {
        return this.getSequences()[sequenceIndex];
    };
    Manifest.prototype.getTotalSequences = function() {
        return this.getSequences().length;
    };
    Manifest.prototype.getManifestType = function() {
        var service = this.getService($loafo.ServiceProfile.UI_EXTENSIONS);
        if (service) return service.getProperty("manifestType");
        return $bpdXW.ManifestType.EMPTY;
    };
    Manifest.prototype.isMultiSequence = function() {
        return this.getTotalSequences() > 1;
    };
    Manifest.prototype.isPagingEnabled = function() {
        var viewingHint = this.getViewingHint();
        if (viewingHint) return viewingHint === $loafo.ViewingHint.PAGED;
        var behavior = this.getBehavior();
        if (behavior) return behavior === $loafo.Behavior.PAGED;
        return false;
    };
    Manifest.prototype.getViewingDirection = function() {
        return this.getProperty("viewingDirection");
    };
    Manifest.prototype.getViewingHint = function() {
        return this.getProperty("viewingHint");
    };
    Object.defineProperty(Manifest.prototype, "annotationIdMap", {
        /**
        * Developer Note: The concept of the "id map" appear in the
        * JSON-LD specification https://www.w3.org/TR/json-ld11/#dfn-id-map
        * This functionality may be available as well in the 'nodeMap' code of the
        * digitalbazaar/jsonld library
        *
        * this very simplified version just returns a mao of id -> Annotation nodes
        * in manifest
        *
        * THe annotationIdMap is a Javascript object whose property names are
        * IRI (id values) and property values are instances of the Annotation class
        **/ get: function() {
            if (this._annotationIdMap == null) {
                this._annotationIdMap = {};
                for(var _i = 0, _a = this.getSequences(); _i < _a.length; _i++){
                    var seq = _a[_i];
                    for(var _b = 0, _c = seq.getScenes(); _b < _c.length; _b++){
                        var scene = _c[_b];
                        for(var _d = 0, _e = scene.getContent(); _d < _e.length; _d++){
                            var anno = _e[_d];
                            this._annotationIdMap[anno.id] = anno;
                        }
                    }
                }
            }
            return this._annotationIdMap;
        },
        enumerable: false,
        configurable: true
    });
    return Manifest;
}($bpdXW.IIIFResource);
module.exports.Manifest = $15e7939dece6a330$var$Manifest;

});

parcelRegister("aWk7d", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ManifestType = void 0;
var $7f6eecacaf6fc803$var$ManifestType;
(function(ManifestType) {
    ManifestType["EMPTY"] = "";
    ManifestType["MANUSCRIPT"] = "manuscript";
    ManifestType["MONOGRAPH"] = "monograph";
})($7f6eecacaf6fc803$var$ManifestType || (module.exports.ManifestType = $7f6eecacaf6fc803$var$ManifestType = {}));

});

parcelRegister("lUdGQ", function(module, exports) {
"use strict";
var $ff29727dd25da4cd$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PointSelector = void 0;

var $bpdXW = parcelRequire("bpdXW");

var $3uWBl = parcelRequire("3uWBl");
var $ff29727dd25da4cd$var$PointSelector = /** @class */ function(_super) {
    $ff29727dd25da4cd$var$__extends(PointSelector, _super);
    function PointSelector(jsonld) {
        var _this = _super.call(this, jsonld) || this;
        _this.isPointSelector = true;
        return _this;
    }
    /**
    @returns the 3D coordinates of the point as a Vector3 instance.
    **/ PointSelector.prototype.getLocation = function() {
        return new $3uWBl.Vector3(this.__jsonld.x, this.__jsonld.y, this.__jsonld.z);
    };
    Object.defineProperty(PointSelector.prototype, "Location", {
        /**
        @returns the 3D coordinates of the point as a Vector3 instance.
        **/ get: function() {
            return this.getLocation();
        },
        enumerable: false,
        configurable: true
    });
    return PointSelector;
}($bpdXW.JSONLDResource);
module.exports.PointSelector = $ff29727dd25da4cd$var$PointSelector;

});

parcelRegister("53zBL", function(module, exports) {
"use strict";
var $3ae8da920ca495fe$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Range = void 0;

var $bpdXW = parcelRequire("bpdXW");

var $loafo = parcelRequire("loafo");
var $3ae8da920ca495fe$var$Range = /** @class */ function(_super) {
    $3ae8da920ca495fe$var$__extends(Range, _super);
    function Range(jsonld, options) {
        var _this = _super.call(this, jsonld, options) || this;
        _this._ranges = null;
        _this.canvases = null;
        _this.items = [];
        return _this;
    }
    Range.prototype.getCanvasIds = function() {
        if (this.__jsonld.canvases) return this.__jsonld.canvases;
        else if (this.canvases) return this.canvases;
        return [];
    };
    Range.prototype.getDuration = function() {
        // For this implementation, we want to catch SOME of the temporal cases - i.e. when there is a t=1,100
        if (this.canvases && this.canvases.length) {
            var startTimes = [];
            var endTimes = [];
            // When we loop through all of the canvases we store the recorded start and end times.
            // Then we choose the maximum and minimum values from this. This will give us a more accurate duration for the
            // Chosen range. However this is still not perfect and does not cover more complex ranges. These cases are out of
            // scope for this change.
            for(var _i = 0, _a = this.canvases; _i < _a.length; _i++){
                var canvas = _a[_i];
                if (!canvas) continue;
                var _b = canvas.match(/(.*)#t=([0-9.]+),?([0-9.]+)?/) || [
                    undefined,
                    canvas
                ], canvasId = _b[1], start_1 = _b[2], end_1 = _b[3];
                if (canvasId) {
                    startTimes.push(parseFloat(start_1));
                    endTimes.push(parseFloat(end_1));
                }
            }
            if (startTimes.length && endTimes.length) return new $bpdXW.Duration(Math.min.apply(Math, startTimes), Math.max.apply(Math, endTimes));
        } else {
            // get child ranges and calculate the start and end based on them
            var childRanges = this.getRanges();
            var startTimes = [];
            var endTimes = [];
            // Once again, we use a max/min to get the ranges.
            for(var _c = 0, childRanges_1 = childRanges; _c < childRanges_1.length; _c++){
                var childRange = childRanges_1[_c];
                var duration = childRange.getDuration();
                if (duration) {
                    startTimes.push(duration.start);
                    endTimes.push(duration.end);
                }
            }
            // And return the minimum as the start, and the maximum as the end.
            if (startTimes.length && endTimes.length) return new $bpdXW.Duration(Math.min.apply(Math, startTimes), Math.max.apply(Math, endTimes));
        }
        var start;
        var end;
        // There are 2 paths for this implementation. Either we have a list of canvases, or a list of ranges
        // which may have a list of ranges.
        // This is one of the limitations of this implementation.
        if (this.canvases && this.canvases.length) // When we loop through each of the canvases we are expecting to see a fragment or a link to the whole canvas.
        // For example - if we have http://example.org/canvas#t=1,100 it will extract 1 and 100 as the start and end.
        for(var i = 0; i < this.canvases.length; i++){
            var canvas = this.canvases[i];
            var temporal = $bpdXW.Utils.getTemporalComponent(canvas);
            if (temporal && temporal.length > 1) {
                if (i === 0) // Note: Cannot guarantee ranges are sequential (fixed above)
                start = Number(temporal[0]);
                if (i === this.canvases.length - 1) end = Number(temporal[1]); // Note: The end of this duration may be targeting a different canvas.
            }
        }
        else {
            // In this second case, where there are nested ranges, we recursively get the duration
            // from each of the child ranges (a start and end) and then choose the first and last for the bounds of this range.
            var childRanges = this.getRanges();
            for(var i = 0; i < childRanges.length; i++){
                var childRange = childRanges[i];
                var duration = childRange.getDuration();
                if (duration) {
                    if (i === 0) start = duration.start;
                    if (i === childRanges.length - 1) end = duration.end;
                }
            }
        }
        if (start !== undefined && end !== undefined) return new $bpdXW.Duration(start, end);
        return undefined;
    };
    // getCanvases(): ICanvas[] {
    //     if (this._canvases) {
    //         return this._canvases;
    //     }
    //     return this._canvases = <ICanvas[]>this.items.en().where(m => m.isCanvas()).toArray();
    // }
    Range.prototype.getRanges = function() {
        if (this._ranges) return this._ranges;
        return this._ranges = this.items.filter(function(m) {
            return m.isRange();
        });
    };
    Range.prototype.getBehavior = function() {
        var behavior = this.getProperty("behavior");
        if (Array.isArray(behavior)) behavior = behavior[0];
        if (behavior) return behavior;
        return null;
    };
    Range.prototype.getViewingDirection = function() {
        return this.getProperty("viewingDirection");
    };
    Range.prototype.getViewingHint = function() {
        return this.getProperty("viewingHint");
    };
    Range.prototype.getTree = function(treeRoot) {
        treeRoot.data = this;
        this.treeNode = treeRoot;
        var ranges = this.getRanges();
        if (ranges && ranges.length) for(var i = 0; i < ranges.length; i++){
            var range = ranges[i];
            var node = new $bpdXW.TreeNode();
            treeRoot.addNode(node);
            this._parseTreeNode(node, range);
        }
        $bpdXW.Utils.generateTreeNodeIds(treeRoot);
        return treeRoot;
    };
    Range.prototype.spansTime = function(time) {
        var duration = this.getDuration();
        if (duration) {
            if (time >= duration.start && time <= duration.end) return true;
        }
        return false;
    };
    Range.prototype._parseTreeNode = function(node, range) {
        node.label = range.getLabel().getValue(this.options.locale);
        node.data = range;
        node.data.type = $bpdXW.Utils.normaliseType($bpdXW.TreeNodeType.RANGE);
        range.treeNode = node;
        var ranges = range.getRanges();
        if (ranges && ranges.length) for(var i = 0; i < ranges.length; i++){
            var childRange = ranges[i];
            var behavior = childRange.getBehavior();
            if (behavior === $loafo.Behavior.NO_NAV) continue;
            else {
                var childNode = new $bpdXW.TreeNode();
                node.addNode(childNode);
                this._parseTreeNode(childNode, childRange);
            }
        }
    };
    return Range;
}($bpdXW.ManifestResource);
module.exports.Range = $3ae8da920ca495fe$var$Range;

});

parcelRegister("lGjrj", function(module, exports) {
"use strict";
var $fc8c9985a3a207e0$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Rendering = void 0;

var $bpdXW = parcelRequire("bpdXW");
var $fc8c9985a3a207e0$var$Rendering = /** @class */ function(_super) {
    $fc8c9985a3a207e0$var$__extends(Rendering, _super);
    function Rendering(jsonld, options) {
        return _super.call(this, jsonld, options) || this;
    }
    Rendering.prototype.getFormat = function() {
        return this.getProperty("format");
    };
    return Rendering;
}($bpdXW.ManifestResource);
module.exports.Rendering = $fc8c9985a3a207e0$var$Rendering;

});

parcelRegister("2oYJZ", function(module, exports) {
"use strict";
var $1bfcf086ada7a9ae$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Scene = void 0;

var $bpdXW = parcelRequire("bpdXW");
var $1bfcf086ada7a9ae$var$Scene = /** @class */ function(_super) {
    $1bfcf086ada7a9ae$var$__extends(Scene, _super);
    function Scene(jsonld, options) {
        return _super.call(this, jsonld, options) || this;
    }
    // Presentation API 3.0
    Scene.prototype.getContent = function() {
        var content = [];
        var items = this.__jsonld.items || this.__jsonld.content;
        if (!items) return content;
        // should be contained in an AnnotationPage
        var annotationPage = null;
        if (items.length) annotationPage = new $bpdXW.AnnotationPage(items[0], this.options);
        if (!annotationPage) return content;
        var annotations = annotationPage.getItems();
        for(var i = 0; i < annotations.length; i++){
            var a = annotations[i];
            var annotation = new $bpdXW.Annotation(a, this.options);
            content.push(annotation);
        }
        return content;
    };
    Object.defineProperty(Scene.prototype, "Content", {
        // 3D extension
        get: function() {
            return this.getContent();
        },
        enumerable: false,
        configurable: true
    });
    Scene.prototype.getAnnotationById = function(searchId) {
        for(var _i = 0, _a = this.Content; _i < _a.length; _i++){
            var anno = _a[_i];
            if (anno.id === searchId) return anno;
        }
        return null;
    };
    Scene.prototype.getBackgroundColor = function() {
        // regular expression intended to match strings like
        // "#FF00FF" -- interpreted as three hexadecimal values
        // in range 0-255 . Not that the \w escape matches digits,
        // upper and lower case latin characters, and underscore
        // currently only supports the form for CSS
        // https://www.w3.org/wiki/CSS/Properties/color/RGB
        // with 6 hexadecimal digits
        var bgc = this.getProperty("backgroundColor");
        if (bgc) return $bpdXW.Color.fromCSS(bgc);
        else return null;
    };
    return Scene;
}($bpdXW.ManifestResource);
module.exports.Scene = $1bfcf086ada7a9ae$var$Scene;

});

parcelRegister("jeD8Q", function(module, exports) {
"use strict";
var $e00dafdb437be532$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sequence = void 0;

var $loafo = parcelRequire("loafo");

var $bpdXW = parcelRequire("bpdXW");
var $e00dafdb437be532$var$Sequence = /** @class */ function(_super) {
    $e00dafdb437be532$var$__extends(Sequence, _super);
    function Sequence(jsonld, options) {
        var _this = _super.call(this, jsonld, options) || this;
        _this.items = [];
        _this._thumbnails = null;
        return _this;
    }
    Sequence.prototype.getCanvases = function() {
        if (this.items.length) return this.items;
        var items = this.__jsonld.canvases || this.__jsonld.elements;
        if (items) for(var i = 0; i < items.length; i++){
            var c = items[i];
            var canvas = new $bpdXW.Canvas(c, this.options);
            canvas.index = i;
            this.items.push(canvas);
        }
        else if (this.__jsonld) for(var i = 0; i < this.__jsonld.length; i++){
            var c = this.__jsonld[i];
            var canvas = new $bpdXW.Canvas(c, this.options);
            canvas.index = i;
            this.items.push(canvas);
        }
        return this.items;
    };
    Sequence.prototype.getCanvasById = function(id) {
        for(var i = 0; i < this.getTotalCanvases(); i++){
            var canvas = this.getCanvasByIndex(i);
            // normalise canvas id
            var canvasId = $bpdXW.Utils.normaliseUrl(canvas.id);
            if ($bpdXW.Utils.normaliseUrl(id) === canvasId) return canvas;
        }
        return null;
    };
    Sequence.prototype.getCanvasByIndex = function(canvasIndex) {
        return this.getCanvases()[canvasIndex];
    };
    Sequence.prototype.getCanvasIndexById = function(id) {
        for(var i = 0; i < this.getTotalCanvases(); i++){
            var canvas = this.getCanvasByIndex(i);
            if (canvas.id === id) return i;
        }
        return null;
    };
    Sequence.prototype.getCanvasIndexByLabel = function(label, foliated) {
        label = label.trim();
        if (!isNaN(label)) {
            // if the label is numeric
            label = parseInt(label, 10).toString(); // trim any preceding zeros.
            if (foliated) label += "r"; // default to recto
        }
        var doublePageRegExp = /(\d*)\D+(\d*)/;
        var match, regExp, regStr, labelPart1, labelPart2;
        for(var i = 0; i < this.getTotalCanvases(); i++){
            var canvas = this.getCanvasByIndex(i);
            // check if there's a literal match
            if (canvas.getLabel().getValue(this.options.locale) === label) return i;
            // check if there's a match for double-page spreads e.g. 100-101, 100_101, 100 101
            match = doublePageRegExp.exec(label);
            if (!match) continue;
            labelPart1 = match[1];
            labelPart2 = match[2];
            if (!labelPart2) continue;
            regStr = "^" + labelPart1 + "\\D+" + labelPart2 + "$";
            regExp = new RegExp(regStr);
            if (regExp.test(canvas.getLabel().toString())) return i;
        }
        return -1;
    };
    Sequence.prototype.getLastCanvasLabel = function(alphanumeric) {
        for(var i = this.getTotalCanvases() - 1; i >= 0; i--){
            var canvas = this.getCanvasByIndex(i);
            var label = canvas.getLabel().getValue(this.options.locale);
            if (alphanumeric) {
                var regExp = /^[a-zA-Z0-9]*$/;
                if (regExp.test(label)) return label;
            } else if (label) return label;
        }
        return this.options.defaultLabel;
    };
    Sequence.prototype.getLastPageIndex = function() {
        return this.getTotalCanvases() - 1;
    };
    Sequence.prototype.getNextPageIndex = function(canvasIndex, pagingEnabled) {
        var index;
        if (pagingEnabled) {
            var indices = this.getPagedIndices(canvasIndex);
            var viewingDirection = this.getViewingDirection();
            if (viewingDirection && viewingDirection === $loafo.ViewingDirection.RIGHT_TO_LEFT) index = indices[0] + 1;
            else index = indices[indices.length - 1] + 1;
        } else index = canvasIndex + 1;
        if (index > this.getLastPageIndex()) return -1;
        return index;
    };
    Sequence.prototype.getPagedIndices = function(canvasIndex, pagingEnabled) {
        var indices = [];
        if (!pagingEnabled) indices.push(canvasIndex);
        else {
            if (this.isFirstCanvas(canvasIndex) || this.isLastCanvas(canvasIndex)) indices = [
                canvasIndex
            ];
            else if (canvasIndex % 2) indices = [
                canvasIndex,
                canvasIndex + 1
            ];
            else indices = [
                canvasIndex - 1,
                canvasIndex
            ];
            var viewingDirection = this.getViewingDirection();
            if (viewingDirection && viewingDirection === $loafo.ViewingDirection.RIGHT_TO_LEFT) indices = indices.reverse();
        }
        return indices;
    };
    Sequence.prototype.getPrevPageIndex = function(canvasIndex, pagingEnabled) {
        var index;
        if (pagingEnabled) {
            var indices = this.getPagedIndices(canvasIndex);
            var viewingDirection = this.getViewingDirection();
            if (viewingDirection && viewingDirection === $loafo.ViewingDirection.RIGHT_TO_LEFT) index = indices[indices.length - 1] - 1;
            else index = indices[0] - 1;
        } else index = canvasIndex - 1;
        return index;
    };
    /**
    * @returns Array of Scene instances in the Sequence
    **/ Sequence.prototype.getScenes = function() {
        var returnVal = [];
        var low_items = this.__jsonld.elements || this.__jsonld;
        if (low_items) for(var i = 0; i < low_items.length; ++i){
            var c = low_items[i];
            if (c.type === 'Scene') {
                var scene = new $bpdXW.Scene(c, this.options);
                //scene.index = i;
                returnVal.push(scene);
            }
        }
        return returnVal;
    };
    Sequence.prototype.getStartCanvasIndex = function() {
        var startCanvas = this.getStartCanvas();
        if (startCanvas) // if there's a startCanvas attribute, loop through the canvases and return the matching index.
        for(var i = 0; i < this.getTotalCanvases(); i++){
            var canvas = this.getCanvasByIndex(i);
            if (canvas.id === startCanvas) return i;
        }
        // default to first canvas.
        return 0;
    };
    // todo: deprecate
    Sequence.prototype.getThumbs = function(width, height) {
        //console.warn('getThumbs will be deprecated, use getThumbnails instead');
        var thumbs = [];
        var totalCanvases = this.getTotalCanvases();
        for(var i = 0; i < totalCanvases; i++){
            var canvas = this.getCanvasByIndex(i);
            var thumb = new $bpdXW.Thumb(width, canvas);
            thumbs.push(thumb);
        }
        return thumbs;
    };
    Sequence.prototype.getThumbnails = function() {
        if (this._thumbnails != null) return this._thumbnails;
        this._thumbnails = [];
        var canvases = this.getCanvases();
        for(var i = 0; i < canvases.length; i++){
            var thumbnail = canvases[i].getThumbnail();
            if (thumbnail) this._thumbnails.push(thumbnail);
        }
        return this._thumbnails;
    };
    Sequence.prototype.getStartCanvas = function() {
        return this.getProperty("startCanvas");
    };
    Sequence.prototype.getTotalCanvases = function() {
        return this.getCanvases().length;
    };
    Sequence.prototype.getViewingDirection = function() {
        if (this.getProperty("viewingDirection")) return this.getProperty("viewingDirection");
        else if (this.options.resource.getViewingDirection) return this.options.resource.getViewingDirection();
        return null;
    };
    Sequence.prototype.getViewingHint = function() {
        return this.getProperty("viewingHint");
    };
    Sequence.prototype.isCanvasIndexOutOfRange = function(canvasIndex) {
        return canvasIndex > this.getTotalCanvases() - 1;
    };
    Sequence.prototype.isFirstCanvas = function(canvasIndex) {
        return canvasIndex === 0;
    };
    Sequence.prototype.isLastCanvas = function(canvasIndex) {
        return canvasIndex === this.getTotalCanvases() - 1;
    };
    Sequence.prototype.isMultiCanvas = function() {
        return this.getTotalCanvases() > 1;
    };
    Sequence.prototype.isPagingEnabled = function() {
        var viewingHint = this.getViewingHint();
        if (viewingHint) return viewingHint === $loafo.ViewingHint.PAGED;
        return false;
    };
    // checks if the number of canvases is even - therefore has a front and back cover
    Sequence.prototype.isTotalCanvasesEven = function() {
        return this.getTotalCanvases() % 2 === 0;
    };
    return Sequence;
}($bpdXW.ManifestResource);
module.exports.Sequence = $e00dafdb437be532$var$Sequence;

});

parcelRegister("2JO3k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Deserialiser = void 0;

var $bpdXW = parcelRequire("bpdXW");
var $1fe69c26f0280a59$var$Deserialiser = /** @class */ function() {
    function Deserialiser() {}
    Deserialiser.parse = function(manifest, options) {
        if (typeof manifest === "string") manifest = JSON.parse(manifest);
        return this.parseJson(manifest, options);
    };
    Deserialiser.parseJson = function(json, options) {
        var resource;
        // have options been passed for the manifest to inherit?
        if (options) {
            if (options.navDate && !isNaN(options.navDate.getTime())) json.navDate = options.navDate.toString();
        }
        if (json["@type"]) switch(json["@type"]){
            case "sc:Collection":
                resource = this.parseCollection(json, options);
                break;
            case "sc:Manifest":
                resource = this.parseManifest(json, options);
                break;
            default:
                return null;
        }
        else // presentation 3
        switch(json["type"]){
            case "Collection":
                resource = this.parseCollection(json, options);
                break;
            case "Manifest":
                resource = this.parseManifest(json, options);
                break;
            default:
                return null;
        }
        // Top-level resource was loaded from a URI, so flag it to prevent
        // unnecessary reload:
        resource.isLoaded = true;
        return resource;
    };
    Deserialiser.parseCollection = function(json, options) {
        var collection = new $bpdXW.Collection(json, options);
        if (options) {
            collection.index = options.index || 0;
            if (options.resource) collection.parentCollection = options.resource.parentCollection;
        } else collection.index = 0;
        this.parseCollections(collection, options);
        this.parseManifests(collection, options);
        this.parseItems(collection, options);
        return collection;
    };
    Deserialiser.parseCollections = function(collection, options) {
        var items;
        if (collection.__jsonld.collections) items = collection.__jsonld.collections;
        else if (collection.__jsonld.items) items = collection.__jsonld.items.filter(function(m) {
            return m.type.toLowerCase() === "collection";
        });
        if (items) for(var i = 0; i < items.length; i++){
            if (options) options.index = i;
            var item = this.parseCollection(items[i], options);
            item.index = i;
            item.parentCollection = collection;
            collection.items.push(item);
        }
    };
    Deserialiser.parseManifest = function(json, options) {
        var manifest = new $bpdXW.Manifest(json, options);
        return manifest;
    };
    Deserialiser.parseManifests = function(collection, options) {
        var items;
        if (collection.__jsonld.manifests) items = collection.__jsonld.manifests;
        else if (collection.__jsonld.items) items = collection.__jsonld.items.filter(function(m) {
            return m.type.toLowerCase() === "manifest";
        });
        if (items) for(var i = 0; i < items.length; i++){
            var item = this.parseManifest(items[i], options);
            item.index = i;
            item.parentCollection = collection;
            collection.items.push(item);
        }
    };
    Deserialiser.parseItem = function(json, options) {
        if (json["@type"]) {
            if (json["@type"].toLowerCase() === "sc:manifest") return this.parseManifest(json, options);
            else if (json["@type"].toLowerCase() === "sc:collection") return this.parseCollection(json, options);
        } else if (json.type) {
            if (json.type.toLowerCase() === "manifest") return this.parseManifest(json, options);
            else if (json.type.toLowerCase() === "collection") return this.parseCollection(json, options);
        }
        return null;
    };
    Deserialiser.parseItems = function(collection, options) {
        var items = collection.__jsonld.members || collection.__jsonld.items;
        if (items) {
            var _loop_1 = function(i) {
                if (options) options.index = i;
                var item = this_1.parseItem(items[i], options);
                if (!item) return {
                    value: void 0
                };
                // only add to items if not already parsed from backwards-compatible collections/manifests arrays
                if (collection.items.filter(function(m) {
                    return m.id === item.id;
                })[0]) return "continue";
                item.index = i;
                item.parentCollection = collection;
                collection.items.push(item);
            };
            var this_1 = this;
            for(var i = 0; i < items.length; i++){
                var state_1 = _loop_1(i);
                if (typeof state_1 === "object") return state_1.value;
            }
        }
    };
    return Deserialiser;
}();
module.exports.Deserialiser = $1fe69c26f0280a59$var$Deserialiser;

});

parcelRegister("ky1YU", function(module, exports) {
"use strict";
var $ef588513f5b17ca2$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Service = void 0;

var $bpdXW = parcelRequire("bpdXW");
var $ef588513f5b17ca2$var$Service = /** @class */ function(_super) {
    $ef588513f5b17ca2$var$__extends(Service, _super);
    function Service(jsonld, options) {
        return _super.call(this, jsonld, options) || this;
    }
    Service.prototype.getProfile = function() {
        var profile = this.getProperty("profile");
        if (!profile) profile = this.getProperty("dcterms:conformsTo");
        if (Array.isArray(profile)) return profile[0];
        return profile;
    };
    Service.prototype.getConfirmLabel = function() {
        return $bpdXW.Utils.getLocalisedValue(this.getProperty("confirmLabel"), this.options.locale);
    };
    Service.prototype.getDescription = function() {
        return $bpdXW.Utils.getLocalisedValue(this.getProperty("description"), this.options.locale);
    };
    Service.prototype.getFailureDescription = function() {
        return $bpdXW.Utils.getLocalisedValue(this.getProperty("failureDescription"), this.options.locale);
    };
    Service.prototype.getFailureHeader = function() {
        return $bpdXW.Utils.getLocalisedValue(this.getProperty("failureHeader"), this.options.locale);
    };
    Service.prototype.getHeader = function() {
        return $bpdXW.Utils.getLocalisedValue(this.getProperty("header"), this.options.locale);
    };
    Service.prototype.getServiceLabel = function() {
        return $bpdXW.Utils.getLocalisedValue(this.getProperty("label"), this.options.locale);
    };
    Service.prototype.getInfoUri = function() {
        var infoUri = this.id;
        if (!infoUri.endsWith("/")) infoUri += "/";
        infoUri += "info.json";
        return infoUri;
    };
    return Service;
}($bpdXW.ManifestResource);
module.exports.Service = $ef588513f5b17ca2$var$Service;

});

parcelRegister("gT2AM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Size = void 0;
var $c4b3cb234d68041f$var$Size = /** @class */ function() {
    function Size(width, height) {
        this.width = width;
        this.height = height;
    }
    return Size;
}();
module.exports.Size = $c4b3cb234d68041f$var$Size;

});

parcelRegister("7Su5A", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatusCode = void 0;
var $5bc4eaa3be7b08a4$var$StatusCode;
(function(StatusCode) {
    StatusCode[StatusCode["AUTHORIZATION_FAILED"] = 1] = "AUTHORIZATION_FAILED";
    StatusCode[StatusCode["FORBIDDEN"] = 2] = "FORBIDDEN";
    StatusCode[StatusCode["INTERNAL_SERVER_ERROR"] = 3] = "INTERNAL_SERVER_ERROR";
    StatusCode[StatusCode["RESTRICTED"] = 4] = "RESTRICTED";
})($5bc4eaa3be7b08a4$var$StatusCode || (module.exports.StatusCode = $5bc4eaa3be7b08a4$var$StatusCode = {}));

});

parcelRegister("hHQud", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Thumb = void 0;
// todo: deprecate
// this is used by Sequence.getThumbs
var $ce3f2a867c96853f$var$Thumb = /** @class */ function() {
    function Thumb(width, canvas) {
        this.data = canvas;
        this.index = canvas.index;
        this.width = width;
        var heightRatio = canvas.getHeight() / canvas.getWidth();
        if (heightRatio) this.height = Math.floor(this.width * heightRatio);
        else this.height = width;
        this.uri = canvas.getCanonicalImageUri(width);
        this.label = canvas.getLabel().getValue(); // todo: pass locale?
        this.viewingHint = canvas.getViewingHint();
    }
    return Thumb;
}();
module.exports.Thumb = $ce3f2a867c96853f$var$Thumb;

});

parcelRegister("aml4N", function(module, exports) {
"use strict";
var $78ac4eca4b9f24f4$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Thumbnail = void 0;

var $bpdXW = parcelRequire("bpdXW");
var $78ac4eca4b9f24f4$var$Thumbnail = /** @class */ function(_super) {
    $78ac4eca4b9f24f4$var$__extends(Thumbnail, _super);
    function Thumbnail(jsonld, options) {
        return _super.call(this, jsonld, options) || this;
    }
    return Thumbnail;
}($bpdXW.Resource);
module.exports.Thumbnail = $78ac4eca4b9f24f4$var$Thumbnail;

});

parcelRegister("coue3", function(module, exports) {
"use strict";
var $905f2c1bb6588ee4$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslateTransform = void 0;

var $bpdXW = parcelRequire("bpdXW");
var $905f2c1bb6588ee4$var$TranslateTransform = /** @class */ function(_super) {
    $905f2c1bb6588ee4$var$__extends(TranslateTransform, _super);
    function TranslateTransform(jsonld) {
        var _this = _super.call(this, jsonld) || this;
        _this.isTranslateTransform = true;
        return _this;
    }
    TranslateTransform.prototype.getTranslation = function() {
        var retVal = {};
        for(var _i = 0, _a = [
            "x",
            "y",
            "z"
        ]; _i < _a.length; _i++){
            var attrib = _a[_i];
            var raw = this.__jsonld[attrib];
            retVal[attrib] = raw !== undefined ? Number(raw) : 0.0;
        }
        return retVal;
    };
    return TranslateTransform;
}($bpdXW.Transform);
module.exports.TranslateTransform = $905f2c1bb6588ee4$var$TranslateTransform;

});

parcelRegister("dGbbu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TransformParser = void 0;

var $bpdXW = parcelRequire("bpdXW");
var $9f57df8f9dd4a091$var$TransformParser = /** @class */ function() {
    function TransformParser() {}
    TransformParser.BuildFromJson = function(jsonld) {
        if (jsonld.type === "TranslateTransform") return new $bpdXW.TranslateTransform(jsonld);
        else if (jsonld.type === "RotateTransform") return new $bpdXW.RotateTransform(jsonld);
        else if (jsonld.type === "ScaleTransform") return new $bpdXW.ScaleTransform(jsonld);
        else throw new Error("Unknown transform type " + jsonld.type);
    };
    return TransformParser;
}();
module.exports.TransformParser = $9f57df8f9dd4a091$var$TransformParser;

});

parcelRegister("lAFUM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TreeNode = void 0;

var $bpdXW = parcelRequire("bpdXW");
var $fb7d792c6f0cab8c$var$TreeNode = /** @class */ function() {
    function TreeNode(label, data) {
        this.label = label;
        this.data = data || {};
        this.nodes = [];
    }
    TreeNode.prototype.addNode = function(node) {
        this.nodes.push(node);
        node.parentNode = this;
    };
    TreeNode.prototype.isCollection = function() {
        return this.data.type === $bpdXW.Utils.normaliseType($bpdXW.TreeNodeType.COLLECTION);
    };
    TreeNode.prototype.isManifest = function() {
        return this.data.type === $bpdXW.Utils.normaliseType($bpdXW.TreeNodeType.MANIFEST);
    };
    TreeNode.prototype.isRange = function() {
        return this.data.type === $bpdXW.Utils.normaliseType($bpdXW.TreeNodeType.RANGE);
    };
    return TreeNode;
}();
module.exports.TreeNode = $fb7d792c6f0cab8c$var$TreeNode;

});

parcelRegister("g5jkY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TreeNodeType = void 0;
var $bb5c1cf289cfd3f3$var$TreeNodeType;
(function(TreeNodeType) {
    TreeNodeType["COLLECTION"] = "collection";
    TreeNodeType["MANIFEST"] = "manifest";
    TreeNodeType["RANGE"] = "range";
})($bb5c1cf289cfd3f3$var$TreeNodeType || (module.exports.TreeNodeType = $bb5c1cf289cfd3f3$var$TreeNodeType = {}));

});

parcelRegister("5RMk3", function(module, exports) {
"use strict";
var $445762d71b565646$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RotateTransform = void 0;

var $bpdXW = parcelRequire("bpdXW");
var $445762d71b565646$var$RotateTransform = /** @class */ function(_super) {
    $445762d71b565646$var$__extends(RotateTransform, _super);
    function RotateTransform(jsonld) {
        var _this = _super.call(this, jsonld) || this;
        _this.isRotateTransform = true;
        return _this;
    }
    /**
    * Returns an object with x,y,z attributes whose values are
    * a counter-clockwise rotation in degrees about the fixed coordinate
    * system axes.
    *
    * @returns object
    **/ RotateTransform.prototype.getRotation = function() {
        var retVal = {};
        for(var _i = 0, _a = [
            "x",
            "y",
            "z"
        ]; _i < _a.length; _i++){
            var attrib = _a[_i];
            var raw = this.__jsonld[attrib];
            retVal[attrib] = raw !== undefined ? Number(raw) : 0.0;
        }
        return retVal;
    };
    Object.defineProperty(RotateTransform.prototype, "Rotation", {
        /**
        * accessor Rotation is an object with x,y,z attributes whose values are
        * a counter-clockwise rotation in degrees about the fixed coordinate
        * system axes.
        **/ get: function() {
            return this.getRotation();
        },
        enumerable: false,
        configurable: true
    });
    return RotateTransform;
}($bpdXW.Transform);
module.exports.RotateTransform = $445762d71b565646$var$RotateTransform;

});

parcelRegister("eGPMK", function(module, exports) {
"use strict";
var $ab1d2867d89efe88$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ScaleTransform = void 0;

var $bpdXW = parcelRequire("bpdXW");
var $ab1d2867d89efe88$var$ScaleTransform = /** @class */ function(_super) {
    $ab1d2867d89efe88$var$__extends(ScaleTransform, _super);
    function ScaleTransform(jsonld) {
        var _this = _super.call(this, jsonld) || this;
        _this.isScaleTransform = true;
        return _this;
    }
    ScaleTransform.prototype.getScale = function() {
        var retVal = {};
        for(var _i = 0, _a = [
            "x",
            "y",
            "z"
        ]; _i < _a.length; _i++){
            var attrib = _a[_i];
            var raw = this.__jsonld[attrib];
            // note that default scaling is 1.0
            retVal[attrib] = raw !== undefined ? Number(raw) : 1.0;
        }
        return retVal;
    };
    return ScaleTransform;
}($bpdXW.Transform);
module.exports.ScaleTransform = $ab1d2867d89efe88$var$ScaleTransform;

});

parcelRegister("3ib2J", function(module, exports) {
"use strict";
//import { colorString } from "color-string"
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Color = void 0;

var $bA74c = parcelRequire("bA74c");
/**
 * class structure with red, green, blue values in 0-255 range
 * Uses the {@link  https://www.npmjs.com/package.color-string | color-string }
 * library for conversion from and to string representations of color.
**/ var $265b9e7138d4d129$var$Color = /** @class */ function() {
    /**
    * @param rgbValue - Array of three 0-255 integers for r,g,b value. Ex: [255.0,0] for red
    **/ function Color(rgbValue) {
        this.value = rgbValue;
    }
    /**
    * @param cssTerm - hex representtion of color as used in CSS. Ex "#FF0000" as red
    * @returns Color instance.
    **/ Color.fromCSS = function(cssTerm) {
        var rv = $bA74c.get(cssTerm);
        if (rv.model !== 'rgb') throw new Error("unsupported color string: " + cssTerm);
        return new Color([
            rv.value[0],
            rv.value[1],
            rv.value[2]
        ]);
    };
    Object.defineProperty(Color.prototype, "red", {
        /**
        * @return 0 to 255 value of red color component
        **/ get: function() {
            return this.value[0];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Color.prototype, "green", {
        /**
        * @return 0 to 255 value of green color component
        **/ get: function() {
            return this.value[1];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Color.prototype, "blue", {
        /**
        * @return 0 to 255 value of blue color component
        **/ get: function() {
            return this.value[2];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Color.prototype, "CSS", {
        /**
        * @returns  hex string (as for CSS ) representation of r,g,b components
        **/ get: function() {
            return $bA74c.to.hex(this.value);
        },
        enumerable: false,
        configurable: true
    });
    return Color;
}();
module.exports.Color = $265b9e7138d4d129$var$Color;

});
parcelRegister("bA74c", function(module, exports) {
/* MIT license */ 
var $jVuP9 = parcelRequire("jVuP9");

var $8mXov = parcelRequire("8mXov");
var $86e889c881e89501$var$hasOwnProperty = Object.hasOwnProperty;
var $86e889c881e89501$var$reverseNames = Object.create(null);
// create a list of reverse color names
for(var $86e889c881e89501$var$name in $jVuP9)if ($86e889c881e89501$var$hasOwnProperty.call($jVuP9, $86e889c881e89501$var$name)) $86e889c881e89501$var$reverseNames[$jVuP9[$86e889c881e89501$var$name]] = $86e889c881e89501$var$name;
var $86e889c881e89501$var$cs = module.exports = {
    to: {},
    get: {}
};
$86e889c881e89501$var$cs.get = function(string) {
    var prefix = string.substring(0, 3).toLowerCase();
    var val;
    var model;
    switch(prefix){
        case 'hsl':
            val = $86e889c881e89501$var$cs.get.hsl(string);
            model = 'hsl';
            break;
        case 'hwb':
            val = $86e889c881e89501$var$cs.get.hwb(string);
            model = 'hwb';
            break;
        default:
            val = $86e889c881e89501$var$cs.get.rgb(string);
            model = 'rgb';
            break;
    }
    if (!val) return null;
    return {
        model: model,
        value: val
    };
};
$86e889c881e89501$var$cs.get.rgb = function(string) {
    if (!string) return null;
    var abbr = /^#([a-f0-9]{3,4})$/i;
    var hex = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i;
    var rgba = /^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
    var per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
    var keyword = /^(\w+)$/;
    var rgb = [
        0,
        0,
        0,
        1
    ];
    var match;
    var i;
    var hexAlpha;
    if (match = string.match(hex)) {
        hexAlpha = match[2];
        match = match[1];
        for(i = 0; i < 3; i++){
            // https://jsperf.com/slice-vs-substr-vs-substring-methods-long-string/19
            var i2 = i * 2;
            rgb[i] = parseInt(match.slice(i2, i2 + 2), 16);
        }
        if (hexAlpha) rgb[3] = parseInt(hexAlpha, 16) / 255;
    } else if (match = string.match(abbr)) {
        match = match[1];
        hexAlpha = match[3];
        for(i = 0; i < 3; i++)rgb[i] = parseInt(match[i] + match[i], 16);
        if (hexAlpha) rgb[3] = parseInt(hexAlpha + hexAlpha, 16) / 255;
    } else if (match = string.match(rgba)) {
        for(i = 0; i < 3; i++)rgb[i] = parseInt(match[i + 1], 0);
        if (match[4]) {
            if (match[5]) rgb[3] = parseFloat(match[4]) * 0.01;
            else rgb[3] = parseFloat(match[4]);
        }
    } else if (match = string.match(per)) {
        for(i = 0; i < 3; i++)rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
        if (match[4]) {
            if (match[5]) rgb[3] = parseFloat(match[4]) * 0.01;
            else rgb[3] = parseFloat(match[4]);
        }
    } else if (match = string.match(keyword)) {
        if (match[1] === 'transparent') return [
            0,
            0,
            0,
            0
        ];
        if (!$86e889c881e89501$var$hasOwnProperty.call($jVuP9, match[1])) return null;
        rgb = $jVuP9[match[1]];
        rgb[3] = 1;
        return rgb;
    } else return null;
    for(i = 0; i < 3; i++)rgb[i] = $86e889c881e89501$var$clamp(rgb[i], 0, 255);
    rgb[3] = $86e889c881e89501$var$clamp(rgb[3], 0, 1);
    return rgb;
};
$86e889c881e89501$var$cs.get.hsl = function(string) {
    if (!string) return null;
    var hsl = /^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
    var match = string.match(hsl);
    if (match) {
        var alpha = parseFloat(match[4]);
        var h = (parseFloat(match[1]) % 360 + 360) % 360;
        var s = $86e889c881e89501$var$clamp(parseFloat(match[2]), 0, 100);
        var l = $86e889c881e89501$var$clamp(parseFloat(match[3]), 0, 100);
        var a = $86e889c881e89501$var$clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [
            h,
            s,
            l,
            a
        ];
    }
    return null;
};
$86e889c881e89501$var$cs.get.hwb = function(string) {
    if (!string) return null;
    var hwb = /^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
    var match = string.match(hwb);
    if (match) {
        var alpha = parseFloat(match[4]);
        var h = (parseFloat(match[1]) % 360 + 360) % 360;
        var w = $86e889c881e89501$var$clamp(parseFloat(match[2]), 0, 100);
        var b = $86e889c881e89501$var$clamp(parseFloat(match[3]), 0, 100);
        var a = $86e889c881e89501$var$clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [
            h,
            w,
            b,
            a
        ];
    }
    return null;
};
$86e889c881e89501$var$cs.to.hex = function() {
    var rgba = $8mXov(arguments);
    return '#' + $86e889c881e89501$var$hexDouble(rgba[0]) + $86e889c881e89501$var$hexDouble(rgba[1]) + $86e889c881e89501$var$hexDouble(rgba[2]) + (rgba[3] < 1 ? $86e889c881e89501$var$hexDouble(Math.round(rgba[3] * 255)) : '');
};
$86e889c881e89501$var$cs.to.rgb = function() {
    var rgba = $8mXov(arguments);
    return rgba.length < 4 || rgba[3] === 1 ? 'rgb(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ')' : 'rgba(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ', ' + rgba[3] + ')';
};
$86e889c881e89501$var$cs.to.rgb.percent = function() {
    var rgba = $8mXov(arguments);
    var r = Math.round(rgba[0] / 255 * 100);
    var g = Math.round(rgba[1] / 255 * 100);
    var b = Math.round(rgba[2] / 255 * 100);
    return rgba.length < 4 || rgba[3] === 1 ? 'rgb(' + r + '%, ' + g + '%, ' + b + '%)' : 'rgba(' + r + '%, ' + g + '%, ' + b + '%, ' + rgba[3] + ')';
};
$86e889c881e89501$var$cs.to.hsl = function() {
    var hsla = $8mXov(arguments);
    return hsla.length < 4 || hsla[3] === 1 ? 'hsl(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%)' : 'hsla(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%, ' + hsla[3] + ')';
};
// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
$86e889c881e89501$var$cs.to.hwb = function() {
    var hwba = $8mXov(arguments);
    var a = '';
    if (hwba.length >= 4 && hwba[3] !== 1) a = ', ' + hwba[3];
    return 'hwb(' + hwba[0] + ', ' + hwba[1] + '%, ' + hwba[2] + '%' + a + ')';
};
$86e889c881e89501$var$cs.to.keyword = function(rgb) {
    return $86e889c881e89501$var$reverseNames[rgb.slice(0, 3)];
};
// helpers
function $86e889c881e89501$var$clamp(num, min, max) {
    return Math.min(Math.max(min, num), max);
}
function $86e889c881e89501$var$hexDouble(num) {
    var str = Math.round(num).toString(16).toUpperCase();
    return str.length < 2 ? '0' + str : str;
}

});
parcelRegister("jVuP9", function(module, exports) {
'use strict';
module.exports = {
    "aliceblue": [
        240,
        248,
        255
    ],
    "antiquewhite": [
        250,
        235,
        215
    ],
    "aqua": [
        0,
        255,
        255
    ],
    "aquamarine": [
        127,
        255,
        212
    ],
    "azure": [
        240,
        255,
        255
    ],
    "beige": [
        245,
        245,
        220
    ],
    "bisque": [
        255,
        228,
        196
    ],
    "black": [
        0,
        0,
        0
    ],
    "blanchedalmond": [
        255,
        235,
        205
    ],
    "blue": [
        0,
        0,
        255
    ],
    "blueviolet": [
        138,
        43,
        226
    ],
    "brown": [
        165,
        42,
        42
    ],
    "burlywood": [
        222,
        184,
        135
    ],
    "cadetblue": [
        95,
        158,
        160
    ],
    "chartreuse": [
        127,
        255,
        0
    ],
    "chocolate": [
        210,
        105,
        30
    ],
    "coral": [
        255,
        127,
        80
    ],
    "cornflowerblue": [
        100,
        149,
        237
    ],
    "cornsilk": [
        255,
        248,
        220
    ],
    "crimson": [
        220,
        20,
        60
    ],
    "cyan": [
        0,
        255,
        255
    ],
    "darkblue": [
        0,
        0,
        139
    ],
    "darkcyan": [
        0,
        139,
        139
    ],
    "darkgoldenrod": [
        184,
        134,
        11
    ],
    "darkgray": [
        169,
        169,
        169
    ],
    "darkgreen": [
        0,
        100,
        0
    ],
    "darkgrey": [
        169,
        169,
        169
    ],
    "darkkhaki": [
        189,
        183,
        107
    ],
    "darkmagenta": [
        139,
        0,
        139
    ],
    "darkolivegreen": [
        85,
        107,
        47
    ],
    "darkorange": [
        255,
        140,
        0
    ],
    "darkorchid": [
        153,
        50,
        204
    ],
    "darkred": [
        139,
        0,
        0
    ],
    "darksalmon": [
        233,
        150,
        122
    ],
    "darkseagreen": [
        143,
        188,
        143
    ],
    "darkslateblue": [
        72,
        61,
        139
    ],
    "darkslategray": [
        47,
        79,
        79
    ],
    "darkslategrey": [
        47,
        79,
        79
    ],
    "darkturquoise": [
        0,
        206,
        209
    ],
    "darkviolet": [
        148,
        0,
        211
    ],
    "deeppink": [
        255,
        20,
        147
    ],
    "deepskyblue": [
        0,
        191,
        255
    ],
    "dimgray": [
        105,
        105,
        105
    ],
    "dimgrey": [
        105,
        105,
        105
    ],
    "dodgerblue": [
        30,
        144,
        255
    ],
    "firebrick": [
        178,
        34,
        34
    ],
    "floralwhite": [
        255,
        250,
        240
    ],
    "forestgreen": [
        34,
        139,
        34
    ],
    "fuchsia": [
        255,
        0,
        255
    ],
    "gainsboro": [
        220,
        220,
        220
    ],
    "ghostwhite": [
        248,
        248,
        255
    ],
    "gold": [
        255,
        215,
        0
    ],
    "goldenrod": [
        218,
        165,
        32
    ],
    "gray": [
        128,
        128,
        128
    ],
    "green": [
        0,
        128,
        0
    ],
    "greenyellow": [
        173,
        255,
        47
    ],
    "grey": [
        128,
        128,
        128
    ],
    "honeydew": [
        240,
        255,
        240
    ],
    "hotpink": [
        255,
        105,
        180
    ],
    "indianred": [
        205,
        92,
        92
    ],
    "indigo": [
        75,
        0,
        130
    ],
    "ivory": [
        255,
        255,
        240
    ],
    "khaki": [
        240,
        230,
        140
    ],
    "lavender": [
        230,
        230,
        250
    ],
    "lavenderblush": [
        255,
        240,
        245
    ],
    "lawngreen": [
        124,
        252,
        0
    ],
    "lemonchiffon": [
        255,
        250,
        205
    ],
    "lightblue": [
        173,
        216,
        230
    ],
    "lightcoral": [
        240,
        128,
        128
    ],
    "lightcyan": [
        224,
        255,
        255
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210
    ],
    "lightgray": [
        211,
        211,
        211
    ],
    "lightgreen": [
        144,
        238,
        144
    ],
    "lightgrey": [
        211,
        211,
        211
    ],
    "lightpink": [
        255,
        182,
        193
    ],
    "lightsalmon": [
        255,
        160,
        122
    ],
    "lightseagreen": [
        32,
        178,
        170
    ],
    "lightskyblue": [
        135,
        206,
        250
    ],
    "lightslategray": [
        119,
        136,
        153
    ],
    "lightslategrey": [
        119,
        136,
        153
    ],
    "lightsteelblue": [
        176,
        196,
        222
    ],
    "lightyellow": [
        255,
        255,
        224
    ],
    "lime": [
        0,
        255,
        0
    ],
    "limegreen": [
        50,
        205,
        50
    ],
    "linen": [
        250,
        240,
        230
    ],
    "magenta": [
        255,
        0,
        255
    ],
    "maroon": [
        128,
        0,
        0
    ],
    "mediumaquamarine": [
        102,
        205,
        170
    ],
    "mediumblue": [
        0,
        0,
        205
    ],
    "mediumorchid": [
        186,
        85,
        211
    ],
    "mediumpurple": [
        147,
        112,
        219
    ],
    "mediumseagreen": [
        60,
        179,
        113
    ],
    "mediumslateblue": [
        123,
        104,
        238
    ],
    "mediumspringgreen": [
        0,
        250,
        154
    ],
    "mediumturquoise": [
        72,
        209,
        204
    ],
    "mediumvioletred": [
        199,
        21,
        133
    ],
    "midnightblue": [
        25,
        25,
        112
    ],
    "mintcream": [
        245,
        255,
        250
    ],
    "mistyrose": [
        255,
        228,
        225
    ],
    "moccasin": [
        255,
        228,
        181
    ],
    "navajowhite": [
        255,
        222,
        173
    ],
    "navy": [
        0,
        0,
        128
    ],
    "oldlace": [
        253,
        245,
        230
    ],
    "olive": [
        128,
        128,
        0
    ],
    "olivedrab": [
        107,
        142,
        35
    ],
    "orange": [
        255,
        165,
        0
    ],
    "orangered": [
        255,
        69,
        0
    ],
    "orchid": [
        218,
        112,
        214
    ],
    "palegoldenrod": [
        238,
        232,
        170
    ],
    "palegreen": [
        152,
        251,
        152
    ],
    "paleturquoise": [
        175,
        238,
        238
    ],
    "palevioletred": [
        219,
        112,
        147
    ],
    "papayawhip": [
        255,
        239,
        213
    ],
    "peachpuff": [
        255,
        218,
        185
    ],
    "peru": [
        205,
        133,
        63
    ],
    "pink": [
        255,
        192,
        203
    ],
    "plum": [
        221,
        160,
        221
    ],
    "powderblue": [
        176,
        224,
        230
    ],
    "purple": [
        128,
        0,
        128
    ],
    "rebeccapurple": [
        102,
        51,
        153
    ],
    "red": [
        255,
        0,
        0
    ],
    "rosybrown": [
        188,
        143,
        143
    ],
    "royalblue": [
        65,
        105,
        225
    ],
    "saddlebrown": [
        139,
        69,
        19
    ],
    "salmon": [
        250,
        128,
        114
    ],
    "sandybrown": [
        244,
        164,
        96
    ],
    "seagreen": [
        46,
        139,
        87
    ],
    "seashell": [
        255,
        245,
        238
    ],
    "sienna": [
        160,
        82,
        45
    ],
    "silver": [
        192,
        192,
        192
    ],
    "skyblue": [
        135,
        206,
        235
    ],
    "slateblue": [
        106,
        90,
        205
    ],
    "slategray": [
        112,
        128,
        144
    ],
    "slategrey": [
        112,
        128,
        144
    ],
    "snow": [
        255,
        250,
        250
    ],
    "springgreen": [
        0,
        255,
        127
    ],
    "steelblue": [
        70,
        130,
        180
    ],
    "tan": [
        210,
        180,
        140
    ],
    "teal": [
        0,
        128,
        128
    ],
    "thistle": [
        216,
        191,
        216
    ],
    "tomato": [
        255,
        99,
        71
    ],
    "turquoise": [
        64,
        224,
        208
    ],
    "violet": [
        238,
        130,
        238
    ],
    "wheat": [
        245,
        222,
        179
    ],
    "white": [
        255,
        255,
        255
    ],
    "whitesmoke": [
        245,
        245,
        245
    ],
    "yellow": [
        255,
        255,
        0
    ],
    "yellowgreen": [
        154,
        205,
        50
    ]
};

});

parcelRegister("8mXov", function(module, exports) {
'use strict';

var $2y1I3 = parcelRequire("2y1I3");
var $617e73434a6cfefb$var$concat = Array.prototype.concat;
var $617e73434a6cfefb$var$slice = Array.prototype.slice;
var $617e73434a6cfefb$var$swizzle = module.exports = function swizzle(args) {
    var results = [];
    for(var i = 0, len = args.length; i < len; i++){
        var arg = args[i];
        if ($2y1I3(arg)) // http://jsperf.com/javascript-array-concat-vs-push/98
        results = $617e73434a6cfefb$var$concat.call(results, $617e73434a6cfefb$var$slice.call(arg));
        else results.push(arg);
    }
    return results;
};
$617e73434a6cfefb$var$swizzle.wrap = function(fn) {
    return function() {
        return fn($617e73434a6cfefb$var$swizzle(arguments));
    };
};

});
parcelRegister("2y1I3", function(module, exports) {
module.exports = function isArrayish(obj) {
    if (!obj || typeof obj === 'string') return false;
    return obj instanceof Array || Array.isArray(obj) || obj.length >= 0 && (obj.splice instanceof Function || Object.getOwnPropertyDescriptor(obj, obj.length - 1) && obj.constructor.name !== 'String');
};

});




parcelRegister("hzQBg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.eulerFromRotateTransform = module.exports.lightRelativeRotation = module.exports.cameraRelativeRotation = void 0;

var $3uWBl = parcelRequire("3uWBl");
// https://ros2jsguy.github.io/threejs-math/index.html
/**
* performs the calculation required for the lookAt
* property of a camera resource. Determines the
* required angles of two rotations, the first about
* the x axis and the second about the y axis, which will
* rotate the default camera direction (0,0,-1) into the
* direction of the input arguments
*
* Result of calculation is returned as a instance of EulerAngle from the
* threejs-math library. The "axes order" of the EulerAngle is "YXZ": The
* three-js library uses body-fixed axes to represent EulerAngles, which reverse
* the ordering of the "relative rotation" algorithm described in the
* draft 3d api.

* @param direction A vector interpreted as a direction. Client code
*        responsible for not passing a 0-length vector, else a

*
* @returns threejs-math.EulerAngle instance
**/ function $034d6530c6792ba8$var$cameraRelativeRotation(direction) {
    if (direction.length() == 0.0) throw new Error("degenerate geometry: cameraRelativeRotation");
    // projDirection is the direction projected onto the xz plane
    var projDirection = direction.clone().setComponent(1, 0.0);
    var projLength = projDirection.length();
    // handle the edge case, desired viewing direction is either straight up
    // or straight down
    if (projLength == 0.0) {
        if (direction.y > 0.0) // looking straight up fro below
        return new $3uWBl.Euler($3uWBl.MathUtils.degToRad(90), $3uWBl.MathUtils.degToRad(180.0), 0, "YXZ");
        else return new $3uWBl.Euler($3uWBl.MathUtils.degToRad(-90), $3uWBl.MathUtils.degToRad(180.0), 0, "YXZ");
    }
    var yAngleRad = Math.atan2(-projDirection.x, -projDirection.z);
    var xAngleRad = Math.atan2(direction.y, projLength);
    return new $3uWBl.Euler(xAngleRad, yAngleRad, 0.0, "YXZ");
}
module.exports.cameraRelativeRotation = $034d6530c6792ba8$var$cameraRelativeRotation;
/**
* Evaluates the rotation required to transform a directional light
* or spot ling, which in iiif 3D spec
* have an initial direction in the -Y direction, to a direction
* along the input argument
*
* TODO : expand on this documentation taking into account the
*        implied specification that RotateTransform instances
*        are to be interpreted as an Euler angle definition of
*        the rotation
*
* @param direction A vector interpreted as a direction. Client code
*        responsible for not passing a 0-length vector, else a
*
* @returns threejs-math.EulerAngle instance
**/ function $034d6530c6792ba8$var$lightRelativeRotation(direction) {
    if (direction.length() == 0.0) throw new Error("degenerate geometry: cameraRelativeRotation");
    var unit_direction = direction.clone().divideScalar(direction.length());
    // negative y axis is initial direction of DirectionalLight, SpotLight
    // in draft 3D API
    var ny_axis = new $3uWBl.Vector3(0.0, -1, 0.0);
    var quat = new $3uWBl.Quaternion().setFromUnitVectors(ny_axis, unit_direction);
    var tmp = new $3uWBl.Euler().setFromQuaternion(quat, "ZXY");
    // standard be setting the final intrinsic Y rotation, which is
    // along desired direction, to 0
    return new $3uWBl.Euler(tmp.x, 0.0, tmp.z, "ZXY");
}
module.exports.lightRelativeRotation = $034d6530c6792ba8$var$lightRelativeRotation;
/**
* Implements the convention that the 3 component values for the RotateTranform
* cass (properties  x,y,z) are to be interpreted as Euler angles in the intrinsic XYZ
* order
* @param transform : A object with a Rotation member object, properties x,y,z

*
* @returns threejs-math.EulerAngle instance. From this  threejs-math functionsa
* allow conversion to other rotation representations.
**/ function $034d6530c6792ba8$var$eulerFromRotateTransform(transform) {
    var eulerOrder = "XYZ";
    var rdata = transform.Rotation;
    return new $3uWBl.Euler($3uWBl.MathUtils.degToRad(rdata.x), $3uWBl.MathUtils.degToRad(rdata.y), $3uWBl.MathUtils.degToRad(rdata.z), eulerOrder);
}
module.exports.eulerFromRotateTransform = $034d6530c6792ba8$var$eulerFromRotateTransform;

});




var $3uWBl = parcelRequire("3uWBl");

var $3uWBl = parcelRequire("3uWBl");

var $5N2AT = parcelRequire("5N2AT");
const $1ca9575c2d306713$export$5ebc3ab7500e7450 = {
    /*
    argument transform has:
    1. optional properties "x","y","z" which if defined are numeric
       and interpreted as rotations in degrees ccw about X,Y,Z axes respectively
       
    Developer Note Apr 18 2024: Pending more complete specification of the
    RotateTransfrom in the 3D API, at this revision only one axis may be non-zero.
    
    Returns a Quaternion instance
*/ quaternionFromRotateTransform (transform) {
        if (!transform.isRotateTransform) throw new Error("invalid transform to quaternionFromRotateTransform");
        var euler = $5N2AT.eulerFromRotateTransform(transform);
        var retVal = new (0, $3uWBl.Quaternion)().setFromEuler(euler);
        return retVal;
    },
    /*
array elements are manifesto RotateTransform instances, or a mockup which
must have a true value for a "isRotateTransform" property and
must have x,y,z numeric properties. At this revision the limit that only
one of the x,y,z components can be non-zero is enforced.

Note that quaternion multiplication in not-commutative. The choice of the
premultiply function to combine rotations supports the IIIF convention as to
the interpretation of arrays of RotateTranforms:
element 0 is applied to a Vector
then element 1 is applied to the result... 
*/ quaternionFromTransformArray (transformArray) {
        let accum = new (0, $3uWBl.Quaternion)();
        transformArray.forEach((transform)=>{
            if (transform.isRotateTransform) {
                const nquat = $1ca9575c2d306713$export$5ebc3ab7500e7450.quaternionFromRotateTransform(transform);
                accum.premultiply(nquat);
            } else if (transform.isScaleTransform) console.warn("unexpected ScaleTransform in camera or light annotation");
        // developer Note: TranslateTransform instances can be ignored in this calculation
        });
        return accum;
    },
    vectorFromTransformArray (transformArray) {
        let accum = new (0, $3uWBl.Vector3)(0, 0, 0);
        transformArray.forEach((transform)=>{
            if (transform.isRotateTransform) {
                const nquat = $1ca9575c2d306713$export$5ebc3ab7500e7450.quaternionFromRotateTransform(transform);
                accum.applyQuaternion(nquat);
            } else if (transform.isScaleTransform) console.warn("unexpected ScaleTransform in camera or light annotation");
            else if (transform.isTranslateTransform) {
                const coord = transform.getTranslation();
                accum.add(new (0, $3uWBl.Vector3)(coord.x, coord.y, coord.z));
            }
        });
        return accum;
    },
    /*
returns 2, array of a Vector3 axis and angle of rotation in radians
*/ axisAngleFromQuaternion (quat) {
        var vec = new (0, $3uWBl.Vector3)(quat.x, quat.y, quat.z);
        var vlen = vec.length();
        var angle = 2.0 * Math.atan2(vlen, quat.w);
        if (angle == 0.0) return {
            axis: new (0, $3uWBl.Vector3)(1.0, 0.0, 0.0),
            angle: 0.0
        };
        else return {
            axis: vec.divideScalar(vlen),
            angle: angle
        };
    }
};


/*
A collection of functions taking
or returning strings that are useful
in x3d/x3dom processing
*/ const $f1cf6ebb7e4f40db$export$a0c9861d287ed39 = {
    /*
        rgb an object with red, green, blue properties,
        each of which is a integner in range [0,256)
        returns a string of form "0.012 1.000 0.000"
    */ makeSFColor (rgb) {
        return [
            rgb.red,
            rgb.green,
            rgb.blue
        ].map((x)=>{
            return Math.max(0.0, Math.min(1.0, x / 255)).toFixed(3);
        }).join(" ");
    },
    /*
        returns the 4 floating point string as the
        XML attribute value for an SFRotation
        
        axis_angle an object with property axis that itself
        has x,y,z properties
        
        axis_angle has property angle that is the numeric
        angle in radians
    */ makeSFRotation (axis_angle) {
        let axis = axis_angle.axis;
        return [
            axis.x,
            axis.y,
            axis.z,
            axis_angle.angle
        ].join(" ");
    },
    /*
    xyz an object with x, y, z property
    */ makeSFVec3f (xyz) {
        return [
            xyz.x,
            xyz.y,
            xyz.z
        ].join(" ");
    }
};



var $5N2AT = parcelRequire("5N2AT");
/* 
script level: define structure and event handlers to determine when
both the window load event has been fired and the x3dom ready event
 */ let $09c84f25631aecf7$var$_pre_init_state = {
    x3dom: false,
    document: false
};
x3dom.runtime.ready = function(element) {
    //console.log("x3dom.ready fired");
    $09c84f25631aecf7$var$_pre_init_state.x3dom = true;
    if ($09c84f25631aecf7$var$_pre_init_state.x3dom && $09c84f25631aecf7$var$_pre_init_state.document) $09c84f25631aecf7$var$initialize_viewer();
};
let $09c84f25631aecf7$var$manifestViewer = null;
let $09c84f25631aecf7$var$initialize_viewer = function() {
    console.log("initialize_viewer called");
    $09c84f25631aecf7$var$manifestViewer = {
        triad_switch_node: document.getElementById("triad-switch-node"),
        axes_description: document.getElementById("axes-description"),
        set AxesVisible (value){
            // value a boolean
            var newChoice = value ? 0 : -1;
            this.triad_switch_node.setAttribute("whichChoice", newChoice);
            this.axes_description.style.display = value ? "block" : "none";
        },
        navigationinfo_node: document.getElementById("navigationinfo-node"),
        headlight_description: document.getElementById("headlight-description"),
        set HeadlightOn (value){
            // value is a boolean
            var newBool = value ? "true" : "false";
            this.navigationinfo_node.setAttribute("headlight", newBool);
            this.headlight_description.style.display = value ? "block" : "none";
        },
        default_viewpoint: document.getElementById("default-viewpoint"),
        iiif_perspective_viewpoint: document.getElementById("iiif-perspective-viewpoint"),
        iiif_orthographic_viewpoint: document.getElementById("iiif-orthographic-viewpoint"),
        default_viewpoint_values: {
            position: null,
            orientation: null,
            centerOfRotation: null
        },
        storeDefaultViewpoint () {
            for (var key of Object.keys($09c84f25631aecf7$var$manifestViewer.default_viewpoint_values))$09c84f25631aecf7$var$manifestViewer.default_viewpoint_values[key] = $09c84f25631aecf7$var$manifestViewer.default_viewpoint.getAttribute(key);
            console.log("default viewpoint " + JSON.stringify($09c84f25631aecf7$var$manifestViewer.default_viewpoint_values));
        },
        restoreDefaultViewpoint () {
            for (var key of Object.keys($09c84f25631aecf7$var$manifestViewer.default_viewpoint_values)){
                let val = $09c84f25631aecf7$var$manifestViewer.default_viewpoint_values[key];
                if (val != null) $09c84f25631aecf7$var$manifestViewer.default_viewpoint.setAttribute(key, val);
            }
            $09c84f25631aecf7$var$manifestViewer.default_viewpoint.setAttribute("set_bind", "true");
        },
        setProxyCamera (proxyCamera) {
            console.log("enter setProxyCamera( proxyCamera )");
            var cameraNode = proxyCamera.x3dnode;
            console.log("setting node " + cameraNode.getAttribute("id"));
            for (const [key, value1] of Object.entries(proxyCamera.fields)){
                console.log(`setting field ${key} to ${value1}`);
                cameraNode.setAttribute(key, value1);
            }
            console.log("set 'set_bind' to true on " + cameraNode.getAttribute("id"));
            cameraNode.setAttribute("set_bind", "true");
        },
        background_node: document.getElementById("x3d-background"),
        defaultBackgroundColor: {
            red: 204,
            green: 204,
            blue: 204
        },
        /*
            rgb has properties red, greem, blue, each in integer
            in range [0, 256)
            
            side effect of setting the X3D scene background color
        */ set BackgroundColor (rgb){
            this.background_node.setAttribute("skyColor", (0, $f1cf6ebb7e4f40db$export$a0c9861d287ed39).makeSFColor(rgb));
        },
        annotation_container: document.getElementById("annotation_container"),
        clearAnnotationContent () {
            while(annotation_container.firstChild)annotation_container.removeChild(annotation_container.lastChild);
        },
        handleNewManifest (event) {
            if (event?.detail?.manifest) {
                var manifest = event?.detail?.manifest;
                $09c84f25631aecf7$var$manifestViewer.clearAnnotationContent();
                $09c84f25631aecf7$var$manifestViewer.restoreDefaultViewpoint();
                var scene = manifest.getSequences()[0].getScenes()[0];
                $09c84f25631aecf7$var$manifestViewer.BackgroundColor = scene.getBackgroundColor() ?? $09c84f25631aecf7$var$manifestViewer.defaultBackgroundColor;
                var annotations = scene.getContent();
                let ann = new $09c84f25631aecf7$var$SceneAnnotations(scene);
                /*
        for (let camera of ann.cameras) {
            console.log(`adding ${camera.label} to scene`);
            camera.x3dnode.setAttribute("id", "new-viewpoint");
            manifestViewer.annotation_container.appendChild(camera.x3dnode);
            
        }
        */ for (let model of ann.models){
                    console.log(`adding ${model.label} to scene`);
                    $09c84f25631aecf7$var$manifestViewer.annotation_container.appendChild(model.x3dnode);
                }
                for (let light of ann.lights){
                    console.log(`adding ${light.label} to scene`);
                    $09c84f25631aecf7$var$manifestViewer.annotation_container.appendChild(light.x3dnode);
                }
                console.log($09c84f25631aecf7$var$manifestViewer.annotation_container.innerHTML);
                if (ann.cameras.length > 0) $09c84f25631aecf7$var$manifestViewer.setProxyCamera(ann.cameras[0]);
                for (let text_annotation_value of ann.text_annotations){
                    console.log(`adding ${text_annotation_value} to text annotation table`);
                    $09c84f25631aecf7$var$manifestViewer.addTextAnnotationValue(text_annotation_value);
                }
            //manifestViewer.default_viewpoint.setAttribute('set_bind', 'false');
            //document.getElementById('alt-viewpoint').setAttribute('set_bind','true');
            //setTimeout( () =>
            //{
            //    console.log("binding iiif viewpoint 7");
            //    //document.getElementById('new-viewpoint').setAttribute('set_bind','true');
            //    var vp = document.getElementById('x3delem').runtime.nextView();
            //    console.log("viewpoint" + vp);
            //vp.setAttribute('set_bind', 'false');
            //document.getElementById('new-viewpoint').setAttribute('bind','true');
            //}, 10000);
            //ann.cameras[0].x3dnode.setAttribute("set_bind", "true");
            }
        },
        manifest_label_container: document.getElementById("manifest_label_container"),
        manifest_summary_container: document.getElementById("manifest_summary_container"),
        /*
    showDescriptiveProperties will display the descriptive properties,
    as explained in Presentation 3.0 API (Section 3.1) in the non-3D viewport
    of the web page
    */ show_descriptive_properties (event) {
            console.log("enter : show_descriptive_properties");
            if (event?.detail?.manifest) {
                let label = event?.detail?.manifest?.getLabel()?.getValue();
                console.log("Setting manifest label to: " + label);
                if ($09c84f25631aecf7$var$manifestViewer.manifest_label_container) $09c84f25631aecf7$var$manifestViewer.manifest_label_container.innerHTML = label;
                if (event?.detail?.manifest?.getSummary) {
                    let summary = event.detail.manifest.getSummary().getValue();
                    if ($09c84f25631aecf7$var$manifestViewer.manifest_summary_container) $09c84f25631aecf7$var$manifestViewer.manifest_summary_container.innerHTML = summary;
                } else console.log("manifest.getSummary is not implemented");
            }
        },
        text_annotations_container: document.getElementById("text-annotations-table"),
        addTextAnnotationValue (value1) {
            let rowNode = document.createElement("tr");
            $09c84f25631aecf7$var$manifestViewer.text_annotations_container.appendChild(rowNode);
            rowNode.innerHTML = value1;
        }
    };
    $09c84f25631aecf7$var$manifestViewer.storeDefaultViewpoint();
    let show_axes_checkbox = document.getElementById("show-axes-checkbox");
    show_axes_checkbox.checked = false;
    show_axes_checkbox.addEventListener("click", (event)=>{
        $09c84f25631aecf7$var$manifestViewer.AxesVisible = show_axes_checkbox?.checked;
    });
    let headlight_on_checkbox = document.getElementById("headlight-on-checkbox");
    headlight_on_checkbox.checked = true;
    headlight_on_checkbox.addEventListener("click", (event)=>{
        $09c84f25631aecf7$var$manifestViewer.HeadlightOn = headlight_on_checkbox?.checked;
    });
    document.addEventListener("new_manifest", $09c84f25631aecf7$var$manifestViewer.handleNewManifest);
    document.addEventListener("new_manifest", $09c84f25631aecf7$var$manifestViewer.show_descriptive_properties);
    var event = new Event("viewer_ready");
    document.dispatchEvent(event);
};
window.addEventListener("load", (event)=>{
    $09c84f25631aecf7$var$_pre_init_state.document = true;
    if ($09c84f25631aecf7$var$_pre_init_state.x3dom && $09c84f25631aecf7$var$_pre_init_state.document) $09c84f25631aecf7$var$initialize_viewer();
});
class $09c84f25631aecf7$var$SceneAnnotations {
    constructor(scene){
        this.models = [];
        this.lights = [];
        this.cameras = [];
        this.text_annotations = [];
        this.scene = scene;
        // create and retain  the array of all annotations
        this.annotations = scene.getContent();
        let that = this;
        this.annotations.forEach((item)=>{
            that.addAnnotation(item);
        });
    }
    /*
    the entry point for adding a general annotation (model, camera, or light)
    to the appropriate list data-member of this instanceof
    Has no return value
    
    will put an object with members label and x3dnode on the appropriate list
    
    anno is an instance of the Annotation class as defined in manifesto3d.js module
    */ addAnnotation(anno) {
        const body = anno.getBody()[0];
        const target = anno.getTarget();
        let bodyObj = body.isSpecificResource() ? {
            base: body.getSource(),
            wrapper: body
        } : {
            base: body,
            wrapper: null
        };
        /*
    Developer Note 24 Feb 2025
    for the revised AnnotationBody class which is the subject of PR 27
    https://github.com/IIIF-Commons/manifesto-3d/pull/27
    isSpecificResource is defined as as function returning bool
    
    
    For the case of the target the test here has to accomodate the 
    threadbare object returned by JSONLDResource.getPropertyAsObject
    when the manifest just has an IRI for the target field.
    */ let targetObj = target.isSpecificResource && (typeof target.isSpecificResource == "function" && target.isSpecificResource() || target.isSpecificResource == true) ? {
            base: target.getSource(),
            wrapper: target
        } : {
            base: target,
            wrapper: null
        };
        var label = anno.getLabel()?.getValue();
        //let that = this;
        console.log("bodyObj.base.getType() " + bodyObj.base.getType());
        try {
            let addHandler = ((base)=>{
                var lowType = base.getType().toLowerCase();
                switch(lowType){
                    case "ambientlight":
                    case "directionallight":
                    case "spotlight":
                        return this.addLight.bind(this);
                    case "model":
                        return this.addModel.bind(this);
                    case "perspectivecamera":
                    case "orthographiccamera":
                        return this.addCamera.bind(this);
                    case "textualbody":
                        return this.addTextualBody.bind(this);
                    default:
                        throw new Error("unidentified body base resource " + lowType);
                }
            })(bodyObj.base);
            addHandler(bodyObj, targetObj, label);
        } catch (err) {
            console.error("exception " + err);
            throw err;
        }
    }
    /*
    Handle case where the annotation is a model represented in
    the X3D secengraph by a Inline X3D node, enclosed in X3D Transform
    nodes for proper placement
    */ addModel(bodyObj, targetObj, label = null) {
        label = label ?? `model ${this.models.length + 1}`;
        console.log("enter addModel with " + label);
        let inlineNode = document.createElement("inline");
        inlineNode.setAttribute("url", bodyObj.base.id);
        // x3dtransform will be list of X3D Transform nodes need to
        // perform the function of iiif transforms in the SpecificResource
        // of the body and the PointSelector of the target resources
        let x3dtransforms;
        try {
            x3dtransforms = bodyObj.wrapper?.getTransform() != null ? bodyObj.wrapper.getTransform().map(this.IIIFTransformToX3DTransform) : [];
        } catch (err) {
            console.warn(`bodyObj.wrapper.getTransform().map : ${err}`);
            x3dtransforms = [];
        }
        if (targetObj.wrapper?.Selector?.isPointSelector) x3dtransforms.push(this.IIIFPointSelectorToX3dTransform(targetObj.wrapper.Selector));
        if (x3dtransforms.length > 0) {
            x3dtransforms[0].appendChild(inlineNode);
            for(var i = 1; i < x3dtransforms.length; ++i)x3dtransforms[i].appendChild(x3dtransforms[i - 1]);
            this.models.push({
                label: label,
                x3dnode: x3dtransforms.at(-1)
            });
        } else this.models.push({
            label: label,
            x3dnode: inlineNode
        });
    }
    addLight(bodyObj, targetObj, label = null) {
        label = label ?? `light ${this.models.length + 1}`;
        console.log("enter addLight with " + label);
        let lightNode = null;
        let iiifLight = bodyObj.base;
        if (iiifLight.isAmbientLight()) {
            lightNode = document.createElement("pointlight");
            lightNode.setAttribute("intensity", "0.0");
            lightNode.setAttribute("ambientIntensity", iiifLight.getIntensity().toString());
        } else {
            // is a directional or spot light, requireing
            // both a position ("location" in X3D)
            // and a direction
            // position
            let lightLocation = (()=>{
                let retVal = new (0, $3uWBl.Vector3)(0, 0, 0);
                if (targetObj.wrapper?.Selector?.isPointSelector) retVal.add(targetObj.wrapper.Selector.Location);
                if (bodyObj.wrapper?.getTransform()) {
                    const transforms = bodyObj.wrapper.getTransform();
                    const transVector = (0, $1ca9575c2d306713$export$5ebc3ab7500e7450).vectorFromTransformArray(transforms);
                    retVal.add(transVector);
                }
                return retVal;
            })();
            // a function which returns a direction vector if the body is a 
            // SpecificResource with RotateTransforms, otherwise returns a
            // undefined
            let direction_from_rotation = ()=>{
                if (bodyObj.wrapper?.isSpecificResource) {
                    let transform = bodyObj.wrapper.getTransform();
                    if (transform) {
                        // assume transform is entirely RotateTransform instances
                        let quat = (0, $1ca9575c2d306713$export$5ebc3ab7500e7450).quaternionFromTransformArray(transform);
                        return new (0, $3uWBl.Vector3)(0.0, -1, 0.0).applyQuaternion(quat);
                    }
                }
                return undefined;
            };
            // a function which returns a direction if the Light has a lookAt property
            // which is a PointSelector
            let direction_from_lookat = ()=>{
                if (iiifLight.LookAt?.isPointSelector) {
                    let lookAtLocation = iiifLight.LookAt.Location;
                    return lookAtLocation?.clone().sub(lightLocation).normalize();
                } else return undefined;
            };
            let light_direction = direction_from_rotation() ?? direction_from_lookat();
            console.log((light_direction, (0, $f1cf6ebb7e4f40db$export$a0c9861d287ed39).makeSFVec3f(light_direction)));
            if (iiifLight.isDirectionalLight()) lightNode = document.createElement("directionallight");
            else if (iiifLight.isSpotLight()) {
                // spotlight has an angle and a location
                lightNode = document.createElement("spotlight");
                let angleInDegrees = (0, $3uWBl.MathUtils).degToRad(iiifLight.Angle);
                lightNode.setAttribute("cutOffAngle", angleInDegrees);
                lightNode.setAttribute("beamWidth", angleInDegrees);
                lightNode.setAttribute("location", (0, $f1cf6ebb7e4f40db$export$a0c9861d287ed39).makeSFVec3f(lightLocation));
            } else console.log("unknown light " + iiifLight.getType());
            lightNode.setAttribute("direction", (0, $f1cf6ebb7e4f40db$export$a0c9861d287ed39).makeSFVec3f(light_direction));
            lightNode.setAttribute("intensity", iiifLight.getIntensity().toString());
            lightNode.setAttribute("ambientIntensity", "0.0");
        }
        var light_color = iiifLight.getColor();
        var rgbAttr = (0, $f1cf6ebb7e4f40db$export$a0c9861d287ed39).makeSFColor(light_color);
        lightNode.setAttribute("color", rgbAttr);
        lightNode.setAttribute("global", "true");
        this.lights.push({
            label: label,
            x3dnode: lightNode
        });
    }
    /*
   * this is an alpha implementation and it will work by modifying
   * the existing Viewpoint node in the model. As such, it only makes
   * sense if there is just one camera annotation
   *
   * that one viewpoint is manifestViewer.default_viewpoint
   * later work will need to develop the UI for switching between
   * multiple cameras.
   *
   */ addCamera(bodyObj, targetObj, label = null) {
        label = label ?? `camera ${this.cameras.length + 1}`;
        console.log("enter addCamera with " + label);
        let camera = bodyObj.base; // just convenient alias
        // cameraPosition set to a Vector3 instance    
        let cameraPosition = (()=>{
            let retVal = new (0, $3uWBl.Vector3)(0, 0, 0);
            if (targetObj.wrapper?.Selector?.isPointSelector) retVal.add(targetObj.wrapper.Selector.Location);
            if (bodyObj.wrapper?.getTransform()) {
                const transforms = bodyObj.wrapper.getTransform();
                const transVector = (0, $1ca9575c2d306713$export$5ebc3ab7500e7450).vectorFromTransformArray(transforms);
                retVal.add(transVector);
            }
            return retVal;
        })();
        /* determine a camera orientation from two possible ways
     * first, the existence of a non-empty transform array in the
     * specific resource
     * cameraOrientation will be set to a Quaternion instance that
     * represents the required rotations from the X3D default camera direction
     * pointing in the -z axis  direction
     */ // each of the orientationFromXXXXX will return either 
        // Quaternion instance or the undefined type
        let orientationFromTransformArray = ()=>{
            if (bodyObj.wrapper?.isSpecificResource) {
                let transform = bodyObj.wrapper.getTransform();
                if (transform) // assume transform is entirely RotateTransform instances
                return (0, $1ca9575c2d306713$export$5ebc3ab7500e7450).quaternionFromTransformArray(transform);
            }
            return undefined;
        };
        let orientationFromLookAt = ()=>{
            var lookFrom = cameraPosition;
            // there are two mechanisms to determine what the 
            // camera should be looking at
            // each of the atLocFrom will return either a Vector3
            // or an undefined type
            let atLocFromAnno = ()=>{
                let lookedAtAnno = this.scene.getAnnotationById(camera.LookAt?.id);
                return lookedAtAnno?.LookAtLocation;
            };
            let atLocFromPoint = ()=>{
                if (!camera.LookAt?.isPointSelector) return undefined;
                return camera.LookAt?.Location;
            };
            let lookAt = atLocFromAnno() ?? atLocFromPoint();
            if (!lookAt) return undefined;
            let direction = lookAt.clone().sub(lookFrom).normalize();
            let euler = $5N2AT.cameraRelativeRotation(direction);
            return new (0, $3uWBl.Quaternion)().setFromEuler(euler);
        };
        let quat = orientationFromTransformArray() ?? orientationFromLookAt();
        console.log("camera orientation " + quat);
        // centerFromXXXX returns a Vector3 or undefined ; a position intended to
        // be the center of rotation of an X3D Viewpoint
        let centerFromTransformArray = ()=>{
            // at this point of development we have no way of 
            // determining a center of rotation just from the camera transform
            return null;
        };
        let centerFromLookAt = ()=>{
            // there are two mechanisms to determine what the 
            // camera should be looking at
            // each of the atLocFrom will return either a Vector3
            // or an undefined type
            let atLocFromAnno = ()=>{
                try {
                    var lookedAtAnnoId = camera.LookAt?.id;
                    let lookedAtAnno = lookedAtAnnoId ? this.scene.getAnnotationById(lookedAtAnnoId) : null;
                    return lookedAtAnno?.LookAtLocation;
                } catch (err) {
                    return null;
                }
            };
            let atLocFromPoint = ()=>{
                try {
                    if (!camera?.LookAt?.isPointSelector) return null;
                    return camera?.LookAt?.Location ?? null;
                } catch (err) {
                    return null;
                }
            };
            return atLocFromAnno() ?? atLocFromPoint();
        };
        var center = centerFromLookAt();
        console.log("camera center " + center);
        let axisAngle = (0, $1ca9575c2d306713$export$5ebc3ab7500e7450).axisAngleFromQuaternion(quat);
        let attrSFRotation = (0, $f1cf6ebb7e4f40db$export$a0c9861d287ed39).makeSFRotation(axisAngle);
        console.log("evaluated SFRotation " + attrSFRotation);
        let viewpointProxyNode = {};
        if (camera.isPerspectiveCamera) {
            viewpointProxyNode.x3dnode = $09c84f25631aecf7$var$manifestViewer.iiif_perspective_viewpoint;
            viewpointProxyNode.fields = {
                "fieldOfView": (0, $3uWBl.MathUtils).degToRad(camera.FieldOfView)
            };
        } else if (camera.isOrthographicCamera) {
            viewpointProxyNode.x3dnode = $09c84f25631aecf7$var$manifestViewer.iiif_orthographic_viewpoint;
            var half_height = camera.ViewHeight;
            viewpointProxyNode.fields = {
                "fieldOfView": [
                    -half_height,
                    -half_height,
                    +half_height,
                    +half_height
                ].join(" ")
            };
        } else {
            console.warn("unrecognized camera type");
            return;
        }
        viewpointProxyNode.fields["orientation"] = attrSFRotation;
        viewpointProxyNode.fields["position"] = (0, $f1cf6ebb7e4f40db$export$a0c9861d287ed39).makeSFVec3f(cameraPosition);
        if (center) viewpointProxyNode.fields["centerOfRotation"] = (0, $f1cf6ebb7e4f40db$export$a0c9861d287ed39).makeSFVec3f(center);
        viewpointProxyNode.fields["description"] = label;
        console.log("loaded proxy camera: " + JSON.stringify(viewpointProxyNode.fields));
        this.cameras.push(viewpointProxyNode);
    }
    addTextualBody(bodyObj, targetObj, label = null) {
        if (bodyObj.base.isTextualBody) {
            console.log("textual body: " + bodyObj.base.Value);
            this.text_annotations.push(bodyObj.base.Value);
        } else console.warn("unrecognized text resource");
    }
    /*
   * @param iiiftranform : instance of manifesto.Transform class
   * returns: The equivalent X3D node in the form of a DOMElement with tag "transform"
   */ IIIFTransformToX3DTransform(iiiftrans) {
        var retVal = document.createElement("transform");
        if (iiiftrans.isTranslateTransform) {
            var tdata = iiiftrans.getTranslation();
            retVal.setAttribute("translation", (0, $f1cf6ebb7e4f40db$export$a0c9861d287ed39).makeSFVec3f(tdata));
        } else if (iiiftrans.isScaleTransform) {
            var sdata = iiiftrans.getScale();
            retVal.setAttribute("scale", (0, $f1cf6ebb7e4f40db$export$a0c9861d287ed39).makeSFVec3f(sdata));
        } else if (iiiftrans.isRotateTransform) {
            var quat = (0, $1ca9575c2d306713$export$5ebc3ab7500e7450).quaternionFromRotateTransform(iiiftrans);
            let axis_angle = (0, $1ca9575c2d306713$export$5ebc3ab7500e7450).axisAngleFromQuaternion(quat);
            retVal.setAttribute("rotation", (0, $f1cf6ebb7e4f40db$export$a0c9861d287ed39).makeSFRotation(axis_angle));
        } else console.log("error: unknown transform type");
        return retVal;
    }
    IIIFPointSelectorToX3dTransform(selector) {
        var retVal = document.createElement("transform");
        if (selector.isPointSelector) {
            let loc = selector.Location;
            retVal.setAttribute("translation", (0, $f1cf6ebb7e4f40db$export$a0c9861d287ed39).makeSFVec3f(loc));
        }
        return retVal;
    }
}


//# sourceMappingURL=iiif-x3dom-demo.478d27fb.js.map
